// The track page's main script (sections/haki-track-order.liquid), moved out
// of the section on 2026-09-29: the section had reached 222.6 KB of Shopify's
// 256 KB per-file cap, past which the GitHub sync silently stops updating the
// file (see scripts/check_template_sizes.py).
//
// The section still owns everything Liquid: it prints its settings as JSON in
// #htrk-cfg-<id> (read here as C) and pushes its section id onto
// window.HakiTrackQueue; every 'htrk-' + S + '__…' id and class below is built
// from that id. Two sections can share a page (the track page and the order
// page's embedded pop-up), so each runs in its own closure. ES5 only
// (Instagram in-app browser). Generated from the inline script by a one-off
// converter; edit this file directly from now on.
(function () {
  // ---- POP-UP KEYBOARD HELPERS, shared by both pop-ups in this file --------
  // (a11y: PR #347 trapped Tab in the order page's returns pop-up; the track
  // page's own pop-up, flowPop, now uses the same code.) Kept free of S and of
  // the page so tests/account-track-a11y.test.js can run them directly.
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function onScreen(el) {
    if (!el || el.disabled) return false;
    if (el.closest && el.closest('[hidden]')) return false;
    if (!el.getClientRects || !el.getClientRects().length) return false;
    return window.getComputedStyle(el).visibility !== 'hidden';
  }
  // Read at each key press, not once on open: both pop-ups open on a loader
  // or a first step and are re-painted afterwards, so a list taken on open
  // (global.js trapFocus) would go stale.
  function tabbablesIn(box) {
    var all = box.querySelectorAll(FOCUSABLE), out = [];
    for (var i = 0; i < all.length; i++) if (onScreen(all[i])) out.push(all[i]);
    return out;
  }
  // Tab / Shift+Tab cycle inside box.
  function trapTab(e, box) {
    if (e.key !== 'Tab') return;
    var els = tabbablesIn(box);
    if (!els.length) { e.preventDefault(); return; }
    var first = els[0], last = els[els.length - 1], a = document.activeElement;
    if (!box.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && (a === first || a === box)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  // WHERE FOCUS GOES WHEN A POP-UP CLOSES. The element that opened it, while
  // it is still on the page. When there is none (opened from a deep link,
  // /pages/account?order=...&do=return, so focus was on <body>; or the opener
  // was re-rendered away) focus used to fall to <body> and a keyboard user
  // started over from the top of the page. Then: the first of `sels` that is
  // on screen (the page's own button for the same action, then the order
  // heading; a heading gets tabindex=-1 so it can take focus).
  function focusBackTarget(opener, root, sels) {
    var attached = !!opener && (opener.isConnected !== undefined ? opener.isConnected : document.documentElement.contains(opener));
    if (attached && opener !== document.body && opener !== document.documentElement && onScreen(opener)) return opener;
    for (var i = 0; root && i < sels.length; i++) {
      var el = root.querySelector(sels[i]);
      if (!el || !onScreen(el)) continue;
      if (el.tabIndex < 0 && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      return el;
    }
    return null;
  }
  function focusQuietly(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  // ---- FINAL-SALE RETURN REASONS (plm #1674) --------------------------------
  // An item PLM marks finalSale (pre-order, made-to-order, mystery) can only
  // come back damaged or as the wrong item, inside 7 days. PLM sends the allowed
  // codes (finalSaleReasons) and one line to show (finalSaleHint); an older PLM
  // sends neither and never marks an item finalSale, so the fallback list only
  // matters if the flag arrives without the list. PLM's `set` refuses any other
  // reason with a 400 sentence either way. Kept free of S and of the page so
  // tests/track-final-sale-reasons.test.js runs them directly.
  var FINAL_SALE_FALLBACK = ['DEFECTIVE', 'WRONG_ITEM'];
  function finalSaleAllows(body, code) {
    var f = body && Array.isArray(body.finalSaleReasons) && body.finalSaleReasons.length ? body.finalSaleReasons : FINAL_SALE_FALLBACK;
    for (var i = 0; i < f.length; i++) if (f[i] === code) return true;
    return false;
  }
  // The reasons one item may take: all of `reasons`, or the final-sale subset.
  function reasonsForItem(body, item, reasons) {
    if (!item || !item.finalSale) return reasons;
    var out = [];
    for (var i = 0; i < reasons.length; i++) if (finalSaleAllows(body, reasons[i].code)) out.push(reasons[i]);
    return out;
  }
  // Old orders' title snapshots carry the catalogue's "[PREORDER] " prefix
  // (CX review 2026-10-07). Strip it wherever an item title is shown.
  function cleanTitle(v) { return String(v == null ? '' : v).replace(/^\s*\[\s*pre-?order\s*\]\s*/i, ''); }
  function escText(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  // The hint line under a final-sale item, or '' (normal item / no hint sent).
  function finalSaleHintHtml(body, item, id, cls) {
    if (!item || !item.finalSale) return '';
    var t = body && typeof body.finalSaleHint === 'string' ? body.finalSaleHint : '';
    if (!t) return '';
    return '<p class="' + escText(cls) + '" id="' + escText(id) + '">' + escText(t) + '</p>';
  }
  // ---------------------------------------------------------------------------
  // ---- PICKER (button + listbox) MARKUP AND KEYBOARD -------------------------
  // The reason / size / qty pickers: a button that opens a role=listbox of
  // role=option buttons, styled like the product page's size picker. a11y
  // review of #426:
  //  - A closed list is max-height 0 / opacity 0, so it must also leave the
  //    Tab order and the accessibility tree (inert + aria-hidden, options
  //    tabindex=-1). Before, Tab walked through up to 9 invisible options
  //    (WCAG 2.4.7 / 2.4.11).
  //  - An open list is one Tab stop (roving tabindex); Up/Down/Home/End move
  //    between options, as the APG listbox pattern expects. Escape closes and
  //    returns focus to the button (unchanged).
  //  - The role sits on the focusable <button> itself (the <li> is role=none),
  //    so a focused option is read as "option, n of m", not as a bare button
  //    hidden inside an option's presentational children.
  //  - The visible field label is part of the button's name (1.3.1):
  //    aria-labelledby="<label id> <button id>" reads "Reason, Choose a reason".
  // Kept free of the page so tests/track-picker-a11y.test.js runs them.
  function ddArrow(S) {
    return '<svg class="htrk-' + S + '__dd-arrow" width="14" height="14" viewBox="0 0 22 22" fill="none" aria-hidden="true">' +
      '<path d="M5 8.5 11 14.5 17 8.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function ddMarkup(S, id, opts, placeholder, value, labelId) {
    var current = null;
    for (var i = 0; i < opts.length; i++) if (opts[i].value === value && !opts[i].disabled) current = opts[i];
    var home = current;
    for (var f = 0; !home && f < opts.length; f++) if (!opts[f].disabled) home = opts[f];
    var h = '<div class="htrk-' + S + '__dd" id="' + id + '-dd">';
    h += '<input type="hidden" id="' + id + '" value="' + escText(current ? current.value : '') + '">';
    h += '<button type="button" class="htrk-' + S + '__dd-label' + (current ? '' : ' is-placeholder') + '" id="' + id + '-btn"' +
         (labelId ? ' aria-labelledby="' + labelId + ' ' + id + '-btn"' : '') +
         ' aria-haspopup="listbox" aria-expanded="false" aria-controls="' + id + '-list">' +
         '<span>' + escText(current ? current.label : placeholder) + '</span>' + ddArrow(S) + '</button>';
    // Closed on first paint: out of the Tab order and the accessibility tree.
    h += '<ul class="htrk-' + S + '__dd-list" id="' + id + '-list" role="listbox"' +
         (labelId ? ' aria-labelledby="' + labelId + '"' : '') + ' aria-hidden="true" inert>';
    for (var j = 0; j < opts.length; j++) {
      var o = opts[j];
      h += '<li role="none" data-value="' + escText(o.value) + '">' +
           '<button type="button" role="option" class="htrk-' + S + '__dd-opt" tabindex="-1"' +
           ' aria-selected="' + (current === o ? 'true' : 'false') + '"' +
           (o.disabled ? ' aria-disabled="true" disabled' : '') + '>' +
           escText(o.label) + (o.disabled && o.note ? '<small>' + escText(o.note) + '</small>' : '') + '</button></li>';
    }
    h += '</ul></div>';
    return h;
  }
  function ddOptions(list) { return list ? list.querySelectorAll('[role="option"]') : []; }
  function ddEnabled(o) { return !!o && !o.disabled && o.getAttribute('aria-disabled') !== 'true'; }
  // The option an open list starts on: the selected one, else the first usable.
  function ddHome(list) {
    var opts = ddOptions(list), first = null;
    for (var i = 0; i < opts.length; i++) {
      if (!ddEnabled(opts[i])) continue;
      if (opts[i].getAttribute('aria-selected') === 'true') return opts[i];
      if (!first) first = opts[i];
    }
    return first;
  }
  // Open: visible to assistive tech, one Tab stop on the home option.
  // Closed: inert + aria-hidden, every option tabindex=-1.
  function ddSetOpen(list, open) {
    if (!list) return null;
    if (open) { list.removeAttribute('inert'); list.removeAttribute('aria-hidden'); }
    else { list.setAttribute('inert', ''); list.setAttribute('aria-hidden', 'true'); }
    var home = open ? ddHome(list) : null;
    var opts = ddOptions(list);
    for (var i = 0; i < opts.length; i++) opts[i].setAttribute('tabindex', opts[i] === home ? '0' : '-1');
    return home;
  }
  // Where an arrow / Home / End key goes from `cur` (disabled options are
  // skipped, no wrap, as in the APG listbox). null for any other key.
  function ddStep(list, cur, key) {
    var opts = ddOptions(list), en = [];
    for (var i = 0; i < opts.length; i++) if (ddEnabled(opts[i])) en.push(opts[i]);
    if (!en.length) return null;
    var at = -1;
    for (var k = 0; k < en.length; k++) if (en[k] === cur) at = k;
    if (key === 'Home') return en[0];
    if (key === 'End') return en[en.length - 1];
    if (key === 'ArrowDown') return at < 0 ? en[0] : en[Math.min(at + 1, en.length - 1)];
    if (key === 'ArrowUp') return at < 0 ? en[en.length - 1] : en[Math.max(at - 1, 0)];
    return null;
  }
  // Move the single Tab stop to `to` and focus it.
  function ddRove(list, to) {
    if (!to) return;
    var opts = ddOptions(list);
    for (var i = 0; i < opts.length; i++) opts[i].setAttribute('tabindex', opts[i] === to ? '0' : '-1');
    to.focus();
  }
  // A failed send re-enables the form, but its button was disabled while busy,
  // so focus had already fallen to <body> (2.4.3). Then it goes to the error
  // line (role=alert, made focusable with tabindex=-1): it is read, and the
  // next Tab is the form's own button again. Focus the shopper has since put
  // on another control is left alone.
  function focusError(errEl, doc) {
    if (!errEl || !errEl.textContent) return false;
    var a = doc.activeElement;
    if (a && a !== doc.body && a !== doc.documentElement && !a.disabled && a.isConnected !== false) return false;
    errEl.setAttribute('tabindex', '-1');
    errEl.focus();
    return true;
  }
  function run(S) {
    var C = {};
    try { C = JSON.parse(document.getElementById('htrk-cfg-' + S).textContent) || {}; } catch (e) { C = {}; }

  (function () {
    var form = document.getElementById('htrk-form-' + S + '');
    if (!form) return;
    var grid = document.getElementById('htrk-grid-' + S + '');
    var out = document.getElementById('htrk-out-' + S + '');
    var btn = document.getElementById('htrk-submit-' + S + '');
    var orderEl = document.getElementById('htrk-order-' + S + '');
    var emailEl = document.getElementById('htrk-email-' + S + '');
    var API = C.api_json;
    // A SIGNED-IN member arriving from their account's "Track your order" link
    // (/pages/track?order=HS…) gets their own email filled in here, so the link
    // never has to carry an email address (2026-09-25). Guests: empty, as before.
    var MEMBER_EMAIL = C.customer_email_default_json;
    var BUSY = C.button_busy;
    var IDLE = btn.textContent;

    // The address endpoint lives beside the lookup endpoint: /track/address.
    // Derive it from the configured lookup URL so a merchant who repoints
    // api_url repoints both.
    var ADDR_API = API.replace(/\/track\/?$/, '/track/address');
    if (ADDR_API === API) ADDR_API = API.replace(/\/+$/, '') + '/address';
    // The returns endpoint lives beside them: /track/return. Same credential,
    // same derivation, same silent-degrade rules as the address editor.
    var RET_API = API.replace(/\/track\/?$/, '/track/return');
    if (RET_API === API) RET_API = API.replace(/\/+$/, '') + '/return';
    // One photo per call for a damaged / wrong-item return (PLM 1005).
    var PHOTO_API = RET_API.replace(/\/+$/, '') + '/photo';
    // Emailed confirmation codes for GUEST changes (PLM /track/verify), and the
    // signed-in member's shortcut (App Proxy /apps/rewards/track-pass).
    var VERIFY_API = API.replace(/\/track\/?$/, '/track/verify');
    if (VERIFY_API === API) VERIFY_API = API.replace(/\/+$/, '') + '/verify';
    var PASS_API = '/apps/rewards/track-pass';

    // Every sentence a shopper can read comes from the schema, so the merchant
    // edits copy in the theme editor — same rule as the rest of this section.
    var T = {
      shipSection: C.results_shipping_heading,
      itemsSection: C.results_items_heading,
      another: C.another_label,
      heading: C.addr_heading,
      change: C.addr_change_label,
      first: C.addr_label_first,
      last: C.addr_label_last,
      address1: C.addr_label_address1,
      address2: C.addr_label_address2,
      city: C.addr_label_city,
      province: C.addr_label_province,
      zip: C.addr_label_zip,
      phone: C.addr_label_phone,
      country: C.addr_label_country,
      save: C.addr_save_label,
      saving: C.addr_save_busy,
      cancel: C.addr_cancel_label,
      currentHead: C.current_order_title,
      ocCancel: C.order_cancel_label,
      updated: C.addr_updated_text,
      required: C.addr_required_error,
      // Richtext (they carry their own <p> and links); schema defaults apply.
      packedHtml: C.addr_packed_text,
      countryNoteHtml: C.addr_country_note,
      // Return / exchange flows (PLM /api/track/return).
      // The heading names the flow: "Return" or "Exchange". There is no
      // combined returns-and-exchanges heading anywhere (operator, 2026-09-28).
      retHeadReturn: 'Return',
      retHeadExchange: 'Exchange',
      retReason: C.ret_reason_label,
      retChooseReason: C.ret_choose_reason,
      retWant: C.ret_want_label,
      // [fee] is replaced with the return-label fee PLM reports (e.g. "$8"),
      // so the copy and the charge cannot drift.
      //
      // SQUARE BRACKETS, NOT BRACES, AND THAT IS LOAD-BEARING. Shopify's GitHub
      // integration validates every Liquid output tag before writing the file,
      // and a literal opening brace inside one makes it stop scanning for the
      // closing delimiter. It reports "Variable ... was not properly terminated
      // with regexp" and truncates its own quote at that brace, which is the
      // tell.
      //
      // The file then fails to sync WHILE THE REST OF THE THEME SYNCS FINE, so
      // the live site silently keeps the last good copy of this one section and
      // nothing anywhere says so. That is exactly what happened from 2026-09-09
      // to 2026-09-23: two weeks of track-page work sat on main and never
      // reached a customer, including the whole free-gift step.
      //
      // So: no braces in the copy defaults below, and none in this comment
      // either — a doubled brace here would be parsed as a tag like any other.
      // tests/track-liquid-braces.test.js fails the build if one comes back.
      retRefund: C.ret_refund_label,
      retSwap: C.ret_swap_label,
      retCredit: C.ret_credit_label,
      retCreditDone: C.ret_credit_done_text,
      retFeeDone: C.ret_fee_done_text,
      retNote: C.ret_note_label,
      retSubmit: C.ret_submit_label,
      retBusy: C.ret_submit_busy,
      // Guest confirmation code (operator, 2026-09-28: "we need this active").
      vSending: 'Sending you a confirmation code…',
      vSent: 'To keep your order safe, we’ve emailed a 6-digit code to [to]. Enter it below to continue.',
      vLabel: 'Confirmation code',
      vConfirm: 'Confirm',
      vChecking: 'Checking…',
      vResend: 'Send a new code',
      vCancel: 'Cancel',
      vBadCode: 'Enter the 6-digit code from the email.',
      vCancelled: 'Enter the code we emailed you to finish.',
      vDown: 'We couldn’t send a code just now. Please try again in a moment.',
      retPick: C.ret_pick_error,
      retDoneLabel: C.ret_done_text,
      retDoneNoLabel: C.ret_done_nolabel_text,
      retDoneRequested: C.ret_done_requested_text,
      retExisting: C.ret_existing_label,
      // An exchange is filed as a Shopify return, but reads as what it is.
      exExisting: 'Exchange',
      retTrackBack: C.ret_track_back_label,
      retFinalSale: C.ret_final_sale_text,
      // No number here on purpose: the return window is 7 days, or 14 / 30 for
      // loyalty tiers (plm lib/returns/tier.ts). The server has already decided
      // whether this item is inside THEIR window; the tag only says it is not.
      retLate: C.ret_late_text,
      retKeptGift: C.ret_kept_gift_text,
      retGiftWarn: C.ret_gift_warn,
      retGiftSendBack: C.ret_gift_send_back,
      retGiftKeep: C.ret_gift_keep,
      retGiftKeepNoAmount: C.ret_gift_keep_no_amount,
      retGiftCredit: C.ret_gift_credit,
      // Step-by-step Return / Exchange (operator, 2026-09-26). The exchange
      // disclaimer is the operator's own wording. No braces in these defaults
      // (see the [fee] comment above).
      retStartReturn: C.ret_start_return,
      retStartExchange: C.ret_start_exchange,
      stepOf: 'Step [n] of [total]',
      next: 'Next',
      back: 'Back',
      exStep1: 'What would you like to exchange?',
      exStep2: 'What would you like instead?',
      exStep3: 'Review your exchange',
      exStart: C.ex_start_label,
      exComplete: C.ex_complete_label,
      exYouAre: 'You are exchanging the following items:',
      exDisclaimer: C.ex_disclaimer,
      exFree: C.ex_free_text,
      exFeeDone: 'You’ll receive a [fee] invoice for the return label by email. Shipping your new item is on us.',
      exNoStock: 'out of stock in every size and colour',
      // Nothing offered at all (not a stock problem): e.g. a one-size hat
      // before PLM offered like-for-like replacements. Never call it sold out.
      exNoOptions: 'can’t be exchanged online - contact us',
      exNone: C.ex_none_text,
      // An exchange can be the same item again (damaged / wrong one, hats
      // included), another size, or another colour (operator, 2026-09-28).
      newSize: 'Exchange for',
      chooseSize: 'Choose an option',
      // The like-for-like option reads as the product itself (operator,
      // 2026-09-28: "use the product title, with variant if needed"). In the
      // review, where the title is already shown, it's just "replacement".
      swapReplacement: 'replacement',
      currentSize: 'You have size [size]',
      inStock: 'In stock',
      outOfStock: 'Out of stock',
      retStep1: 'What would you like to return?',
      retStep2: 'Refund or store credit?',
      retStep3: 'Review your return',
      retComplete: C.ret_complete_label,
      retYouAre: 'You are returning the following items:',
      optCredit: C.ret_opt_credit,
      // The cost split, hinted on the choice itself (operator, 2026-09-28).
      optCreditHint: C.ret_opt_credit_hint,
      optRefundHint: C.ret_opt_refund_hint,
      optRefundHintNoFee: '(return-label fee applies)',
      // Step 2 is ONLY the money choice; shipping is its own step (operator,
      // 2026-09-28). Both lines say when the money lands.
      optCreditSub: C.ret_opt_credit_sub,
      // With the amount (operator, 2026-09-28: "tell them how much store credit
      // they'll receive"). [amount] = price paid after discounts, plus tax,
      // from PLM; the plain lines above are used when a price is missing.
      optCreditSubAmt: 'Your [amount] credit is added to your account as soon as we receive your return.',
      retSumCreditAmt: 'You’ll receive [amount] in store credit for these items, and return shipping is free.',
      // Damaged / wrong item taken as store credit: +[bonus] on top, paid with
      // the credit (PLM creditBonus; 0 = off). Operator, 2026-09-28.
      optRefundHintFree: '(free return shipping)',
      optCreditHintBonus: '(free return shipping + [bonus] bonus)',
      optCreditHintBonusOnly: '(+ [bonus] bonus)',
      optCreditSubAmtBonus: 'Your [amount] credit plus a [bonus] bonus is added to your account as soon as we receive your return.',
      optCreditSubBonus: 'Your credit plus a [bonus] bonus is added to your account as soon as we receive your return.',
      retSumCreditAmtBonus: 'You’ll receive [amount] in store credit plus a [bonus] bonus, and return shipping is free.',
      retSumCreditBonus: 'You’ll receive store credit for these items plus a [bonus] bonus, and return shipping is free.',
      optRefund: C.ret_opt_refund,
      optRefundSub: C.ret_opt_refund_sub,
      retShipTitle: C.ret_ship_title,
      // "A"/"An" before [fee] is fixed up to match the amount ("An $8", "A $10").
      shipRefund: C.ret_ship_refund,
      shipRefundMixed: 'An [fee] return-label fee will be deducted from your refund (waived for items we confirm arrived damaged or wrong).',
      shipCredit: C.ret_ship_credit,
      retSumCredit: C.ret_sum_credit,
      retSumRefund: C.ret_sum_refund,
      retSumRefundFree: C.ret_sum_refund_free,
      // Under the reason, the moment an our-fault reason is picked (operator,
      // 2026-09-28: "Fee waived upon confirming X"). Staff check these first,
      // so the waiver is promised on confirmation, not outright.
      feeWaived: {
        DEFECTIVE: 'Return-label fee waived once we confirm the damage.',
        WRONG_ITEM: 'Return-label fee waived once we confirm it’s the wrong item.',
        NOT_AS_DESCRIBED: 'Return-label fee waived once we confirm it isn’t as described.'
      },
      feeWaivedOther: 'Return-label fee waived once we confirm the problem.',
      // Photos for a damaged / wrong item (operator, 2026-09-30: required, 1–3).
      photoLabel: { DEFECTIVE: 'Photos of the damage', WRONG_ITEM: 'Photos of the item you received' },
      photoLabelOther: 'Photos of the problem',
      photoReq: '(1–[max] required)',
      photoOpt: '(up to [max], optional)',
      photoAdd: 'Add photo',
      photoRemove: 'Remove photo',
      photoBusy: 'Uploading…',
      photoNeed: 'Please add at least one photo for each damaged or wrong item.',
      photoWait: 'Please wait for your photos to finish uploading.',
      photoFail: 'That photo didn’t upload. Please try again.',
      photoNotImage: 'Please choose a photo (JPEG, PNG, HEIC).',
      giftStepTitle: 'Your free [label]',
      giftStepIntro: 'Returning these takes your order under the [threshold] spend that earned your free [label]. Choose one:',
      giftSendTitle: 'Send it back',
      giftKeepTitle: 'Keep it',
      // A condition, never an amount: what is deducted depends on how it arrives.
      giftSendSub: 'Pack it with your return. If it comes back in its original condition, there is nothing to pay.',
      giftKeepSub: '[amount] (half its retail value) will be deducted from your refund.',
      giftKeepSubNoAmount: 'Half its retail value will be deducted from your refund.',
      giftCreditHint: 'Prefer to keep it for free? Go back and choose store credit.',
      giftSumSend: 'Please pack your free [label] with your return, in its original condition.',
      giftSumKeep: 'You’re keeping your free [label]: [keep]',
      retSoldOut: C.ret_sold_out_text,
      retAllSoldOut: C.ret_all_sold_out_text,
      // Richtext (own <p> and links); schema defaults apply.
      retNotUsHtml: C.ret_not_us_text,
      retAllExcludedHtml: C.ret_all_excluded_text
    };

    // The lookup that succeeded is the identity the address calls ride on. The
    // inputs cannot be trusted for this — a shopper can retype them without
    // searching again — so the pair is captured at the moment a lookup is
    // answered and only ever replaced by the next successful lookup.
    var lastOrder = '';
    var lastEmail = '';
    // HOW THE SHOPPER GOT HERE, reported to PLM with every call. 'link' when
    // both the order number and the email arrived on the URL and the lookup
    // fired on its own — only the order emails build such a link. 'typed' when
    // they filled the form, including an order-only link where they typed the
    // email. PLM counts these (nothing identifying travels with the flag) so
    // the "does anyone use the link in the email" question has an answer.
    var lastEntry = 'typed';
    var addrSeq = 0;       // stale-response guard for back-to-back lookups
    var addrCurrent = null; // the address as PLM last confirmed it
    // Embedded mode (see the comment above the section): which flow the order
    // view asked to open once its answer lands — 'address', 'return' or
    // 'exchange' — and the last returns answer, which renderRetForm needs.
    var EMBED = !!(grid && grid.parentNode && grid.parentNode.hasAttribute('data-htrk-embed'));
    var pendingFocus = null;
    // The flow the order page opened the pop-up for ('return' / 'exchange'),
    // kept until the next open: names the heading while it loads or errors.
    var askedMode = null;
    var flowCancelHook = null; // set by the embedded pop-up (see HakiTrack.open)
    var nameModalHook = null; // set by the embedded pop-up: keeps its accessible name current
    function focusDone(el) {
      pendingFocus = null;
      if (!el) return;
      try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { el.scrollIntoView(); }
    }
    var addrCountry = '';   // locked server-side; shown read-only

    function parseRegions(str) {
      var list = [];
      var parts = str.split('|');
      for (var i = 0; i < parts.length; i++) {
        var sp = parts[i].indexOf(' ');
        list.push([parts[i].slice(0, sp), parts[i].slice(sp + 1)]);
      }
      return list;
    }
    // Shopify province codes. Only the two countries with a fixed, well-known
    // region list get a <select>; everywhere else keeps a free text field.
    var REGIONS = {
      US: parseRegions('AL Alabama|AK Alaska|AZ Arizona|AR Arkansas|CA California|CO Colorado|CT Connecticut|DE Delaware|DC District of Columbia|FL Florida|GA Georgia|HI Hawaii|ID Idaho|IL Illinois|IN Indiana|IA Iowa|KS Kansas|KY Kentucky|LA Louisiana|ME Maine|MD Maryland|MA Massachusetts|MI Michigan|MN Minnesota|MS Mississippi|MO Missouri|MT Montana|NE Nebraska|NV Nevada|NH New Hampshire|NJ New Jersey|NM New Mexico|NY New York|NC North Carolina|ND North Dakota|OH Ohio|OK Oklahoma|OR Oregon|PA Pennsylvania|PR Puerto Rico|RI Rhode Island|SC South Carolina|SD South Dakota|TN Tennessee|TX Texas|UT Utah|VT Vermont|VA Virginia|WA Washington|WV West Virginia|WI Wisconsin|WY Wyoming'),
      CA: parseRegions('AB Alberta|BC British Columbia|MB Manitoba|NB New Brunswick|NL Newfoundland and Labrador|NT Northwest Territories|NS Nova Scotia|NU Nunavut|ON Ontario|PE Prince Edward Island|QC Quebec|SK Saskatchewan|YT Yukon')
    };
    var COUNTRY_NAMES = {
      US: 'United States', CA: 'Canada', GB: 'United Kingdom', AU: 'Australia',
      NZ: 'New Zealand', DE: 'Germany', FR: 'France', NL: 'Netherlands',
      IE: 'Ireland', SE: 'Sweden', NO: 'Norway', DK: 'Denmark', MX: 'Mexico',
      JP: 'Japan', SG: 'Singapore'
    };
    function countryName(code) { return COUNTRY_NAMES[code] || code || ''; }

    function trimStr(v) { return String(v == null ? '' : v).replace(/^\s+|\s+$/g, ''); }

    function esc(v) {
      return String(v == null ? '' : v)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    // SCROLL-AFFORDANCE SHADOWS. `can-down` on a scroller shows the bottom
    // fade that says "more below"; it comes off the moment the shopper
    // reaches the end. One updater reads whichever scrollers currently exist
    // (the items section is rebuilt on every lookup), so nothing holds a
    // reference to a discarded element.
    // FIT THE LOOKUP COLUMN (operator, 2026-09-29: "never needs a scrollbar
    // on desktop"). In the one-viewport results layout, shrink the column's
    // contents step by step (CSS zoom on its children, so text re-wraps at the
    // smaller size) until it fits the window height. Floor 0.7; below that
    // the column scrolls, with the fade. Anything else resets to full size.
    function fitFormCol() {
      var col = grid ? grid.querySelector('.htrk-' + S + '__col--form') : null;
      if (!col) return;
      var kids = col.children;
      var i;
      for (i = 0; i < kids.length; i++) kids[i].style.zoom = '';
      var root = grid.parentNode;
      if (!root || !root.classList.contains('is-fullvp')) return;
      if (!('zoom' in col.style)) return;
      var z = 1;
      while (col.scrollHeight - col.clientHeight > 1 && z > 0.72) {
        z = Math.round((z - 0.04) * 100) / 100;
        for (i = 0; i < kids.length; i++) kids[i].style.zoom = String(z);
      }
    }

    // The returns area's height in the one-screen layout: the room left
    // between its top and the section's bottom inset.
    function fitRetSec() {
      var sec = document.getElementById('htrk-retsec-' + S + '');
      if (!sec) return;
      var root = grid && grid.parentNode;
      var inPop = !!(sec.parentNode && sec.parentNode.classList && sec.parentNode.classList.contains('htrk-' + S + '__flowpop'));
      if (!root || inPop || !root.classList.contains('is-fullvp') || sec.hidden) { sec.style.maxHeight = ''; return; }
      var room = root.getBoundingClientRect().bottom - sec.getBoundingClientRect().top - 24;
      sec.style.maxHeight = Math.max(200, Math.floor(room)) + 'px';
    }

    function updateScrollShadows(e) {
      // Re-fit on render, resize and layout transitions; never on scroll.
      if (!e || e.type !== 'scroll') { fitFormCol(); fitRetSec(); }
      var els = [
        grid ? grid.querySelector('.htrk-' + S + '__col--result') : null,
        grid ? grid.querySelector('.htrk-' + S + '__col--form') : null,
        out.querySelector('.htrk-' + S + '__sec--items'),
        document.getElementById('htrk-retsec-' + S + '')
      ];
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (!el) continue;
        var more = el.scrollHeight - el.clientHeight - el.scrollTop > 2;
        if (more) el.classList.add('can-down');
        else el.classList.remove('can-down');
      }
    }
    window.addEventListener('resize', updateScrollShadows);
    // The grid animates its max-width when results arrive, so column widths —
    // and therefore how tall the wrapped text runs — are still moving at
    // render time. Re-read once the transition lands, or a column that only
    // TRANSIENTLY overflowed keeps a shadow it no longer needs. (Reduced
    // motion fires no transition, but then there is no transient state.)
    if (grid) grid.addEventListener('transitionend', updateScrollShadows);
    // The result column is static markup, so its listener binds once; the
    // items section is rebuilt per lookup and binds inside renderFound.
    var resultColEl = grid ? grid.querySelector('.htrk-' + S + '__col--result') : null;
    if (resultColEl) resultColEl.addEventListener('scroll', updateScrollShadows);
    var formColEl = grid ? grid.querySelector('.htrk-' + S + '__col--form') : null;
    if (formColEl) formColEl.addEventListener('scroll', updateScrollShadows);

    // Three-column mode is two classes that must never disagree: is-three on
    // the grid (the column layout) and is-fullvp on the section (the
    // one-viewport height clamp that lets the footer follow immediately).
    function setThreeCol(on) {
      if (!grid) return;
      var root = grid.parentNode;
      if (on) {
        grid.classList.add('is-three');
        if (root && root.classList) root.classList.add('is-fullvp');
      } else {
        grid.classList.remove('is-three');
        if (root && root.classList) root.classList.remove('is-fullvp');
      }
    }

    // A message is one short sentence; it never earns a second column.
    function message(text, isError) {
      if (grid) grid.classList.remove('is-split');
      if (grid) grid.classList.remove('is-result');
      if (!EMBED) outLive(true);
      if (grid) grid.classList.remove('is-linked');
      focusResult = false;
      // A failed lookup brings the form back, whoever arrived.
      if (grid) grid.classList.remove('is-member-view');
      setThreeCol(false);
      out.innerHTML = '<div class="htrk-' + S + '__msg' + (isError ? ' htrk-' + S + '__msg--err' : '') +
        '">' + esc(text) + '</div>';
      updateScrollShadows();
      reveal();
    }

    // Re-trigger the fade on every render, including a second lookup.
    // Guests only (the aside is rendered only for them): after a found
    // lookup, unhide the sign-in nudge. Phones get it below the results.
    function showNudge() {
      var nudge = document.getElementById('htrk-nudge-' + S + '');
      if (!nudge || EMBED) return;
      nudge.hidden = false;
      if (!nudge.__placed && grid && window.matchMedia) {
        nudge.__placed = true;
        var home = document.createComment('htrk-nudge');
        nudge.parentNode.insertBefore(home, nudge);
        var mq = window.matchMedia('(max-width: 749px)');
        var place = function () {
          if (mq.matches) { if (nudge.parentNode !== grid) grid.appendChild(nudge); }
          else if (home.parentNode && nudge.previousSibling !== home) home.parentNode.insertBefore(nudge, home.nextSibling);
        };
        place();
        if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
      }
    }
    function reveal() {
      out.classList.remove('is-in');
      /* force a reflow so the class removal actually restarts the transition */
      void out.offsetWidth;
      out.classList.add('is-in');
    }

    var SHIELD =
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M12 2.5 4.5 5.6v6.1c0 4.7 3.2 9.1 7.5 10.3 4.3-1.2 7.5-5.6 7.5-10.3V5.6L12 2.5Z" ' +
      'stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<path d="m8.8 12 2.2 2.2 4.2-4.4" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';

    // A date the server sends as 2026-10-31 must not be handed to the Date
    // constructor and re-read in local time — west of UTC that renders the day
    // before, and a delivery promise one day early is exactly the kind of small
    // lie this page exists to stop telling.
    var MONTHS = ['January','February','March','April','May','June','July',
                  'August','September','October','November','December'];
    function prettyDate(iso) {
      if (!iso) return '';
      var parts = String(iso).split('-');
      if (parts.length !== 3) return iso;
      var m = parseInt(parts[1], 10);
      var d = parseInt(parts[2], 10);
      if (!m || !d || m < 1 || m > 12) return iso;
      return d + ' ' + MONTHS[m - 1] + ' ' + parts[0];
    }

    // ESTIMATED DELIVERY (founder, 2026-10-05): customers want the day it
    // reaches THEIR door, not our ship date. PLM sends `delivery` (this order's
    // region) and `deliveryByRegion` (U.S. + international) next to `expected`,
    // which stays the ships-from-our-warehouse date. Short dates: "Nov 17 to 20",
    // "Nov 28 to Dec 2", the year only when it is not this year. "to", never a
    // dash. Older PLM sends neither field: the caller falls back to ships-by.
    var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    function ymd(iso) {
      var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
      if (!m) return null;
      var mo = Number(m[2]), d = Number(m[3]);
      if (mo < 1 || mo > 12 || d < 1 || d > 31) return null;
      return { y: Number(m[1]), m: mo, d: d };
    }
    function shortDate(iso) {
      var a = ymd(iso);
      if (!a) return '';
      return MON[a.m - 1] + ' ' + a.d + (a.y !== new Date().getFullYear() ? ', ' + a.y : '');
    }
    function dateRange(r) {
      var a = r && ymd(r.from), b = r && ymd(r.to);
      if (!a) return '';
      var now = new Date().getFullYear();
      if (!b || (a.y === b.y && a.m === b.m && a.d === b.d)) return shortDate(r.from);
      if (a.y === b.y) {
        var tail = a.y !== now ? ', ' + a.y : '';
        return MON[a.m - 1] + ' ' + a.d + ' to ' + (a.m === b.m ? '' : MON[b.m - 1] + ' ') + b.d + tail;
      }
      return shortDate(r.from) + ' to ' + shortDate(r.to);
    }
    // DATE PRECISION (founder, 2026-10-14): "we cannot promise concrete dates
    // or even concrete date ranges. the tracking page should ... get more and
    // more concrete as production + shipping on that item gets closer to
    // finishing." PLM sends `datePrecision` per line (missing = 'bucket'):
    //   bucket  "late December"     early/mid/late (days 1-10/11-20/21+) of the
    //                               END date + 7 days; the year only when it is
    //                               not this year. Never a day.
    //   week    "the week of Nov 9" the Monday of the padded END date's week.
    //   exact   "Nov 12"            days, as before (item is at our warehouse).
    // Same bucket rule as snippets/haki-month-bucket.liquid (product page, cart,
    // badges) and sections/haki-order.liquid; keep the three in step. `noPad`
    // is for a day that already happened.
    function poPad(iso, noPad) {
      var a = ymd(iso);
      if (!a) return null;
      var t = new Date(Date.UTC(a.y, a.m - 1, a.d + (noPad ? 0 : 7)));
      return { y: t.getUTCFullYear(), m: t.getUTCMonth() + 1, d: t.getUTCDate(), t: t };
    }
    function monthBucket(iso, noPad) {
      var b = poPad(iso, noPad);
      if (!b) return '';
      return (b.d <= 10 ? 'early ' : b.d <= 20 ? 'mid-' : 'late ') + MONTHS[b.m - 1] + (b.y !== new Date().getFullYear() ? ' ' + b.y : '');
    }
    function weekOf(iso, noPad) {
      var b = poPad(iso, noPad);
      if (!b) return '';
      var mon = new Date(b.t.getTime() - ((b.t.getUTCDay() + 6) % 7) * 864e5);
      var m = mon.getUTCMonth() + 1, d = mon.getUTCDate();
      return 'the week of ' + shortDate(mon.getUTCFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d);
    }
    function poPrec(l) {
      var p = l && l.datePrecision;
      return p === 'exact' || p === 'week' ? p : 'bucket';
    }
    // An order-level `datePrecision` (if PLM ever sends one) covers lines that have none.
    function poStampPrec(o) {
      if (!o || !o.datePrecision || !o.lines) return;
      for (var i = 0; i < o.lines.length; i++) if (o.lines[i] && o.lines[i].datePrecision == null) o.lines[i].datePrecision = o.datePrecision;
    }
    // One planned day (ships-by, landing day) at the line's precision.
    function poDay(l, iso, noPad) {
      var p = poPrec(l);
      return p === 'exact' ? shortDate(iso) : p === 'week' ? weekOf(iso, noPad) : monthBucket(iso, noPad);
    }
    // A window {from, to}: exact keeps the range; otherwise its END decides.
    function poWin(l, r) {
      if (!r || !r.from) return '';
      return poPrec(l) === 'exact' ? dateRange(r) : poDay(l, r.to || r.from);
    }
    // The little word before a day: "by Dec 22", "in late December", "the week of ...".
    function poPrep(l) { var p = poPrec(l); return p === 'exact' ? 'by ' : p === 'week' ? '' : 'in '; }
    function poByIn(l, iso, noPad) { var t = poDay(l, iso, noPad); return t ? poPrep(l) + t : ''; }
    // PLM-WRITTEN TEXT (review on #451): `headline`, `detail`, `expected.note`
    // and `arrival.text` are composed by PLM and can carry a day ("Nov 5") or
    // the freight mode. On a pre-order line below 'exact' precision such text
    // is not shown; the caller falls back to its own no-date words.
    var PO_DAYISH = /\b(January|February|March|April|May|June|July|August|September|October|November|December|Jan|Feb|Mar|Apr|Jun|Jul|Aug|Sept|Sep|Oct|Nov|Dec)\.? \d{1,2}(st|nd|rd|th)?\b|\b\d{1,2} (January|February|March|April|May|June|July|August|September|October|November|December|Jan|Feb|Mar|Apr|Jun|Jul|Aug|Sept|Sep|Oct|Nov|Dec)\b|\b(air|sea|ocean|boat|flying|flight|plane|vessel|crossing)\b/i;
    var PO_PRE_STAGES = { preorder_open: 1, with_factory: 1, in_production: 1, arriving_at_warehouse: 1 };
    function poIsPre(l) { return !!(l && (l.late || (l.expected && l.expected.date) || PO_PRE_STAGES[l.stage])); }
    function poClean(l, t) {
      t = String(t == null ? '' : t);
      if (!t || !poIsPre(l) || poPrec(l) === 'exact') return t;
      return PO_DAYISH.test(t) ? '' : t;
    }
    // PRE-ORDER DATE STORY (founder-approved CX design, 2026-10-06 07:05Z;
    // mocks: claude.ai/artifact/VVozExKgLLwyoWxMDPQuiL). Per pre-order line:
    // "Arriving <window>" first, then the promise ("Leaves our U.S. warehouse
    // by <ships-by>"), a was/now block when the date moved, "Running late"
    // when PLM says the ships-by passed, a "Why this date" line ONLY from data,
    // and a 6-step progress line from `stage`. Pre-order emails are OFF, so
    // nothing here promises an email. Same builder in assets/haki-track-order.js
    // and sections/haki-order.liquid; keep the two in step.
    //
    // PLM fields read (all optional, absent = render nothing for them):
    //   arrival {text, from, to, precision, region}   the door window, region-aware
    //   delivery {from, to, region} | null            this order's region range
    //   deliveryByRegion {us, international}          both ranges (country unknown)
    //   expected {date}                               ships-by (the promise)
    //   late {wasShipsBy}                             ships-by passed, not shipped
    //   changed {previousShipsBy, changedAt}          ships-by moved
    //   arrival.freight / freight ('sea' | 'air')     "Why this date" when `why` is absent (never shown)
    //   datePrecision 'bucket'|'week'|'exact'         how concrete dates may be (DATE PRECISION)
    //   why {stage, freight?, atWarehouse?}           "Why this date" (PLM #1645/#1647)
    //   stepDates {kind, <step>: {date, estimated}}   a date under each timeline step
    // A line with none of arrival / delivery / deliveryByRegion / late / changed
    // is an older PLM answer and keeps the previous rendering.
    var PO_STEPS = ['Ordered', 'Being made', 'On its way to us', 'At our warehouse', 'On its way to you', 'Delivered'];
    var PO_STEP_OF = { ordered: 0, preorder_open: 0, with_factory: 1, in_production: 1,
      arriving_at_warehouse: 2, preparing_parcel: 3, on_its_way: 4, delivered: 5 };
    var PO_FREIGHT = { sea: 'by sea', ocean: 'by sea', air: 'by air' };
    function poIsHeldGift(l) { return /^Ships with your /.test(String(l.headline || '')); }
    function poIsNew(l) {
      return !!(l.arrival || (l.delivery && l.delivery.from) || l.deliveryByRegion || l.late || l.changed);
    }
    // "Arriving ..." as HTML, or '' when PLM sent no window. Never a U.S. window
    // for a non-U.S. order: `arrival` and `delivery` are already this order's
    // region; only the country-unknown fallback names both, each labelled.
    // Keep "mid-December" whole: a break at its hyphen leaves "MID-" alone.
    function poNw(html, P) { return html.replace(/([^\s<>]+-[^\s<>]+)/g, '<span class="' + P + '__nw">$1</span>'); }
    // Today as YYYY-MM-DD in the shopper's own calendar, for "is this window
    // already over" checks (string compare is safe on this format).
    function poToday() {
      var d = new Date(), m = d.getMonth() + 1, day = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
    }
    // A window whose last day is before today is not an arrival estimate any
    // more (review on #355): skip it and use the next source.
    function poPast(r) {
      var end = r && String(r.to || r.from || '').slice(0, 10);
      return !!end && /^\d{4}-\d{2}-\d{2}$/.test(end) && end < poToday();
    }
    function poArrival(l) {
      var a = l.arrival && !poPast(l.arrival) ? l.arrival : null, r;
      var dl = l.delivery && !poPast(l.delivery) ? l.delivery : null;
      // PLM's own `text` only at 'exact' precision or with no window to reword:
      // otherwise the window is rebuilt from its END (DATE PRECISION above).
      // Bucket: "Arriving in early December"; week: "Arriving the week of Dec 14"; exact: days.
      var pre = poPrec(l) === 'bucket' ? 'in ' : '';
      if (a && a.text && poPrec(l) === 'exact') return 'Arriving ' + esc(a.text);
      if (a && a.from && (r = poWin(l, a))) return 'Arriving ' + pre + esc(r);
      if (dl && dl.from && (r = poWin(l, dl))) return 'Arriving ' + pre + esc(r);
      var by = l.deliveryByRegion || {};
      var us = poWin(l, by.us), intl = poWin(l, by.international);
      if (us) us = pre + us;
      if (intl) intl = pre + intl;
      // Both regions (country unknown): the PDP / cart wording (PR #409), one line each.
      if (us && intl) return 'Arriving to U.S. customers ' + esc(us) + '<br>Arriving for international customers ' + esc(intl);
      if (us) return 'Arriving to U.S. customers ' + esc(us);
      if (intl) return 'Arriving for international customers ' + esc(intl);
      return '';
    }
    // The sentence PLM's `why` facts support, in the mock's words (Tracking Page
    // End State, scenarios 3/5/7). Only facts PLM sent: the freight mode, the day
    // the batch lands (an estimate, today or later) and the ships-by date. With
    // no `why` (older PLM) this is the previous one-line sentence from freight.
    // NO FREIGHT WORDS (founder, 2026-10-14): never say air or sea, boats or
    // flying. The freight field still decides WHETHER this line shows (it is
    // the only fact older PLM sends), never what it says.
    function poWhyOld(l) {
      var f = (l.arrival && (l.arrival.freight || l.arrival.freightMode)) || l.freight || l.freightMode;
      var how = PO_FREIGHT[String(f || '').toLowerCase()];
      var at = PO_STEP_OF[l.stage];
      if (!how || at == null) return '';
      if (at <= 1) return 'Being made now, then it travels to our U.S. warehouse.';
      if (at === 2) return 'Finished and on its way to our U.S. warehouse.';
      return '';
    }
    // Today on the business calendar PLM dates are in (America/New_York), so
    // "is this plan already past" agrees with PLM's own rule.
    function poTodayET() {
      try {
        return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      } catch (e) { return poToday(); }
    }
    // The step a pre-order line is on. PLM keeps stage arriving_at_warehouse
    // after the goods are RECEIVED (plm status.ts preorderStage) and then sends
    // an actual (estimated:false) atWarehouse date: that line is at step 3.
    function poAt(l) {
      var at = PO_STEP_OF[l.stage];
      if (at !== 2) return at;
      var sd = l.stepDates, w = l.why;
      var got = l.goodsReceived === true ||
        !!(sd && sd.kind === 'preorder' && sd.atWarehouse && sd.atWarehouse.estimated === false && ymd(sd.atWarehouse.date)) ||
        !!(w && w.atWarehouse && w.atWarehouse.estimated === false && ymd(w.atWarehouse.date));
      return got ? 3 : at;
    }
    function poWhy(l) {
      var w = l.why, at = poAt(l);
      if (!w || typeof w !== 'object' || at == null || at > 3) return poWhyOld(l);
      // Days only at 'exact' precision (DATE PRECISION above).
      var by = l.expected && l.expected.date && ymd(l.expected.date) ? poByIn(l, l.expected.date) : '';
      var aw = w.atWarehouse;
      // Goods received, not packed yet (PLM keeps stage arriving_at_warehouse):
      // the batch is HERE. Say when it got here (a day that happened: no padding).
      if (at === 3) {
        if (!aw || aw.estimated !== false || !ymd(aw.date)) return '';
        return 'The batch reached our U.S. warehouse ' + (poPrec(l) === 'exact' ? 'on ' : poPrep(l)) + poDay(l, aw.date, true) + '.' +
               (by ? ' Yours leaves us ' + by + '.' : '');
      }
      var f = String(w.freight || '').toLowerCase();
      if (f !== 'sea' && f !== 'air') f = '';
      var land = aw && aw.estimated && ymd(aw.date) && !(String(aw.date).slice(0, 10) < poTodayET()) ? poDay(l, aw.date) : '';
      if (!f && !land) return poWhyOld(l);
      // No item name: "Your socks is" / "Your pants is" (review on #431). The
      // card already names the item. No freight mode (NO FREIGHT WORDS above).
      var s;
      if (at === 2) {
        s = 'Finished and on its way to our U.S. warehouse.';
      } else {
        s = (at === 0 ? 'Production starts when pre-orders close.' : 'Being made now.') +
            ' Then the batch travels to our U.S. warehouse.';
      }
      if (land) s += ' It reaches our U.S. warehouse ' + (poPrec(l) === 'exact' ? 'around ' : poPrep(l)) + land + (by ? ', and yours leaves us ' + by : '') + '.';
      return s;
    }

    // STEP DATES (PLM #1645/#1647: `stepDates`, one {date, estimated} or null
    // per step). Wording from the approved mock: a reached step shows its day
    // ("Oct 1"), the step it is on now says "Since Oct 3", a step not reached
    // yet shows "Est. late Oct" / "Est. Dec 3", the ships-by step "By Dec 7".
    // A date PLM inferred for a step already reached says "About" (the
    // estimated flag is honest, "Est." would read as a future plan). Ranges use
    // "to", never a dash. No `stepDates` = the Ordered date only, as before.
    var PO_KEYS = ['ordered', 'beingMade', 'toUs', 'atWarehouse', 'toYou', 'delivered'];
    var IS_STEPS = ['Ordered', 'Packed', 'On its way to you', 'Delivered'];
    var IS_KEYS = ['ordered', 'packed', 'toYou', 'delivered'];
    var IS_STEP_OF = { ordered: 0, preparing_parcel: 1, on_its_way: 2, delivered: 3 };
    var WDAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    // "early Oct", "mid-Nov", "late Dec" (days 1-10 / 11-20 / 21+, PLM's own split).
    function partDate(iso) {
      var a = ymd(iso);
      if (!a) return '';
      var p = a.d <= 10 ? 'early ' : a.d <= 20 ? 'mid-' : 'late ';
      return p + MON[a.m - 1] + (a.y !== new Date().getFullYear() ? ' ' + a.y : '');
    }
    // "Thu, Oct 8": a carrier's delivery estimate is a day the shopper plans around.
    function dayDate(iso) {
      var a = ymd(iso);
      if (!a) return '';
      return WDAY[new Date(Date.UTC(a.y, a.m - 1, a.d)).getUTCDay()] + ', ' + shortDate(iso);
    }
    // "Est." is read out as "Estimated" (a11y advisory on #431).
    function estWord(html, P) {
      return html.replace(/^Est\. /, '<span aria-hidden="true">Est.</span><span class="' + P + '__vh">Estimated</span> ');
    }
    // The progress list's name: item and size, so two sizes of one product differ.
    function stepsName(l) {
      var n = giftTitle(l.productTitle).name;
      return n + (n && l.variantTitle ? ', size ' + l.variantTitle : '');
    }
    function sdOk(sd) { return !!(sd && typeof sd === 'object' && ymd(sd.date)); }
    // One step's words. state: 'done' | 'now' | 'next'. `edge` = Ordered or
    // Delivered (a moment, never "Since"). `fmt` formats a future estimate.
    function stepWords(sd, state, edge, fmt) {
      if (!sdOk(sd)) return '';
      // A step not reached yet takes only a plan that is still ahead: an actual
      // date there contradicts the step (review on #431), a past plan is stale.
      if (state === 'next') return sd.estimated && !(String(sd.date).slice(0, 10) < poTodayET()) ? 'Est. ' + fmt(sd.date) : '';
      if (state === 'now' && !edge) return (sd.estimated ? 'Since about ' : 'Since ') + shortDate(sd.date);
      return (sd.estimated ? 'About ' : '') + shortDate(sd.date);
    }
    // The words under each of the six pre-order steps.
    function poStepTexts(l, at, late, orderedOn) {
      var sd = l.stepDates, out = [], i;
      if (!sd || sd.kind !== 'preorder') {
        // Older PLM: the order date under Ordered, nothing else (nothing guessed).
        for (i = 0; i < PO_STEPS.length; i++) out.push(i === 0 && shortDate(orderedOn) ? shortDate(orderedOn) : '');
        return out;
      }
      var arr = l.arrival && !late && !poPast(l.arrival) ? l.arrival : null;
      // While the batch is being made PLM only knows the month-part, so the
      // planned steps say "late Oct", not a day it cannot promise yet.
      // Below 'exact' precision a planned step never shows a day (DATE PRECISION),
      // and is padded ONCE, here, like every other planned date: PLM sends raw dates.
      var prec = poPrec(l);
      var fmt = prec === 'week' ? function (iso) { return weekOf(iso); }
        : prec === 'bucket' ? function (iso) { return monthBucket(iso); }
        : arr && arr.precision === 'month-part' ? partDate : shortDate;
      for (i = 0; i < PO_STEPS.length; i++) {
        var d = sd[PO_KEYS[i]], state = i < at ? 'done' : i === at ? 'now' : 'next';
        var t;
        // "On its way to you" not reached: the ships-by promise, from the SAME
        // field as the "Leaves our U.S. warehouse by" line, so the two always
        // agree; stepDates.toYou only when `expected` is missing.
        if (i === 4 && state === 'next') {
          var sb = !late && l.expected && ymd(l.expected.date) ? l.expected.date : '';
          if (!sb && sdOk(d) && d.estimated && !(String(d.date).slice(0, 10) < poTodayET())) sb = d.date;
          t = sb ? (prec === 'exact' ? 'By ' + shortDate(sb) : 'Est. ' + poDay(l, sb)) : '';
        } else t = stepWords(d, state, i === 0 || i === 5, fmt);
        if (!t && i === 0 && state !== 'next') t = shortDate(orderedOn);
        // Delivered not reached and no carrier estimate: the door window PLM sent.
        if (!t && i === 5 && state === 'next' && arr) {
          // PLM's own text only at exact precision (review on #451); below it the
          // window's end date, or nothing.
          var aw2 = prec === 'exact' || !arr.from ? '' : poWin(l, arr);
          if (aw2) t = 'Est. ' + aw2;
          else if (prec === 'exact' && arr.precision === 'month-part' && arr.text) t = 'Est. ' + String(arr.text).charAt(0).toLowerCase() + String(arr.text).slice(1);
          else if (prec === 'exact' && (arr.text || dateRange(arr))) t = 'Est. ' + (arr.text || dateRange(arr));
        }
        if (t && i === at && late) t += ', running late';
        out.push(t);
      }
      return out;
    }
    // The four in-stock steps (mock scenario 3), or null when PLM sent none.
    function isStepTexts(l, at) {
      var sd = l.stepDates;
      if (!sd || sd.kind !== 'in_stock') return null;
      var out = [];
      for (var i = 0; i < IS_STEPS.length; i++) {
        var state = i < at ? 'done' : i === at ? 'now' : 'next';
        out.push(stepWords(sd[IS_KEYS[i]], state, i === 0 || i === 3, i === 3 ? dayDate : shortDate));
      }
      return out;
    }
    // Everything below the product name for a pre-order line. P = class prefix,
    // T = the element for one line ('p' on the track page, 'span' where the
    // container only takes phrasing content). Returns '' for an old PLM answer.
    function poBlock(l, P, T, tone, orderedOn) {
      if (!poIsNew(l) || poIsHeldGift(l)) return '';
      var el = function (cls, inner) { return '<' + T + ' class="' + P + '__' + cls + '">' + inner + '</' + T + '>'; };
      var h = '';
      var late = !!l.late;
      // Was/now + refund ONLY when the date moved LATER (review on #355): an
      // earlier move is good news and keeps the normal layout. PLM sends
      // `changed` only for later moves, but the page does not rely on that.
      var prevSb = !late && l.changed && l.changed.previousShipsBy ? String(l.changed.previousShipsBy).slice(0, 10) : '';
      var nowSb = l.expected && l.expected.date ? String(l.expected.date).slice(0, 10) : '';
      var changed = !!(prevSb && nowSb && prevSb < nowSb);
      var arrive = late ? '' : poArrival(l);
      h += tone(late || changed ? 'stop' : 'wait', late ? 'Running late' : changed ? 'Running late &middot; new estimate' : 'Estimated delivery');
      if (arrive) h += el('arrive' + (/international customers/.test(arrive) && /U\.S\. customers/.test(arrive) ? ' ' + P + '__arrive--two' : ''), poNw(arrive, P));
      if (late) {
        if (poClean(l, l.detail)) h += ' ' + el('podet', esc(poClean(l, l.detail)));
        if (l.late.wasShipsBy) h += ' ' + el('was', 'Was: leaves our U.S. warehouse ' + esc(poByIn(l, l.late.wasShipsBy)));
      } else {
        // Month wording can make the old and new date read the same: then the
        // "Was" line would say nothing, so it is left out.
        var wasT = changed ? poByIn(l, l.changed.previousShipsBy) : '';
        if (changed && wasT !== poByIn(l, l.expected.date)) h += ' ' + el('was', 'Was: leaves our U.S. warehouse ' + esc(wasT));
        if (l.expected && l.expected.date && ymd(l.expected.date)) {
          h += ' ' + el('promise', (changed ? 'Now leaves' : 'Leaves') + ' our U.S. warehouse ' + poPrep(l) + '<b>' + esc(poDay(l, l.expected.date)) +
               '</b>. If that changes, we&rsquo;ll update it here.');
        }
        if (changed) h += ' ' + el('refund', 'Rather not wait? Ask us for a full refund anytime.');
        var why = poWhy(l);
        if (why) h += ' ' + el('why', '<b>Why this date:</b> ' + esc(why));
      }
      var at = poAt(l);
      if (at != null) h += ' ' + poSteps(at, late, P, stepsName(l), poStepTexts(l, at, late, orderedOn));
      return h;
    }
    // The progress line: an ordered list, the current step marked with
    // aria-current. Vertical by default; a wide card lays it out in a row.
    // Each list is named after its item, so several pre-orders on one page do
    // not read as identical "Order progress" lists (a11y review, #355).
    // `texts[i]` is the ready words under step i (poStepTexts / isStepTexts):
    // only dates PLM sent, never a guess. `names` defaults to the six
    // pre-order steps; the in-stock line passes its four.
    function poSteps(at, late, P, title, texts, names) {
      var N = names || PO_STEPS;
      var t = title;
      var h = '<ol class="' + P + '__steps"' + (N.length !== 6 ? ' style="--htrk-n:' + N.length + '"' : '') +
              ' aria-label="Order progress' + (t ? ': ' + esc(t) : '') + '">';
      for (var i = 0; i < N.length; i++) {
        var cls = i < at ? ' is-done' : i === at ? ' is-now' + (late ? ' is-late' : '') : '';
        h += '<li class="' + P + '__step' + cls + '"' + (i === at ? ' aria-current="step"' : '') + '>' +
             '<span class="' + P + '__sdot" aria-hidden="true"></span>' + N[i] +
             (texts && texts[i] ? '<span class="' + P + '__sdate"> ' + estWord(esc(texts[i]), P) + '</span>' : '') +
             (i < at ? '<span class="' + P + '__vh">, done</span>' : '') + '</li>';
      }
      return h + '</ol>';
    }

    // Confirmed status colors (founder, 2026-09-01). Every stage's dot AND
    // label take a color; nothing stays gray. Green = moving toward the door,
    // yellow = in the factory pipeline, red = needs a human. `blink: false`
    // is Delivered's solid light — the journey is over, nothing is "live".
    var LIGHTS = {
      ordered:               { tone: 'go',   blink: true },
      preorder_open:         { tone: 'wait', blink: true },
      with_factory:          { tone: 'wait', blink: true },
      in_production:         { tone: 'wait', blink: true },
      arriving_at_warehouse: { tone: 'wait', blink: true },
      preparing_parcel:      { tone: 'go',   blink: true },
      on_its_way:            { tone: 'go',   blink: true },
      delivered:             { tone: 'go',   blink: false }
    };

    // The PDP's stock light, verbatim: a blinking core inside a pulsing halo.
    var LIVE_SVG =
      '<svg viewBox="0 0 16 16" width="13" height="13">' +
      '<circle class="htrk-' + S + '__live-halo" cx="8" cy="8" r="5"></circle>' +
      '<circle class="htrk-' + S + '__live-core" cx="8" cy="8" r="3.2"></circle></svg>';

    // The status half of a card: the light + words (or the pre-order date
    // story), told by the line that leads the card, plus the parcel's tracking
    // link once. The items are listed under it by itemHtml.
    // `rv` = the result view (renderResult) only; the order-page pop-up never passes it.
    function statusHtml(line, orderedOn, tracking, rv) {
      var h = '';
      // Every known stage gets a colored light and a matching label. The
      // stale branch of stage 'ordered' ("Taking longer than it should")
      // shares its stage key with healthy "Getting ready", so the headline
      // is still the only way to tell them apart — but now it maps to RED,
      // the theme's own error color, instead of skipping the light. An
      // unknown future stage falls back to the old plain dot and uncolored
      // label rather than guessing a meaning.
      var light = LIGHTS[line.stage] || null;
      if (line.stage === 'ordered' && /longer/i.test(String(line.headline || ''))) {
        light = { tone: 'stop', blink: true };
      }
      var dot;
      var stageCls = '';
      if (light) {
        stageCls = ' htrk-' + S + '__stage--' + light.tone;
        dot = '<span class="htrk-' + S + '__live htrk-' + S + '__live--' + light.tone +
              (light.blink ? '' : ' htrk-' + S + '__live--still') +
              '" aria-hidden="true">' + LIVE_SVG + '</span>';
      } else {
        dot = '<span class="htrk-' + S + '__dot"></span>';
      }
      // A pre-order line in the new date story (see poBlock). The stage light
      // becomes the "Estimated delivery" / "Running late" label in the same
      // colors; PLM's stage words move into the progress line.
      var PS = 'htrk-' + S;
      var po = poBlock(line, PS, 'p', function (t, words) {
        var lt = { tone: t, blink: true };
        return '<p class="' + PS + '__stage ' + PS + '__stage--' + lt.tone + '"><span class="' + PS + '__live ' + PS + '__live--' + lt.tone +
               '" aria-hidden="true">' + LIVE_SVG + '</span>' + words + '</p>';
      }, orderedOn);
      if (po) return po;

      // An in-stock parcel the carrier is moving leads with its own "Arriving
      // Thu, Oct 8" (mock scenario 5), from the carrier's estimate PLM sends.
      var eta = !rv || poIsHeldGift(line) ? '' : inStockEta(line);
      var etaT = tracking || line.tracking;
      if (eta) {
        h += '<p class="htrk-' + S + '__stage' + stageCls + '">' + dot + 'Estimated delivery</p>';
        h += '<p class="htrk-' + S + '__arrive">Arriving ' + esc(dayDate(eta)) + '</p>';
        h += '<p class="htrk-' + S + '__detail">' + (etaT && etaT.carrier && !/^other$/i.test(String(etaT.carrier).trim())
          ? 'The date from ' + esc(etaT.carrier) + '. It updates as your parcel moves.'
          : 'The carrier&rsquo;s date. It updates as your parcel moves.') + '</p>';
      } else {
        // A pre-order headline with a day or a freight word in it: the stage name instead.
        h += '<p class="htrk-' + S + '__stage' + stageCls + '">' + dot + esc(poClean(line, line.headline) || PO_STEPS[PO_STEP_OF[line.stage]] || '') + '</p>';
        if (poClean(line, line.detail)) h += '<p class="htrk-' + S + '__detail">' + esc(poClean(line, line.detail)) + '</p>';
      }

      // Held gift: its pre-order (listed just above it) carries the dates.
      if (line.expected && line.expected.date && !poIsHeldGift(line)) {
        // Older PLM: no delivery fields. The ships-by date and its caveat as
        // separate paragraphs (a11y review, PR #355).
        h += '<p class="htrk-' + S + '__eta htrk-' + S + '__eta--date">Leaves our U.S. warehouse ' +
             (poPrec(line) === 'exact' ? 'by <b>' + esc(prettyDate(line.expected.date)) : poPrep(line) + '<b>' + esc(poDay(line, line.expected.date))) + '</b></p>';
        if (!line.expected.confirmed && poClean(line, line.expected.note)) {
          h += ' <p class="htrk-' + S + '__caveat">' + esc(poClean(line, line.expected.note)) + '</p>';
        }
      }

      // In-stock parcel: Ordered / Packed / On its way to you / Delivered, only
      // when PLM sent its step dates (older PLM: no timeline, as before). Before
      // the carrier link in reading order (a11y advisory on #431).
      var isAt = IS_STEP_OF[line.stage];
      var isTx = isAt != null && !poIsHeldGift(line) ? isStepTexts(line, isAt) : null;
      if (isTx) h += poSteps(isAt, false, 'htrk-' + S, stepsName(line), isTx, IS_STEPS);

      var t = tracking || line.tracking;
      if (t && t.number) {
        var carrier = carrierName(t.carrier);
        if (t.url) {
          h += '<a class="htrk-' + S + '__track" href="' + esc(t.url) +
               '" target="_blank" rel="noopener">Track with ' + carrier + ' &rarr;<span class="htrk-' + S + '__vh"> (opens in a new tab)</span></a>';
        } else {
          h += '<p class="htrk-' + S + '__eta">' + carrier + ' &middot; ' + esc(t.number) + '</p>';
        }
      }
      return h;
    }

    // The Shipping details section: protection badge (if any) plus the address
    // box the editor renders into later. It starts hidden unless the badge is
    // there, because the address answer arrives asynchronously and a heading
    // over nothing reads as broken.
    // GUEST "VIEWING" CARD (operator, 2026-09-29: the middle column felt empty
    // without shipping info). A signed-out visitor gets the same green card a
    // member sees on the left, at the top of the middle column, minus the
    // total ("we don't need order total there for guests"). Desktop only:
    // phones keep the plain "Order # · placed" line above the items.
    var GUEST_CARD = C.guest;
    function guestCardHtml(o) {
      if (!GUEST_CARD || EMBED || !o || !o.orderNumber) return '';
      var n = 0;
      for (var i = 0; i < (o.lines || []).length; i++) n += (o.lines[i].quantity || 1);
      var meta = [];
      if (o.orderedOn) meta.push('Placed ' + prettyDate(o.orderedOn));
      if (n) meta.push(n + (n === 1 ? ' item' : ' items'));
      return '<h2 class="htrk-' + S + '__sechead htrk-' + S + '__cardhead">' + esc(T.currentHead) + '</h2>' +
        '<div class="htrk-' + S + '__current-card htrk-' + S + '__guestcard">' +
        '<p class="htrk-' + S + '__current-label">' + esc(C.my_order_viewing) + '</p>' +
        '<div class="htrk-' + S + '__current-top"><p class="htrk-' + S + '__current-name">' + esc(o.orderNumber) + '</p></div>' +
        (meta.length ? '<p class="htrk-' + S + '__current-meta">' + esc(meta.join(' \u00b7 ')) + '</p>' : '') +
        '<div class="htrk-' + S + '__cardacts" hidden></div>' +
        '</div>';
    }

    // QUESTIONS (founder-approved mock, 2026-10-06): how pre-orders work (only
    // on an order with a pre-order in it) and how to reach us. Last in the
    // middle column. In the account page's pop-up (EMBED) only the pre-order
    // link, as one line at the top of the results: the pop-up hides the items
    // and, per flow, one of the two middle sections (review on #395).
    function questionsHtml(o) {
      var P = 'htrk-' + S, links = [];
      var pre = false, PRE = { preorder_open: 1, with_factory: 1, in_production: 1, arriving_at_warehouse: 1 };
      for (var i = 0; i < (o.lines || []).length; i++) if (PRE[o.lines[i].stage] || o.lines[i].late) pre = true;
      if (EMBED) {
        return pre && C.preorder_info_url
          ? '<p class="' + P + '__poinfo"><a href="' + esc(C.preorder_info_url) + '">' + esc(C.preorder_info_label || 'How pre-orders work') + '</a></p>'
          : '';
      }
      if (pre && C.preorder_info_url) links.push('<li><a href="' + esc(C.preorder_info_url) + '">' + esc(C.preorder_info_label || 'How pre-orders work') + '</a></li>');
      if (C.contact_url) links.push('<li><a href="' + esc(C.contact_url) + '">' + esc(C.contact_label || 'Contact us') + '</a></li>');
      if (!links.length) return '';
      return '<div class="' + P + '__qs"><h2 class="' + P + '__sechead">' + esc(C.questions_title || 'Questions') + '</h2>' +
             '<ul class="' + P + '__qlist" role="list">' + links.join('') + '</ul></div>';
    }

    // `rv` = the result view (renderResult): no guest card (the ORDER heading
    // names the order) and Questions is its own box further down the column.
    function shipSectionHtml(o, rv) {
      var card = rv ? '' : guestCardHtml(o);
      var prot = o.shippingProtection
        ? '<div class="htrk-' + S + '__prot">' + SHIELD + '<span>You have shipping protection</span></div>'
        : '';
      var qs = EMBED || rv ? '' : questionsHtml(o);
      return '<section class="htrk-' + S + '__sec htrk-' + S + '__sec--ship" id="htrk-ship-' + S + '"' +
             (prot || card || qs ? '' : ' hidden') + '>' +
             card +
             '<h2 class="htrk-' + S + '__sechead" id="htrk-shiphead-' + S + '">' + esc(T.shipSection) + '</h2>' +
             prot +
             '<div class="htrk-' + S + '__addr" id="htrk-addr-' + S + '"></div>' +
             qs +
             '</section>';
    }

    // Show the Shipping details section only while it holds something, and let
    // the grid follow: three columns with it, the plain two-column split
    // without. Called after every render into the address box.
    function syncShipVis() {
      var sec = document.getElementById('htrk-ship-' + S + '');
      if (!sec) {
        setThreeCol(false);
        return;
      }
      var box = addrBox();
      var hasAddr = !!(box && trimStr(box.innerHTML));
      var hasProt = !!sec.querySelector('.htrk-' + S + '__prot');
      // The guest card counts on desktop only; on phones it is hidden by CSS.
      var hasCard = !!sec.querySelector('.htrk-' + S + '__guestcard');
      var hasQs = !!sec.querySelector('.htrk-' + S + '__qs');
      var show = hasAddr || hasProt || hasCard || hasQs;
      sec.classList.toggle('has-guestcard', !!sec.querySelector('.htrk-' + S + '__guestcard'));
      sec.classList.toggle('has-shipinfo', hasAddr || hasProt);
      if (show) sec.removeAttribute('hidden');
      else sec.setAttribute('hidden', 'hidden');
      // The returns section shares the middle column and follows the same
      // rule: shown only while it holds something.
      var retSec = document.getElementById('htrk-retsec-' + S + '');
      var rb = retBox();
      var hasRet = !!(rb && trimStr(rb.innerHTML));
      if (retSec) {
        if (hasRet) retSec.removeAttribute('hidden');
        else retSec.setAttribute('hidden', 'hidden');
      }
      var mid = show || hasRet;
      var cols = document.getElementById('htrk-cols-' + S + '');
      if (cols) {
        cols.className = 'htrk-' + S + '__cols' + (mid ? ' has-ship' : '');
      }
      // Only the itemized layout ever widens to three columns.
      setThreeCol(!!(mid && cols && grid && grid.classList.contains('is-split')));
      // Layout mode changes what scrolls; re-read the affordance shadows.
      updateScrollShadows();
    }

    // ONE CARD PER SHIPMENT (founder-approved mock, 2026-10-06:
    // claude.ai/artifact/VVozExKgLLwyoWxMDPQuiL). An order reads as the parcels
    // it travels in: lines with the same tracking number shipped together and
    // are one card with one carrier link; in-stock lines not shipped yet are one
    // card; each pre-order is its own card per stage + ships-by date. A gift (or
    // an international in-stock line) that PLM holds for a pre-order carries that
    // pre-order's stage, `expected` and `late` (plm lib/track/status.ts
    // trackOrderLines), so the same key drops it into its pre-order's card.
    // Pure: no DOM, no S. tests/track-shipment-cards.test.js runs it as written.
    function shipmentCards(lines) {
      var PRE = { preorder_open: 1, with_factory: 1, in_production: 1, arriving_at_warehouse: 1 };
      var HELD = /^Ships with your /;
      var cards = [], byKey = {};
      for (var i = 0; i < (lines || []).length; i++) {
        var ln = lines[i], key, kind, num = ln.tracking && ln.tracking.number;
        var held = HELD.test(String(ln.headline || ''));
        if (ln.stage === 'cancelled') { key = 'x'; kind = 'other'; }
        else if (num) { key = 't|' + num; kind = 'parcel'; }
        else if (PRE[ln.stage] || ln.late || held) {
          // A pre-order whose ships-by moved (`changed`) carries its own Was/Now and
          // refund line, so it never shares a card with one that did not move: only
          // the lead's date story renders. Its held gift copies `changed` and follows.
          key = 'p|' + ln.stage + '|' + ((ln.expected && ln.expected.date) || (ln.late && ln.late.wasShipsBy) || '') +
                '|' + ((ln.changed && ln.changed.previousShipsBy) || '');
          kind = 'preorder';
        } else if (ln.stage === 'ordered' || ln.stage === 'preparing_parcel') { key = 'r|' + ln.stage + '|' + ln.headline; kind = 'ready'; }
        else { key = 'o|' + ln.stage; kind = 'other'; }
        var c = byKey[key];
        if (!c) {
          c = byKey[key] = { kind: kind, lines: [], lead: null, tracking: kind === 'parcel' ? ln.tracking : null,
                             date: (ln.expected && ln.expected.date) || (ln.late && ln.late.wasShipsBy) || '', seq: cards.length };
          cards.push(c);
        }
        c.lines.push(ln);
        // A held line never speaks for its card: the pre-order it waits for does.
        if (!c.lead || (HELD.test(String(c.lead.headline || '')) && !held)) c.lead = ln;
      }
      var RANK = { parcel: 0, ready: 1, preorder: 2, other: 3 };
      return cards.sort(function (a, b) {
        if (a.kind !== b.kind) return RANK[a.kind] - RANK[b.kind];
        if (a.kind === 'preorder' && a.date !== b.date) {
          if (!a.date) return 1;
          if (!b.date) return -1;
          return a.date < b.date ? -1 : 1;
        }
        return a.seq - b.seq;
      });
    }
    // The word for one card in the summary line ("1 delivered · 1 being made").
    // Words fit after a count ("2 on the way"); de-AI pass on #395.
    function cardWord(c) {
      var l = c.lead || {};
      if (l.late) return 'running late';
      if (l.stage === 'ordered' && /longer/i.test(String(l.headline || ''))) return 'taking longer';
      // Goods received, not packed yet (PLM keeps the stage): it is not at sea.
      var aw = l.stepDates && l.stepDates.atWarehouse;
      if (l.stage === 'arriving_at_warehouse' && (l.goodsReceived === true || (aw && aw.estimated === false))) return 'at our warehouse';
      return {
        delivered: 'delivered', on_its_way: 'on the way', preparing_parcel: 'being packed',
        returned_to_us: 'coming back to us', ordered: 'getting ready', preorder_open: 'waiting to be made',
        with_factory: 'being made', in_production: 'being made', arriving_at_warehouse: 'on the way to us',
        cancelled: 'cancelled'
      }[l.stage] || '';
    }
    // "2 parcels · 1 delivered · 1 being made". One card: "1 parcel · being made".
    // A cancelled card is not a parcel: it is neither counted nor numbered, and
    // an order that is only cancelled lines gets no summary.
    // `word`: the result view's PARCEL_WORD ("2 parcels"); the pop-up passes none.
    function cardsSummary(cards, word) {
      var w1 = String(word || 'parcel').toLowerCase();
      var live = [], words = [], count = {};
      for (var i = 0; i < cards.length; i++) if (!(cards[i].lead && cards[i].lead.stage === 'cancelled')) live.push(cards[i]);
      var n = live.length;
      if (!n) return '';
      for (var j = 0; j < n; j++) {
        var w = cardWord(live[j]);
        if (!w) continue;
        if (!count[w]) { count[w] = 0; words.push(w); }
        count[w]++;
      }
      var out = [n + ' ' + w1 + (n === 1 ? '' : 's')];
      for (var k = 0; k < words.length; k++) out.push(n === 1 ? words[k] : count[words[k]] + ' ' + words[k]);
      return out.join(' \u00b7 ');
    }
    // Each card's h3: "Shipment 1 of 2" counting live cards only ("Your parcel"
    // when there is one); a cancelled card is headed "Cancelled".
    // `word` names a card in the result view (PARCEL_WORD); the pop-up keeps "Shipment".
    function cardHeads(cards, word) {
      var n = 0, i, out = [], at = 0;
      for (i = 0; i < cards.length; i++) if (!(cards[i].lead && cards[i].lead.stage === 'cancelled')) n++;
      for (i = 0; i < cards.length; i++) {
        if (cards[i].lead && cards[i].lead.stage === 'cancelled') { out.push('Cancelled'); continue; }
        at++;
        out.push(n > 1 ? (word || 'Shipment') + ' ' + at + ' of ' + n : 'Your ' + (word ? String(word).toLowerCase() : 'parcel'));
      }
      return out;
    }
    // The small label beside the heading, from the stage the card's lead is in.
    // A tracking number alone is not "Shipped": PLM gives one to a packed,
    // labelled parcel the carrier has not scanned yet (review on #395).
    function cardKind(c) {
      if (c.kind === 'ready') return 'In stock';
      if (c.kind === 'preorder') return 'Pre-order';
      if (c.kind !== 'parcel') return '';
      var st = c.lead && c.lead.stage;
      if (st === 'on_its_way' || st === 'delivered') return 'Shipped';
      if (st === 'preparing_parcel') return 'Packed';
      if (st === 'returned_to_us') return 'Coming back to us';
      return '';
    }
    // PLM's `parcels` (sent when an order has more than one) minus the ones a
    // card already shows, with a line that counts exactly what it lists.
    function looseParcels(lines, parcels) {
      var seen = {}, list = [], shown = 0, i;
      for (i = 0; i < (lines || []).length; i++) {
        var t = lines[i].tracking;
        if (t && t.number && !seen[t.number]) { seen[t.number] = 1; shown++; }
      }
      for (i = 0; i < (parcels || []).length; i++) if (parcels[i] && !seen[parcels[i].number]) list.push(parcels[i]);
      var head = !list.length ? '' : shown
        ? (list.length === 1 ? '1 more parcel on this order' : list.length + ' more parcels on this order')
        : 'Your order came in ' + list.length + (list.length === 1 ? ' parcel' : ' parcels');
      return { list: list, head: head };
    }
    // PLM marks a free gift by its title: "Haki "Star" Socks (Gift)", anchored to
    // the END so "Gift of the Sea Tee" is a paid tee (plm isGiftTitle).
    function giftTitle(title) {
      var t = String(title == null ? '' : title).replace(/^\s*\[\s*pre-?order\s*\]\s*/i, '');
      var m = /^(.*?)\s*\(\s*gift\s*\)\s*$/i.exec(t);
      return m ? { name: m[1], gift: true } : { name: t, gift: false };
    }

    // Shopify's "Other" is a placeholder, not a carrier anyone would name.
    function carrierName(c) { return c && !/^other$/i.test(String(c).trim()) ? esc(c) : 'Carrier'; }
    var GIFT_SVG = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.4">' +
      '<rect x="2" y="6" width="12" height="3"/><path d="M3 9v5h10V9M8 6v8M8 6C6.5 3.5 4 3.5 4.5 5S8 6 8 6zm0 0c1.5-2.5 4-2.5 3.5-1S8 6 8 6z"/></svg>';

    // One item row inside a card: the name (linked when PLM knows the product
    // page), size and quantity, and for a line PLM holds for a pre-order, its
    // "Ships with your ..." note.
    function itemHtml(line) {
      var P = 'htrk-' + S;
      var g = giftTitle(line.productTitle);
      var name = esc(g.name) + (g.gift ? '<span class="' + P + '__giftlbl"> &middot; your free gift</span>' : '');
      var url = line.productUrl;
      var linked = typeof url === 'string' && url.charAt(0) === '/' && url.charAt(1) !== '/';
      var h = '<li class="' + P + '__item">' +
              '<p class="' + P + '__prod">' + (linked ? '<a href="' + esc(url) + '">' + name + '</a>' : name) + '</p>';
      var meta = [];
      if (line.variantTitle) meta.push('Size ' + esc(line.variantTitle));
      if (line.quantity > 1) meta.push('Qty ' + esc(line.quantity));
      if (meta.length) h += '<p class="' + P + '__meta">' + meta.join(' &middot; ') + '</p>';
      if (/^Ships with your /.test(String(line.headline || ''))) {
        h += '<p class="' + P + '__inote">' + (g.gift ? GIFT_SVG : '') + esc(line.headline) + '</p>';
      }
      return h + '</li>';
    }

    // A photo slot that is still loading, or has no photo: a quiet tee outline.
    var THUMB_SVG = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round">' +
      '<path d="M8 3 3 6l2 4 2-1v12h10V9l2 1 2-4-5-3c-.5 1.5-2 2.5-4 2.5S8.5 4.5 8 3z"/></svg>';
    // One item row inside a card (mock "Tracking Page End State", scenario 5):
    // the product photo, the name (linked when PLM knows the product page), size
    // and quantity, an IN STOCK / PRE-ORDER / FREE label, and a note: the
    // "Ships with your ..." PLM sends for a held line, or the gift block's
    // "In parcel 1, with your ..." (`note`). The photo arrives later
    // (hydrateThumbs); without one the slot keeps its outline.
    function rvItemHtml(line, note) {
      var P = 'htrk-' + S;
      var g = giftTitle(line.productTitle);
      var name = esc(g.name);
      var url = line.productUrl;
      var linked = typeof url === 'string' && url.charAt(0) === '/' && url.charAt(1) !== '/';
      var img = linked && productHandle(url) ? ' data-htrk-img="' + esc(url) + '"' : '';
      var h = '<li class="' + P + '__item">' +
              '<span class="' + P + '__thumb' + (g.gift ? ' ' + P + '__thumb--gift' : '') + '"' + img + '>' + THUMB_SVG + '</span>' +
              '<div class="' + P + '__ibody">' +
              '<p class="' + P + '__prod">' + (linked ? '<a href="' + esc(url) + '">' + name + '</a>' : name) + '</p>';
      var meta = [];
      if (line.variantTitle) meta.push('Size ' + esc(line.variantTitle));
      if (line.quantity > 1) meta.push('Qty ' + esc(line.quantity));
      if (meta.length) h += '<p class="' + P + '__meta">' + meta.join(' &middot; ') + '</p>';
      var n = note || (/^Ships with your /.test(String(line.headline || '')) ? line.headline : '');
      if (n) h += '<p class="' + P + '__inote">' + (g.gift ? GIFT_SVG : '') + esc(n) + '</p>';
      return h + '</div><p class="' + P + '__ilabel">' + itemLabel(line) + '</p></li>';
    }

    // IN STOCK / PRE-ORDER / FREE beside each item. Pure (tests run it as
    // written). A gift is Free; a paid line PLM holds for a pre-order ("Ships
    // with your ...", an international order's in-stock item) is In stock even
    // though it carries the pre-order's stage and dates.
    function itemLabel(l) {
      if (giftTitle(l.productTitle).gift) return 'Free';
      if (/^Ships with your /.test(String(l.headline || ''))) return 'In stock';
      var sd = l.stepDates;
      if (sd && sd.kind === 'preorder') return 'Pre-order';
      if (sd && sd.kind === 'in_stock') return 'In stock';
      if (/^\s*\[\s*pre-?order\s*\]/i.test(String(l.productTitle || ''))) return 'Pre-order';
      var PRE = { preorder_open: 1, with_factory: 1, in_production: 1, arriving_at_warehouse: 1 };
      return PRE[l.stage] || l.late ? 'Pre-order' : 'In stock';
    }
    // The small label on each card's top row: "In stock · on its way to you",
    // "Pre-order · being made" (mock scenario 5). A cancelled card has none (its
    // heading already says Cancelled).
    function cardTag(c) {
      var l = c.lead || {};
      if (l.stage === 'cancelled') return '';
      var lab = itemLabel(l);
      if (lab === 'Free') lab = 'In stock';
      var w = cardWord(c);
      if (w === 'on the way') w = 'on its way to you';
      return lab + (w ? ' · ' + w : '');
    }
    // FREE GIFTS IN THEIR OWN BLOCK (founder decision 2026-10-08, option C of
    // claude.ai/artifact/LQ6JKSaf8d5saPik75x38y). Gifts ship exactly as PLM
    // says (nothing here moves one); the cards list the paid items, and a
    // "Your free gifts" block under them says which parcel each gift is in:
    // "In parcel 1, with your Spirit Bomb Tee". The item named is the one PLM
    // holds the gift for ("Ships with your ..."), otherwise the first paid
    // item in the same parcel. Parcel numbers count live cards, as cardHeads.
    // `word` is the result view's PARCEL_WORD, so a card heading and its gifts
    // always use the same word ("Parcel 2 of 2" / "In parcel 2").
    // Pure: returns { items: [paid lines per card], gifts: [{line, card, note}] }.
    function giftPlan(cards, word) {
      var w = String(word || 'Parcel').toLowerCase();
      var live = 0, at = 0, i, k, items = [], gifts = [];
      for (i = 0; i < cards.length; i++) if (!(cards[i].lead && cards[i].lead.stage === 'cancelled')) live++;
      for (i = 0; i < cards.length; i++) {
        var c = cards[i], gone = !!(c.lead && c.lead.stage === 'cancelled'), paid = [], gs = [];
        if (!gone) at++;
        for (k = 0; k < c.lines.length; k++) (giftTitle(c.lines[k].productTitle).gift ? gs : paid).push(c.lines[k]);
        items.push(paid);
        for (k = 0; k < gs.length; k++) {
          var m = /^Ships with your (.+)$/.exec(String(gs[k].headline || ''));
          var anchor = m ? m[1] : (paid.length ? giftTitle(paid[0].productTitle).name : '');
          var where = gone ? 'Cancelled' : live > 1 ? 'In ' + w + ' ' + at : 'In your ' + w;
          gifts.push({ line: gs[k], card: i, note: where + (anchor && !gone ? ', with your ' + anchor : '') });
        }
      }
      return { items: items, gifts: gifts };
    }
    // An in-stock parcel the carrier is moving: its own delivery estimate, the
    // day PLM sends as stepDates.delivered {estimated: true} (plm step-dates.ts
    // carrierEta). '' when there is none or it is already past.
    function inStockEta(l) {
      var sd = l && l.stepDates, d = sd && sd.delivered;
      if (!sd || sd.kind !== 'in_stock' || l.stage === 'delivered' || !d || !d.estimated || !ymd(d.date)) return '';
      var day = String(d.date).slice(0, 10);
      return day < poTodayET() ? '' : day;
    }

    // PRODUCT PHOTOS, fetched by the browser from the storefront's own public
    // product JSON (/products/<handle>.js), once per handle, only when the row
    // is near the screen. PLM is not involved. A missing product, a network
    // error or a product without a photo leaves the outline in place.
    function productHandle(url) {
      var m = /^\/(?:collections\/[^\/?#]+\/)?products\/([^\/?#]+)/.exec(String(url || ''));
      return m ? m[1] : '';
    }
    // The photo for a product page URL from its product JSON: the variant's own
    // photo when the URL names a variant, else the product's main one, sized
    // for a 64px slot (2x).
    function productPhoto(p, url) {
      if (!p || typeof p !== 'object') return '';
      var vm = /[?&]variant=(\d+)/.exec(String(url || '')), src = '';
      if (vm && p.variants) {
        for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          if (String(v.id) === vm[1] && v.featured_image && v.featured_image.src) src = v.featured_image.src;
        }
      }
      if (!src) src = p.featured_image || (p.images && p.images[0]) || '';
      if (typeof src !== 'string' || !src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=160';
    }
    var PRODUCT_JSON = {};
    function productJson(handle, fetcher) {
      if (!handle) return Promise.resolve(null);
      if (!PRODUCT_JSON[handle]) {
        PRODUCT_JSON[handle] = Promise.resolve()
          .then(function () { return fetcher('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r && r.ok ? r.json() : null; })
          .then(null, function () { return null; });
      }
      return PRODUCT_JSON[handle];
    }
    var thumbIO = null; // one observer per render; the previous one is let go
    function hydrateThumbs(root) {
      if (thumbIO) { thumbIO.disconnect(); thumbIO = null; }
      if (!root || !window.fetch) return;
      var els = root.querySelectorAll('[data-htrk-img]');
      var load = function (el) {
        var url = el.getAttribute('data-htrk-img');
        el.removeAttribute('data-htrk-img');
        productJson(productHandle(url), window.fetch.bind(window)).then(function (p) {
          var src = productPhoto(p, url);
          if (!src || !el.parentNode) return;
          var img = document.createElement('img');
          // Decorative: the product name is the link right beside it (a11y review on #433).
          img.alt = '';
          img.width = 64; img.height = 64;
          img.loading = 'lazy'; img.decoding = 'async';
          img.onload = function () { el.classList.add('has-img'); };
          img.onerror = function () { if (img.parentNode) img.parentNode.removeChild(img); };
          img.src = src;
          el.appendChild(img);
        });
      };
      var i;
      if ('IntersectionObserver' in window) {
        var io = thumbIO = new IntersectionObserver(function (es) {
          for (var j = 0; j < es.length; j++) if (es[j].isIntersecting) { io.unobserve(es[j].target); load(es[j].target); }
        }, { rootMargin: '300px 0px' });
        for (i = 0; i < els.length; i++) io.observe(els[i]);
      } else {
        for (i = 0; i < els.length; i++) load(els[i]);
      }
    }

    function cardsHtml(lines, orderedOn) {
      var P = 'htrk-' + S;
      var cards = shipmentCards(lines);
      var n = cards.length, h = '', heads = cardHeads(cards);
      var sum = cardsSummary(cards);
      if (sum) h += '<p class="' + P + '__summary">' + esc(sum) + '</p>';
      h += '<ul class="' + P + '__cards" role="list">';
      for (var i = 0; i < n; i++) {
        var c = cards[i];
        var kind = cardKind(c);
        h += '<li class="' + P + '__card">' +
             '<div class="' + P + '__chead">' +
             '<h3 class="' + P + '__cnum">' + heads[i] + '</h3>' +
             (kind ? '<p class="' + P + '__ckind">' + kind + '</p>' : '') +
             '</div>' +
             '<div class="' + P + '__line ' + P + '__cbody">' + statusHtml(c.lead, orderedOn, c.tracking) + '</div>' +
             '<ul class="' + P + '__items" role="list">';
        for (var k = 0; k < c.lines.length; k++) h += itemHtml(c.lines[k]);
        h += '</ul></li>';
      }
      return h + '</ul>';
    }

    // THE RESULT VIEW (founder-approved mock "Tracking Page End State",
    // scenario 5, claude.ai/artifact/FazSQd7c7pLbLFLQ57yUc9). Once an order is
    // found the lookup form steps aside: an ORDER #... heading with "Placed ...
    // · N items" and a "Track another order" link, then two columns on desktop
    // (stacked on phones): the parcels on the left, one card each with its own
    // "Arriving ..." line and timeline, the free gifts in their own block under
    // them; on the right Shipping details (protection, address + Change
    // address), the order's Return / Exchange / Cancel buttons, Questions, the
    // returns area and the other-orders box. The pop-up on the order page
    // (EMBED) keeps the older layout below.
    // THE WORD FOR ONE CARD in the result view: "Parcel 1 of 2" on the card,
    // "In parcel 1, with your ..." in the gift block. One constant so the two
    // can never disagree (review on #433; the founder is choosing the word).
    var PARCEL_WORD = 'Parcel';
    var sideOrdersHook = null; // set by memberOrders: fills the side copy of "Your other active orders"
    function orderHeadHtml(o) {
      var P = 'htrk-' + S, n = 0, meta = [];
      for (var i = 0; i < (o.lines || []).length; i++) n += (o.lines[i].quantity || 1);
      if (o.orderedOn) meta.push('Placed ' + prettyDate(o.orderedOn));
      if (n) meta.push(n + (n === 1 ? ' item' : ' items'));
      // A member's order total (the "Viewing" card's, which this heading replaces).
      var tot = MEMBER_EMAIL ? ownTotal(cardTotal, o.orderNumber) : '';
      if (tot) meta.push(tot);
      return '<div class="' + P + '__rvhead">' +
        '<button type="button" class="' + P + '__another" id="htrk-another-' + S + '">' + esc(T.another) + '</button>' +
        '<h1 class="' + P + '__rvtitle" id="htrk-rvtitle-' + S + '" tabindex="-1">Order ' + esc(o.orderNumber) + '</h1>' +
        (meta.length ? '<p class="' + P + '__rvmeta">' + esc(meta.join(' \u00b7 ')) + '</p>' : '') +
        '</div>';
    }
    function resultItemsHtml(o, data) {
      var P = 'htrk-' + S;
      var cards = shipmentCards(o.lines), heads = cardHeads(cards, PARCEL_WORD), plan = giftPlan(cards, PARCEL_WORD), sum = cardsSummary(cards, PARCEL_WORD);
      var h = '<section class="' + P + '__sec ' + P + '__sec--items">' +
              '<h2 class="' + P + '__vh">' + esc(T.itemsSection) + '</h2>';
      if (sum) h += '<p class="' + P + '__summary">' + esc(sum) + '</p>';
      h += '<ul class="' + P + '__cards" role="list">';
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i], tag = cardTag(c), its = plan.items[i];
        h += '<li class="' + P + '__card">' +
             '<div class="' + P + '__chead"><h3 class="' + P + '__cnum">' + heads[i] + '</h3>' +
             (tag ? '<p class="' + P + '__ckind">' + esc(tag) + '</p>' : '') + '</div>' +
             '<div class="' + P + '__line ' + P + '__cbody">' + statusHtml(c.lead, o.orderedOn, c.tracking, true) + '</div>';
        // A parcel holding only free gifts keeps its card (its status and
        // tracking link belong to it); the gifts themselves are in the gift block.
        if (!its.length && c.lines.length) {
          h += '<p class="' + P + '__giftonly">Only free gifts in this ' + esc(PARCEL_WORD.toLowerCase()) + '. See Your free gifts below.</p>';
        }
        if (its.length) {
          h += '<ul class="' + P + '__items" role="list">';
          for (var k = 0; k < its.length; k++) h += rvItemHtml(its[k]);
          h += '</ul>';
        }
        h += '</li>';
      }
      h += '</ul>';
      if (plan.gifts.length) {
        h += '<div class="' + P + '__card ' + P + '__giftcard"><div class="' + P + '__chead"><h3 class="' + P + '__cnum">Your free gifts</h3></div>' +
             '<ul class="' + P + '__items" role="list">';
        for (var g = 0; g < plan.gifts.length; g++) h += rvItemHtml(plan.gifts[g].line, plan.gifts[g].note);
        h += '</ul></div>';
      }
      var lp = looseParcels(o.lines, data.parcels), loose = lp.list;
      if (loose.length) {
        h += '<p class="' + P + '__order" style="margin-top:18px">' + esc(lp.head) + '</p>';
        for (var p = 0; p < loose.length; p++) {
          var par = loose[p], name = par.carrier ? esc(par.carrier) : 'Carrier';
          h += '<div class="' + P + '__line">' + (par.url
            ? '<a class="' + P + '__track" style="margin-top:0" href="' + esc(par.url) + '" target="_blank" rel="noopener">Track with ' + name + ' &rarr;<span class="' + P + '__vh"> (opens in a new tab)</span></a>'
            : '<p class="' + P + '__detail">' + name + ' &middot; ' + esc(par.number) + '</p>') + '</div>';
        }
      }
      return h + '</section>';
    }
    // The right-hand column. The guest sign-in box and the member's other
    // orders live in the (now hidden) lookup column; the side gets a copy, so
    // nothing has to be moved in and out of the results on every render.
    function resultSideHtml(o) {
      var P = 'htrk-' + S, h = shipSectionHtml(o, true);
      h += '<div class="' + P + '__acts"><div class="' + P + '__cardacts" hidden></div></div>';
      h += questionsHtml(o);
      h += '<section class="' + P + '__sec ' + P + '__sec--ret" id="htrk-retsec-' + S + '" hidden>' +
           '<h2 class="' + P + '__sechead" id="htrk-rethead-' + S + '" hidden></h2>' +
           '<div class="' + P + '__ret" id="htrk-ret-' + S + '"></div></section>';
      var nav = document.getElementById('htrk-myorders-' + S);
      var nudge = document.getElementById('htrk-nudge-' + S);
      if (nav && MEMBER_EMAIL) {
        h += '<nav class="' + P + '__myorders ' + P + '__sidebox ' + P + '__sideorders" aria-label="' + esc(nav.getAttribute('aria-label') || '') + '" hidden>' +
             '<p class="' + P + '__myorders-title">' + esc((nav.querySelector('.' + P + '__myorders-title') || {}).textContent || '') + '</p>' +
             '<ul class="' + P + '__myorders-list" role="list"></ul></nav>';
      } else if (nudge && !MEMBER_EMAIL) {
        h += '<aside class="' + P + '__nudge ' + P + '__sidebox">' + nudge.innerHTML + '</aside>';
      }
      return '<div class="' + P + '__side">' + h + '</div>';
    }
    var focusResult = false; // set by a lookup the shopper started (form, an order in the list)
    function trackAnother() {
      if (!grid) return;
      if (thumbIO) { thumbIO.disconnect(); thumbIO = null; }
      outLive(true);
      grid.classList.remove('is-result');
      grid.classList.remove('is-member-view');
      out.innerHTML = '';
      setThreeCol(false);
      try { window.scrollTo(0, 0); } catch (e) {}
      orderEl.value = '';
      orderEl.focus();
    }
    // LIVE REGION (a11y review on #433, WCAG 4.1.3): #htrk-out is a polite
    // status region, right for a one-line message ("Looking…", an error). The
    // result view is a whole page of headings, cards and buttons, so while it
    // shows #htrk-out stops being live and a short line is said instead
    // ("Order #HS… found, 2 parcels"). message() / showFinding / Track another
    // order make #htrk-out live again. The pop-up (EMBED) never comes here.
    function outLive(on) {
      if (on) { out.setAttribute('role', 'status'); out.setAttribute('aria-live', 'polite'); }
      else { out.removeAttribute('role'); out.removeAttribute('aria-live'); }
    }
    function liveSay(text) {
      var el = document.getElementById('htrk-live-' + S);
      if (!el) {
        el = document.createElement('p');
        el.id = 'htrk-live-' + S;
        el.className = 'htrk-' + S + '__vh';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        out.parentNode.insertBefore(el, out);
      }
      el.textContent = '';
      // A beat later, so the change is announced even when the text repeats.
      setTimeout(function () { el.textContent = text; }, 60);
    }
    function resultSay(o) {
      var cards = (o.lines && o.lines.length) ? shipmentCards(o.lines) : [], n = 0;
      for (var i = 0; i < cards.length; i++) if (!(cards[i].lead && cards[i].lead.stage === 'cancelled')) n++;
      var w = String(PARCEL_WORD).toLowerCase();
      return 'Order ' + o.orderNumber + ' found' + (n ? ', ' + n + ' ' + w + (n === 1 ? '' : 's') : '') + '.';
    }
    function renderResult(data) {
      var o = data.order;
      outLive(false);
      var h = orderHeadHtml(o) + '<div class="htrk-' + S + '__cols" id="htrk-cols-' + S + '">';
      h += (o.lines && o.lines.length)
        ? resultItemsHtml(o, data)
        : '<section class="htrk-' + S + '__sec htrk-' + S + '__sec--items"><div class="htrk-' + S + '__msg">' +
          esc(o.note || 'There is nothing outstanding on this order.') + '</div></section>';
      h += resultSideHtml(o) + '</div>';
      out.innerHTML = h;
      if (grid) {
        grid.classList.remove('is-split');
        grid.classList.add('is-result');
      }
      var another = document.getElementById('htrk-another-' + S);
      if (another) another.addEventListener('click', trackAnother);
      liveSay(resultSay(o));
      hydrateThumbs(out);
      if (sideOrdersHook) sideOrdersHook();
      fillCardActs();
      syncShipVis();
      reveal();
      // The lookup column (and whatever had focus in it) is gone: a lookup the
      // shopper started lands focus on the ORDER heading (review on #433). A
      // page-load lookup leaves focus where the browser put it.
      if (focusResult) {
        focusResult = false;
        var head = document.getElementById('htrk-rvtitle-' + S);
        if (head) { try { head.focus({ preventScroll: true }); } catch (e) { head.focus(); } }
      }
    }

    function renderFound(data) {
      poStampPrec(data && data.order);
      if (!EMBED) { renderResult(data); return; }
      var o = data.order;
      var h = '<p class="htrk-' + S + '__order htrk-' + S + '__orderline">Order ' + esc(o.orderNumber);
      if (o.orderedOn) h += ' &middot; placed ' + esc(prettyDate(o.orderedOn));
      h += '</p>';

      if (!o.lines || !o.lines.length) {
        h += '<div class="htrk-' + S + '__msg">' +
             esc(o.note || 'There is nothing outstanding on this order.') + '</div>';
        h += shipSectionHtml(o);
        out.innerHTML = h;
        if (grid) grid.classList.remove('is-split');
        setThreeCol(false);
        syncShipVis();
        reveal();
        return;
      }

      var items = '<section class="htrk-' + S + '__sec htrk-' + S + '__sec--items">' +
                  '<h2 class="htrk-' + S + '__sechead">' + esc(T.itemsSection) + '</h2>';
      items += cardsHtml(o.lines, o.orderedOn);

      // Only sent when an order shipped in more than one parcel. Parcels a card
      // already shows (PLM matched their lines, 0917) are not listed again; what
      // is left is a parcel PLM could not tie to a line, listed as before.
      var lp = looseParcels(o.lines, data.parcels), loose = lp.list;
      if (loose.length) {
        items += '<p class="htrk-' + S + '__order" style="margin-top:18px">' + esc(lp.head) + '</p>';
        for (var p = 0; p < loose.length; p++) {
          var par = loose[p];
          var name = par.carrier ? esc(par.carrier) : 'Carrier';
          items += '<div class="htrk-' + S + '__line">';
          items += par.url
            ? '<a class="htrk-' + S + '__track" style="margin-top:0" href="' + esc(par.url) +
              '" target="_blank" rel="noopener">Track with ' + name + ' &rarr;<span class="htrk-' + S + '__vh"> (opens in a new tab)</span></a>'
            : '<p class="htrk-' + S + '__detail">' + name + ' &middot; ' + esc(par.number) + '</p>';
          items += '</div>';
        }
      }
      items += '</section>';

      // Returns: its own section with the same heading style as
      // the others. Hidden until loadReturns has something to put in it. Last
      // in the DOM so a phone reads it after the items; on desktop the grid
      // places it under Shipping details in the middle column.
      var ret = '<section class="htrk-' + S + '__sec htrk-' + S + '__sec--ret" id="htrk-retsec-' + S + '" hidden>' +
                '<h2 class="htrk-' + S + '__sechead" id="htrk-rethead-' + S + '" hidden></h2>' +
                '<div class="htrk-' + S + '__ret" id="htrk-ret-' + S + '"></div>' +
                '</section>';

      // Shipping details first, in the DOM and on the phone; on desktop the
      // wrapper becomes the middle+right columns when the middle has content.
      h += '<div class="htrk-' + S + '__cols" id="htrk-cols-' + S + '">' +
           (EMBED ? questionsHtml(o) : '') + shipSectionHtml(o) + items + ret + '</div>';
      out.innerHTML = h;
      if (grid) grid.classList.add('is-split');
      // Fresh items section, fresh scroll listener; the one on the previous
      // render's element died with the element.
      var itemsEl = out.querySelector('.htrk-' + S + '__sec--items');
      if (itemsEl) itemsEl.addEventListener('scroll', updateScrollShadows);
      syncShipVis();
      reveal();
    }

    // ---------------------------------------------------------------------
    // ADDRESS EDITING. Everything below renders into the __addr box that
    // renderFound leaves at the bottom of the results. Nothing here may ever
    // break the tracking answer above it: any surprise — bad JSON, an error
    // payload, a dropped connection — renders nothing and stays quiet.
    // ---------------------------------------------------------------------

    function addrBox() { return document.getElementById('htrk-addr-' + S + ''); }
    function afEl(id) { return document.getElementById('htrk-' + id + '-' + S + ''); }
    function afVal(id) {
      var el = afEl(id);
      return el ? trimStr(el.value) : '';
    }

    // Render an eligibility answer into the address box. Anything but the two
    // shapes we recognize — eligible-with-address, or ineligible-because-packed
    // — renders nothing: reason 'shipped', an { error } payload, a null from a
    // dropped connection, all stay quiet. Called from submitLookup, either in
    // the same paint as the results or later if the answer was slow.
    function applyAddrAnswer(body) {
      var box = addrBox();
      if (!box || !body) { if (pendingFocus === 'address') focusDone(null); return; }
      if (body.eligible && body.address) {
        addrCurrent = body.address;
        addrCountry = body.address.countryCode || '';
        renderAddrCard(addrCurrent, false);
        if (pendingFocus === 'address') { renderAddrForm(addrCurrent); focusDone(box); return; }
      } else if (body.eligible === false && body.address) {
        // Packed or shipped: still show where it's going, read-only — no
        // Change button (operator, 2026-09-29). Packed keeps its quiet line
        // under the address; the parcel may still be catchable by a human.
        addrCurrent = body.address;
        addrCountry = body.address.countryCode || '';
        renderAddrCard(addrCurrent, false, true);
        if (body.reason === 'packed' && T.packedHtml) {
          box.insertAdjacentHTML('beforeend', '<div class="htrk-' + S + '__anote rte">' + T.packedHtml + '</div>');
        }
      } else if (body.eligible === false && body.reason === 'packed' && T.packedHtml) {
        // Older PLM answers carry no address: the quiet line alone.
        box.innerHTML = '<div class="htrk-' + S + '__anote rte">' + T.packedHtml + '</div>';
        syncShipVis();
      }
      // Asked for, but not changeable: land on whatever PLM said instead.
      if (pendingFocus === 'address') focusDone(box);
    }

    // Name on the first line, street on the second, city/region on the third.
    function addrCardLines(a) {
      var street = [];
      if (a.address1) street.push(a.address1);
      if (a.address2) street.push(a.address2);
      var locality = [];
      if (a.city) locality.push(a.city);
      var pz = trimStr((a.provinceCode || '') + ' ' + (a.zip || ''));
      if (pz) locality.push(pz);
      var cn = countryName(a.countryCode || addrCountry);
      if (cn) locality.push(cn);
      return [street.join(', '), locality.join(', ')];
    }

    function renderAddrCard(a, justUpdated, readOnly) {
      var box = addrBox();
      if (!box) return;
      var name = trimStr((a.firstName || '') + ' ' + (a.lastName || ''));
      var lines = addrCardLines(a);
      var h = '<div class="htrk-' + S + '__line">';
      h += '<p class="htrk-' + S + '__stage">' + esc(T.heading) + '</p>';
      h += '<p class="htrk-' + S + '__detail">';
      if (name) h += esc(name) + '<br>';
      h += esc(lines[0]);
      if (lines[1]) h += '<br>' + esc(lines[1]);
      h += '</p>';
      if (justUpdated) h += '<p class="htrk-' + S + '__aok">' + esc(T.updated) + '</p>';
      if (!readOnly) {
        h += '<button type="button" class="htrk-' + S + '__abtn" id="htrk-achange-' + S + '">' +
             esc(T.change) + '</button>';
      }
      h += '</div>';
      box.innerHTML = h;
      syncShipVis();
      var chg = afEl('achange');
      if (chg) {
        chg.addEventListener('click', function () { renderAddrForm(addrCurrent); });
      }
    }

    function afInput(id, label, value, autoc) {
      return '<label class="htrk-' + S + '__field">' +
        '<span class="htrk-' + S + '__label">' + esc(label) + '</span>' +
        '<input type="' + (autoc === 'tel' ? 'tel' : 'text') + '" id="htrk-' + id + '-' + S + '"' +
        ' value="' + esc(value) + '" autocomplete="' + autoc + '">' +
        '</label>';
    }

    function renderAddrForm(a) {
      var box = addrBox();
      if (!box) return;
      var regions = REGIONS[addrCountry];
      var h = '<form class="htrk-' + S + '__line htrk-' + S + '__aform" id="htrk-aform-' + S + '" novalidate>';
      h += '<p class="htrk-' + S + '__stage">' + esc(T.heading) + '</p>';
      h += '<div class="htrk-' + S + '__row">';
      h += afInput('afirst', T.first, a.firstName, 'given-name');
      h += afInput('alast', T.last, a.lastName, 'family-name');
      h += '</div>';
      h += afInput('aaddr1', T.address1, a.address1, 'address-line1');
      h += afInput('aaddr2', T.address2, a.address2, 'address-line2');
      h += afInput('acity', T.city, a.city, 'address-level2');
      h += '<div class="htrk-' + S + '__row">';
      if (regions) {
        h += '<label class="htrk-' + S + '__field">' +
             '<span class="htrk-' + S + '__label">' + esc(T.province) + '</span>' +
             '<select id="htrk-aprov-' + S + '" autocomplete="address-level1">' +
             '<option value=""></option>';
        for (var i = 0; i < regions.length; i++) {
          h += '<option value="' + esc(regions[i][0]) + '"' +
               (regions[i][0] === a.provinceCode ? ' selected' : '') + '>' +
               esc(regions[i][1]) + '</option>';
        }
        h += '</select></label>';
      } else {
        h += afInput('aprov', T.province, a.provinceCode, 'address-level1');
      }
      h += afInput('azip', T.zip, a.zip, 'postal-code');
      h += '</div>';
      h += afInput('aphone', T.phone, a.phone, 'tel');
      // The country is decided server-side; here it is a fact, not a field.
      h += '<div class="htrk-' + S + '__field">' +
           '<span class="htrk-' + S + '__label">' + esc(T.country) + '</span>' +
           '<p class="htrk-' + S + '__afixed">' + esc(countryName(addrCountry)) + '</p>';
      if (T.countryNoteHtml) {
        h += '<div class="htrk-' + S + '__anote rte">' + T.countryNoteHtml + '</div>';
      }
      h += '</div>';
      h += '<p class="htrk-' + S + '__aerr" id="htrk-aerr-' + S + '" role="alert"></p>';
      h += '<div class="htrk-' + S + '__aacts">';
      h += '<button type="submit" class="htrk-' + S + '__submit htrk-' + S + '__submit--a" ' +
           'id="htrk-asave-' + S + '">' + esc(T.save) + '</button>';
      h += '<button type="button" class="htrk-' + S + '__abtn htrk-' + S + '__abtn--cancel" ' +
           'id="htrk-acancel-' + S + '">' + esc(T.cancel) + '</button>';
      h += '</div>';
      h += '</form>';
      box.innerHTML = h;
      syncShipVis();

      var formEl = afEl('aform');
      if (formEl) {
        formEl.addEventListener('submit', function (e) {
          e.preventDefault();
          submitAddress();
        });
      }
      var cancel = afEl('acancel');
      if (cancel) {
        cancel.addEventListener('click', function () {
          renderAddrCard(addrCurrent, false);
          // Opened straight into the editor from the order page's "Change
          // address": Cancel closes the pop-up, like Return / Exchange do.
          if (flowCancelHook) flowCancelHook();
        });
      }
      var firstField = afEl('afirst');
      if (firstField) firstField.focus();
    }

    function submitAddress() {
      var address = {
        firstName: afVal('afirst'),
        lastName: afVal('alast'),
        address1: afVal('aaddr1'),
        address2: afVal('aaddr2'),
        city: afVal('acity'),
        provinceCode: afVal('aprov'),
        zip: afVal('azip'),
        phone: afVal('aphone')
      };

      // Required: everything a carrier needs to find a door. Line 2 and phone
      // are optional; the province only when we could offer a real list.
      var required = ['afirst', 'alast', 'aaddr1', 'acity', 'azip'];
      if (REGIONS[addrCountry]) required.push('aprov');
      var firstBad = null;
      var ids = ['afirst', 'alast', 'aaddr1', 'aaddr2', 'acity', 'aprov', 'azip', 'aphone'];
      for (var i = 0; i < ids.length; i++) {
        var el = afEl(ids[i]);
        if (!el) continue;
        var bad = false;
        for (var r = 0; r < required.length; r++) {
          if (required[r] === ids[i] && !trimStr(el.value)) bad = true;
        }
        el.className = bad ? 'is-invalid' : '';
        if (bad && !firstBad) firstBad = el;
      }
      var errEl = afEl('aerr');
      if (firstBad) {
        if (errEl) errEl.textContent = T.required;
        firstBad.focus();
        return;
      }
      if (errEl) errEl.textContent = '';

      var save = afEl('asave');
      if (save) {
        save.disabled = true;
        save.textContent = T.saving;
      }

      var seq = addrSeq;
      function fail(text) {
        // Honest error, form still filled, button alive again — never a dead
        // working state.
        var e2 = afEl('aerr');
        var s2 = afEl('asave');
        if (e2) e2.textContent = text;
        if (s2) { s2.disabled = false; s2.textContent = T.save; }
        // Save was disabled while busy, so focus had fallen to <body> (2.4.3):
        // same rule as the return form's step 4. The error line is read, and
        // the next Tab is Save again.
        focusError(e2, document);
      }

      changeFetch(ADDR_API, { orderNumber: lastOrder, email: lastEmail, action: 'set', address: address, entry: lastEntry }, 'address', afEl('aform'))
        .then(function (r) {
          if (seq !== addrSeq) return; // the shopper looked up another order
          var body = r.body;
          if (body && body.ok) {
            addrCurrent = body.address || address;
            if (!addrCurrent.countryCode) addrCurrent.countryCode = addrCountry;
            renderAddrCard(addrCurrent, true);
            return;
          }
          if (body && body.error) {
            // 409 means the order stopped being editable while the form was
            // open (it got packed or shipped). Retrying would hit the same
            // wall, so the sentence replaces the form instead of sitting
            // beside a live save button.
            if (r.status === 409) {
              var box = addrBox();
              if (box) {
                box.innerHTML = '<div class="htrk-' + S + '__anote rte"><p>' + esc(body.error) + '</p></div>';
                syncShipVis();
              }
              return;
            }
            // Everything else with an { error } body is a sentence written
            // for the shopper (validation, rate limit, Shopify down) — show
            // it inline, form still filled.
            fail(body.error);
            return;
          }
          // No ok, no error: this is the lookup's own not-found body, which
          // means the pair this session verified with has gone stale. The
          // editor hides rather than arguing.
          var gone = addrBox();
          if (gone) {
            gone.innerHTML = '';
            syncShipVis();
          }
        })
        .catch(function () {
          if (seq !== addrSeq) return;
          fail('We could not reach our order system just now. Check your connection and try again.');
        });
    }

    // ---------------------------------------------------------------------
    // RETURNS. Renders into the __ret box at the foot of the
    // items column, from PLM's /track/return answer. Same rules as the
    // address editor: nothing here may ever break the tracking answer above
    // it — bad JSON, an { error } payload, a dropped connection all render
    // nothing and stay quiet. What the customer picks goes to PLM, which
    // re-checks everything server-side; the page never decides eligibility.
    // ---------------------------------------------------------------------

    // DROPDOWNS. The same behaviour as the product page's size picker
    // (`.dropdown-select` in the theme): the trigger shows the pick, the list
    // slides open, one open at a time, a click outside or Escape closes it.
    // Markup and keyboard rules live in ddMarkup / ddSetOpen / ddStep above
    // run(); a sold-out option is a disabled button and stays visible, struck
    // through.
    var ddOpen = null;

    function ddHtml(id, opts, placeholder, value, labelId) {
      return ddMarkup(S, id, opts, placeholder, value, labelId);
    }

    function ddTrigger(id) { return document.getElementById(id + '-btn'); }

    // Lift an open list out of the pop-up so its scroll box can't clip it:
    // fixed on <body>, under the trigger (or above it when there's no room).
    function ddFloat(dd) {
      var host = dd.closest ? dd.closest('.is-modal') : null;
      var list = dd.querySelector('.htrk-' + S + '__dd-list');
      var btn = dd.querySelector('.htrk-' + S + '__dd-label');
      if (!host || !list || !btn) return;
      var r = btn.getBoundingClientRect();
      var cs = window.getComputedStyle(host);
      var below = window.innerHeight - r.bottom - 12;
      var above = r.top - 12;
      var up = below < 200 && above > below;
      var max = Math.max(120, Math.min(320, up ? above : below));
      list.__home = dd;
      document.body.appendChild(list);
      list.classList.add('is-float');
      list.style.left = r.left + 'px';
      list.style.width = r.width + 'px';
      list.style.maxHeight = max + 'px';
      list.style.top = up ? '' : r.bottom + 'px';
      list.style.bottom = up ? (window.innerHeight - r.top) + 'px' : '';
      list.style.background = cs.backgroundColor;
      list.style.color = cs.color;
      list.style.fontFamily = cs.fontFamily;
      list.style.setProperty('--color-foreground', cs.getPropertyValue('--color-foreground'));
      dd.__list = list;
    }
    function ddUnfloat(dd) {
      var list = dd.__list;
      if (!list) return;
      list.classList.remove('is-float');
      list.removeAttribute('style');
      dd.appendChild(list);
      dd.__list = null;
    }
    function ddClose(dd) {
      ddUnfloat(dd);
      dd.classList.remove('is-open');
      ddSetOpen(dd.querySelector('.htrk-' + S + '__dd-list'), false);
      var btn = dd.querySelector('.htrk-' + S + '__dd-label');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (ddOpen === dd) ddOpen = null;
    }

    function initDropdowns(root) {
      // A re-render can leave a lifted list behind on <body>: drop it.
      var strays = document.querySelectorAll('body > .htrk-' + S + '__dd-list.is-float');
      for (var sI = 0; sI < strays.length; sI++) strays[sI].parentNode.removeChild(strays[sI]);
      ddOpen = null;
      var dds = root.querySelectorAll('.htrk-' + S + '__dd');
      for (var i = 0; i < dds.length; i++) {
        (function (dd) {
          var input = dd.querySelector('input[type="hidden"]');
          var btn = dd.querySelector('.htrk-' + S + '__dd-label');
          var label = btn ? btn.querySelector('span') : null;
          var ownList = dd.querySelector('.htrk-' + S + '__dd-list');
          var opts = ddOptions(ownList);
          if (!input || !btn || !ownList) return;
          ddSetOpen(ownList, false);
          var open = function () {
            if (ddOpen && ddOpen !== dd) ddClose(ddOpen);
            dd.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            ddOpen = dd;
            ddFloat(dd);
            return ddSetOpen(ownList, true);
          };
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (!dd.classList.contains('is-open')) open();
            else ddClose(dd);
          });
          // Down / Up on the button open the list onto the picked option (or
          // the first / last one) and move focus in.
          btn.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
            e.preventDefault();
            var home = dd.classList.contains('is-open') ? ddHome(ownList) : open();
            var picked = home && home.getAttribute('aria-selected') === 'true';
            ddRove(ownList, picked ? home : ddStep(ownList, null, e.key));
          });
          for (var k = 0; k < opts.length; k++) {
            (function (opt) {
              var li = opt.parentNode;
              if (!ddEnabled(opt)) return;
              opt.addEventListener('click', function (e) {
                e.stopPropagation();
                input.value = (li && li.getAttribute('data-value')) || '';
                if (label) label.textContent = opt.textContent;
                btn.classList.remove('is-placeholder');
                btn.classList.remove('is-invalid');
                for (var m = 0; m < opts.length; m++) opts[m].setAttribute('aria-selected', opts[m] === opt ? 'true' : 'false');
                // These dropdowns write straight to a hidden input, so nothing
                // could ever react to a choice being made — the gift preview
                // needs to know when Qty changes. Dispatched rather than
                // special-cased so the next listener gets it for free.
                try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (err) {
                  var ev = document.createEvent('HTMLEvents'); ev.initEvent('change', true, false); input.dispatchEvent(ev);
                }
                ddClose(dd);
                btn.focus();
              });
            })(opts[k]);
          }
          var onEsc = function (e) {
            if (e.key !== 'Escape' || !dd.classList.contains('is-open')) return;
            e.stopPropagation();
            ddClose(dd);
            btn.focus();
          };
          dd.addEventListener('keydown', onEsc);
          // A lifted list is outside dd, so it needs its own keys.
          ownList.addEventListener('keydown', function (e) {
            var to = ddStep(ownList, e.target, e.key);
            if (to) { e.preventDefault(); e.stopPropagation(); ddRove(ownList, to); return; }
            if (ownList.parentNode !== dd) onEsc(e); // inside dd, dd's own listener has it
          });
          // Tab out of an open list closes it, so it never hangs open behind
          // focus that has moved on.
          ownList.addEventListener('focusout', function (e) {
            if (!dd.classList.contains('is-open')) return;
            var to = e.relatedTarget;
            if (to && (ownList.contains(to) || to === btn)) return;
            if (to) ddClose(dd);
          });
        })(dds[i]);
      }
    }
    document.addEventListener('click', function (e) {
      if (ddOpen && !ddOpen.contains(e.target) && !(ddOpen.__list && ddOpen.__list.contains(e.target))) ddClose(ddOpen);
    });
    // A lifted list doesn't move with the pop-up: close it when the pop-up
    // scrolls or the window resizes (its own scrolling is fine).
    document.addEventListener('scroll', function (e) {
      if (ddOpen && ddOpen.__list && e.target !== ddOpen.__list) ddClose(ddOpen);
    }, true);
    window.addEventListener('resize', function () { if (ddOpen && ddOpen.__list) ddClose(ddOpen); });

    // On a phone the results render below the form, off screen, so a tap on
    // "Find my order" seemed to do nothing. Move the page to them. Desktop
    // shows form and results side by side and never needs this.
    function scrollToResults() {
      if (window.matchMedia && window.matchMedia('(min-width: 900px)').matches) return;
      // A hidden (pre-loading) embedded panel must never move the page, and
      // neither must the pop-up (it scrolls inside itself).
      if (grid && grid.parentNode && (grid.parentNode.hidden || grid.parentNode.classList.contains('is-modal'))) return;
      var offset = 16;
      var hdr = document.querySelector('.haki-header, header');
      if (hdr) {
        var pos = window.getComputedStyle(hdr).position;
        if (pos === 'fixed' || pos === 'sticky') offset += hdr.getBoundingClientRect().height;
      }
      var top = out.getBoundingClientRect().top + (window.pageYOffset || 0) - offset;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); } catch (err) { window.scrollTo(0, top); }
    }

    function retBox() { return document.getElementById('htrk-ret-' + S + ''); }

    // Asked alongside the lookup (see submitLookup), so the section is in the
    // first paint whenever PLM answers in time. `onLanded` gets the body, or
    // null when the request failed — either way the lookup is never blocked.

    // ONE LOOKUP, SHARED (2026-09-26, operator hit "Too many attempts"): PLM
    // allows 5 track calls per order per minute. The order view and its embedded
    // track panel asked the same questions separately (4 calls on load, 3 more
    // for Change address). Both now go through this: successful READS (lookup,
    // address/returns eligibility) are reused for 60s, keyed by endpoint +
    // order + email + action; errors are never kept, so the next try asks fresh.
    if (!window.HakiTrackPost) {
      window.HakiTrackPost = function (url, payload) {
        var c = window.__hakiTrackCache || (window.__hakiTrackCache = {});
        var k = [url, String(payload.orderNumber || '').toUpperCase(), String(payload.email || '').toLowerCase(), payload.action || ''].join('|');
        var e = c[k];
        if (e && Date.now() - e.at < 60000) return e.p;
        var p = fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (res) { return res.json().then(function (body) { return { status: res.status, body: body }; }); });
        c[k] = { at: Date.now(), p: p };
        p.then(function (r) { if (!r || r.status !== 200) delete c[k]; }, function () { delete c[k]; });
        return p;
      };
    }

    function loadReturns(orderNumber, email, seq, onLanded) {
      window.HakiTrackPost(RET_API, { orderNumber: orderNumber, email: email, action: 'get', entry: lastEntry, options: 2 })
        .then(function (r) { return r.body; })
        .then(function (body) {
          if (seq !== addrSeq) return; // a newer lookup superseded this
          onLanded(body);
        })
        .catch(function () {
          if (seq !== addrSeq) return;
          onLanded(null); // degrade invisibly
        });
    }

    function retNoteHtml(html) {
      return '<div class="htrk-' + S + '__anote rte">' + html + '</div>';
    }

    // One card per return already on the order: what is in it, where it is.
    function renderExistingReturns(list) {
      var h = '';
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        if (!r) continue;
        h += '<div class="htrk-' + S + '__line">';
        h += '<p class="htrk-' + S + '__stage">' + esc(r.exchange && r.exchange.length ? T.exExisting : T.retExisting) + (r.name ? ' ' + esc(r.name) : '') +
             ' &middot; ' + esc(r.status || '') + '</p>';
        var parts = [];
        if (r.items && r.items.length) parts.push(esc(r.items.join(', ')));
        if (r.exchange && r.exchange.length) parts.push('Exchange for ' + esc(r.exchange.join(', ')));
        if (parts.length) h += '<p class="htrk-' + S + '__detail">' + parts.join('<br>') + '</p>';
        if (r.tracking && r.tracking.number) {
          var carrier = r.tracking.carrier ? esc(r.tracking.carrier) : 'Carrier';
          if (r.tracking.url) {
            h += '<a class="htrk-' + S + '__track" href="' + esc(r.tracking.url) + '" target="_blank" rel="noopener">' +
                 esc(T.retTrackBack) + ' &rarr;</a>';
          } else {
            h += '<p class="htrk-' + S + '__eta">' + carrier + ' &middot; ' + esc(r.tracking.number) + '</p>';
          }
        }
        h += '</div>';
      }
      return h;
    }

    // The eligibility answer. Recognised shapes: eligible-with-items (a start
    // button), ineligible for a reason the merchant wrote copy for (one quiet
    // note), or nothing to say yet (nothing shipped / already returned).
    // The last returns answer and which order it was for, so a panel the order
    // view pre-loaded can open instantly (see HakiTrack.prefetch).
    var lastRet = null;
    // "Return" / "Exchange" for the flow that is open, or the one the order
    // page asked for (still loading, or an error). No heading otherwise.
    function setRetHead() {
      var el = document.getElementById('htrk-rethead-' + S + '');
      if (!el) return;
      var mode = flow ? flow.mode : askedMode;
      el.textContent = mode === 'exchange' ? T.retHeadExchange : mode === 'return' ? T.retHeadReturn : '';
      el.hidden = !mode;
      if (nameModalHook) nameModalHook();
    }
    // ---------------------------------------------------------------------
    // ORDER-CARD ACTIONS (operator, 2026-09-29: "move the return/exchange/
    // cancel buttons into the order card"). One slot in whichever card is on
    // screen (a member's on the left, a guest's in the middle column). The
    // flows and the cancel panel still open in the middle column's box.
    // ---------------------------------------------------------------------
    // ---- the track page's pop-up for Return / Exchange / Cancel ----------
    var flowPop = null, flowBd = null, flowHome = null, ocOpen = false;
    var flowOpener = null, flowAct = null;
    function flowKey(e) {
      if (e.key === 'Escape' || e.keyCode === 27) { closeFlowPop(true); return; }
      if (flowPop) trapTab(e, flowPop);
    }
    // EVERY SCREEN SIZE (operator, 2026-09-29: phones first — "on mobile
    // having it scroll is annoying" — then "just make it a popup on desktop
    // too" after an exchange form ran off the one-screen layout). Returns
    // true when the pop-up is (now) open.
    function openFlowPop() {
      if (EMBED) return false;
      if (flowPop) return true;
      var sec = retSec();
      var opener = document.activeElement;
      var root = grid && grid.parentNode;
      if (!sec || !root) {
        if (!sec) return false;
        if (!sec.__scrollBound) {
          sec.__scrollBound = true;
          sec.addEventListener('scroll', updateScrollShadows);
        }
        setTimeout(function () {
          // One-screen layout: the area scrolls itself, so start it at the
          // top. (scrollIntoView here scrolled the clipped section itself and
          // cut the left column off.) Otherwise bring it into view.
          if (root && root.classList.contains('is-fullvp')) { sec.scrollTop = 0; updateScrollShadows(); }
          else { try { sec.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {} }
        }, 0);
        return false;
      }
      flowHome = document.createComment('htrk-flow');
      sec.parentNode.insertBefore(flowHome, sec);
      flowBd = document.createElement('div');
      flowBd.className = 'htrk-' + S + '__flowbd';
      flowPop = document.createElement('div');
      flowPop.className = 'htrk-' + S + '__flowpop';
      flowPop.setAttribute('role', 'dialog');
      flowPop.setAttribute('aria-modal', 'true');
      // Named by the returns section's heading ("Return" / "Exchange" /
      // "Cancel order"), the same pattern as the order page's pop-up.
      flowPop.setAttribute('aria-labelledby', 'htrk-rethead-' + S);
      flowOpener = opener;
      flowAct = opener && opener.getAttribute ? opener.getAttribute('data-htrk-cact') : null;
      flowPop.innerHTML = '<button type="button" class="htrk-' + S + '__flowx" aria-label="Close">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      flowPop.appendChild(sec);
      root.appendChild(flowBd);
      root.appendChild(flowPop);
      try { document.documentElement.style.overflow = 'hidden'; } catch (e) {}
      flowBd.addEventListener('click', function () { closeFlowPop(true); });
      flowPop.querySelector('.htrk-' + S + '__flowx').addEventListener('click', function () { closeFlowPop(true); });
      document.addEventListener('keydown', flowKey);
      // A flow's own Cancel / Back-at-step-1 has already put the buttons
      // back; it only needs the panel closed.
      flowCancelHook = function () { closeFlowPop(false); };
      // Focus moves in (a flow's first step then moves it to its own title).
      focusQuietly(flowPop.querySelector('.htrk-' + S + '__flowx'));
      return true;
    }
    // restore = true: closed mid-way (✕, backdrop, Esc) → back to the start,
    // as if Cancel was pressed. A finished flow keeps its confirmation, which
    // stays on the page after the panel closes.
    function closeFlowPop(restore) {
      if (!flowPop) return;
      var sec = retSec();
      if (restore && (flow || ocOpen)) {
        flow = null;
        ocOpen = false;
        var head = document.getElementById('htrk-rethead-' + S + '');
        if (head) head.hidden = true;
        applyRetAnswer(lastRet ? lastRet.body : null);
        if (!lastRet) { var rb = retBox(); if (rb) rb.innerHTML = ''; }
      }
      if (sec && flowHome && flowHome.parentNode) flowHome.parentNode.insertBefore(sec, flowHome);
      if (flowHome && flowHome.parentNode) flowHome.parentNode.removeChild(flowHome);
      if (flowPop.parentNode) flowPop.parentNode.removeChild(flowPop);
      if (flowBd && flowBd.parentNode) flowBd.parentNode.removeChild(flowBd);
      flowPop = flowBd = flowHome = null;
      flowCancelHook = null;
      document.removeEventListener('keydown', flowKey);
      try { document.documentElement.style.overflow = ''; } catch (e) {}
      syncShipVis();
      updateScrollShadows();
      // Back to the button that opened it; if a re-paint replaced that
      // button, its new copy; else the order card's heading.
      var sels = [];
      if (flowAct) sels.push('[data-htrk-cact="' + flowAct + '"]');
      sels.push('.htrk-' + S + '__cardhead');
      focusQuietly(focusBackTarget(flowOpener, grid, sels));
      flowOpener = flowAct = null;
    }

    var cardRet = null;      // the returns answer when something can go back
    var cardCancel = false;  // members only: PLM says this order can be cancelled
    // The member's order total, kept WITH the order it belongs to ({n, total}),
    // because a later lookup (typed after "Track another order", or an order
    // that is not in their list) never goes through the list's render(). Read
    // it only through ownTotal (review on #433: a stale total showed the
    // previous order's money).
    var cardTotal = null;
    function ownTotal(stored, orderNumber) {
      var k = function (n) { return String(n == null ? '' : n).replace(/^#/, '').replace(/\s+/g, '').toUpperCase(); };
      return stored && stored.total && k(orderNumber) && k(stored.n) === k(orderNumber) ? String(stored.total) : '';
    }
    var refreshCurrent = null; // set by memberOrders: re-open the current order
    var cancelSeq = 0;
    function fillCardActs() {
      // The result view's own slot (right column) first; the member's
      // "Viewing" card in the lookup column is hidden there.
      var slot = grid ? (out.querySelector('.htrk-' + S + '__acts .htrk-' + S + '__cardacts') || grid.querySelector('.htrk-' + S + '__cardacts')) : null;
      if (!slot || EMBED) return false;
      var h = '';
      if (cardRet) {
        h += '<button type="button" class="htrk-' + S + '__abtn" data-htrk-cact="return">' + esc(T.retStartReturn) + '</button>';
        if (anyExchangeable(cardRet)) h += '<button type="button" class="htrk-' + S + '__abtn" data-htrk-cact="exchange">' + esc(T.retStartExchange) + '</button>';
      }
      if (cardCancel) h += '<button type="button" class="htrk-' + S + '__abtn htrk-' + S + '__abtn--stop" data-htrk-cact="cancel">' + esc(T.ocCancel) + '</button>';
      slot.innerHTML = h;
      slot.hidden = !h;
      var bs = slot.querySelectorAll('[data-htrk-cact]');
      for (var i = 0; i < bs.length; i++) {
        (function (b) {
          b.addEventListener('click', function () {
            var act = b.getAttribute('data-htrk-cact');
            if (act === 'cancel') openOrderCancel(b);
            else if (cardRet) {
              openFlowPop();
              renderRetForm(cardRet, act);
            }
          });
        })(bs[i]);
      }
      return true;
    }

    // CANCEL. Same policy and copy as the order page (sections/haki-order.
    // liquid): any order until it is being packed, whole order, refund or
    // store credit. PLM decides at the moment of asking and again on submit.
    //   Members → /apps/rewards/cancel (the App Proxy proves who they are).
    //   Guests  → PLM /track/cancel with order # + email, and the cancel itself
    //             ALWAYS behind the emailed 6-digit code (operator, 2026-09-29:
    //             "cancel should be allowed same as returns and exchanges via
    //             code auth"); PLM enforces that, the page just asks for it.
    var CANCEL_API = '' + C.proxy_base + '/cancel';
    var CANCEL_TRACK_API = API.replace(/\/track\/?$/, '/track/cancel');
    if (CANCEL_TRACK_API === API) CANCEL_TRACK_API = API.replace(/\/+$/, '') + '/cancel';
    var cardRefund = ''; // "$135.00", from PLM's answer to "can I cancel?"
    function cancelCall(orderNumber, action, method, formEl) {
      if (MEMBER_EMAIL) return cancelPost({ orderNumber: orderNumber, action: action, method: method });
      var p = { orderNumber: orderNumber, email: lastEmail, action: action };
      if (method) p.method = method;
      return action === 'get' ? postJson(CANCEL_TRACK_API, p) : changeFetch(CANCEL_TRACK_API, p, 'cancel', formEl);
    }
    function refundText(r) {
      if (!r || r.amount == null) return '';
      var n = Number(r.amount);
      if (!isFinite(n)) return '';
      var cur = String(r.currency || 'USD').toUpperCase();
      return cur === 'USD' ? '$' + n.toFixed(2) : n.toFixed(2) + ' ' + cur;
    }
    var OC = {
      title: 'Cancel this order?',
      refundTo: 'Refund to my original payment',
      credit: 'Store credit',
      creditNote: 'Spend it on anything, any time. It never expires.',
      fine: C.oc_fine,
      confirm: 'Cancel order',
      keep: 'Keep my order',
      done: "Your order is cancelled. We've emailed you a confirmation."
    };
    function cancelPost(payload) {
      return fetch(CANCEL_API, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(function (b) { return { status: r.status, body: b || {} }; }, function () { return { status: r.status, body: {} }; });
      });
    }
    // Asked once per lookup; a busy (429) or unreachable answer is asked once
    // more before the button stays away (#HS119557: a rate-limited check hid it).
    function checkOrderCancel(orderNumber, tries) {
      if (EMBED) return;
      var seq = ++cancelSeq;
      cancelCall(orderNumber, 'get').then(function (r) {
        if (seq !== cancelSeq) return;
        if ((r.status >= 500 || r.status === 429) && !tries) {
          setTimeout(function () { if (seq === cancelSeq) checkOrderCancel(orderNumber, 1); }, 2000);
          return;
        }
        cardCancel = !!(r.body && r.body.eligible === true);
        cardRefund = cardCancel ? refundText(r.body.refund) : '';
        fillCardActs();
      }, function () {});
    }
    function openOrderCancel(btn) {
      var box = retBox();
      if (!box) return;
      flow = null;
      openFlowPop();
      ocOpen = true;
      var head = document.getElementById('htrk-rethead-' + S + '');
      if (head) { head.textContent = OC.confirm; head.hidden = false; }
      var h = '<h3 class="htrk-' + S + '__stage">' + esc(OC.title) + '</h3>';
      // PLM's refund for THIS order, else this order's own total, else no figure.
      var back = cardRefund || ownTotal(cardTotal, lastOrder);
      if (back) h += '<p class="htrk-' + S + '__detail">You’ll get <b>' + esc(back) + '</b> back.</p>';
      h += '<div class="htrk-' + S + '__ropts" role="radiogroup">' +
        '<label class="htrk-' + S + '__ropt"><input type="radio" name="htrk-ocway-' + S + '" value="original" checked><span><strong>' + esc(OC.refundTo) + '</strong></span></label>' +
        '<label class="htrk-' + S + '__ropt"><input type="radio" name="htrk-ocway-' + S + '" value="store_credit"><span><strong>' + esc(OC.credit) + '</strong><small>' + esc(OC.creditNote) + '</small></span></label>' +
        '</div>';
      if (OC.fine) h += '<p class="htrk-' + S + '__cfine">' + esc(OC.fine) + '</p>';
      h += '<p class="htrk-' + S + '__aerr" id="htrk-ocerr-' + S + '" role="alert"></p>';
      h += '<button type="button" class="htrk-' + S + '__submit htrk-' + S + '__submit--a" id="htrk-ocgo-' + S + '">' + esc(OC.confirm) + '</button>';
      h += '<button type="button" class="htrk-' + S + '__abtn htrk-' + S + '__abtn--cancel" id="htrk-ockeep-' + S + '">' + esc(OC.keep) + '</button>';
      box.innerHTML = h;
      syncShipVis();
      afEl('ockeep').addEventListener('click', function () {
        ocOpen = false;
        if (head) head.hidden = true;
        applyRetAnswer(lastRet ? lastRet.body : null);
        if (!lastRet) { box.innerHTML = ''; syncShipVis(); }
        closeFlowPop(false);
      });
      var go = afEl('ocgo');
      var orderNumber = lastOrder;
      go.addEventListener('click', function () {
        var pick = box.querySelector('input[name="htrk-ocway-' + S + '"]:checked');
        var err = afEl('ocerr');
        go.disabled = true;
        go.textContent = 'Cancelling…';
        cancelCall(orderNumber, 'cancel', pick ? pick.value : 'original', box).then(function (res) {
          if (res.body && res.body.ok) {
            ocOpen = false;
            cardCancel = false;
            cardRet = null;
            fillCardActs();
            if (head) head.hidden = true;
            box.innerHTML = retNoteHtml('<p><b>' + esc(OC.done) + '</b></p>');
            syncShipVis();
            // Refresh the order so every line reads Cancelled.
            if (refreshCurrent) setTimeout(refreshCurrent, 1500);
            else setTimeout(function () {
              orderEl.value = orderNumber;
              emailEl.value = lastEmail;
              submitLookup();
            }, 1500);
            return;
          }
          if (err) err.textContent = (res.body && (res.body.error || res.body.message)) || 'We couldn’t cancel the order just now. Please try again in a moment.';
          go.disabled = false;
          go.textContent = OC.confirm;
        }, function () {
          if (err) err.textContent = 'We couldn’t reach our order system. Check your connection and try again.';
          go.disabled = false;
          go.textContent = OC.confirm;
        });
      });
    }

    function applyRetAnswer(body) {
      setRetHead();
      // Only a REAL answer is kept for the instant re-open. A rate-limit or
      // error body kept here made Return / Exchange look dead (2026-09-26):
      // the next tap re-showed the error, which draws nothing.
      var real = !!(body && typeof body.eligible === 'boolean');
      lastRet = real ? { order: String(lastOrder || orderEl.value || '').trim().toUpperCase(), at: Date.now(), body: body } : null;
      var box = retBox();
      if (!box || !body) return;
      var h = '';
      if (!real && (body.error || body.message)) {
        box.innerHTML = retNoteHtml(esc(body.error || body.message));
        syncShipVis();
        return;
      }
      if (body.existing && body.existing.length) h += renderExistingReturns(body.existing);
      cardRet = (body.eligible && body.items && body.items.length) ? body : null;
      var inCard = fillCardActs();
      if (cardRet && !inCard) {
        // JUST THE TWO BUTTONS (operator, 2026-09-28: the old combined
        // old returns chooser — intro line and all — is gone; only
        // the separate flows remain). Each button goes straight into its flow.
        // The order page skips even these and opens a flow directly.
        // With an order card on screen they live in the card instead
        // (fillCardActs); this is the fallback (the order-page pop-up).
        h += '<div class="htrk-' + S + '__rstarts">';
        h += '<button type="button" class="htrk-' + S + '__abtn" id="htrk-rstart-' + S + '">' + esc(T.retStartReturn) + '</button>';
        if (anyExchangeable(body)) h += '<button type="button" class="htrk-' + S + '__abtn" id="htrk-xstart-' + S + '">' + esc(T.retStartExchange) + '</button>';
        h += '</div>';
      } else if (body.eligible === false) {
        var hasExisting = !!(body.existing && body.existing.length);
        if (body.reason === 'not_us' && T.retNotUsHtml) h += retNoteHtml(T.retNotUsHtml);
        // With a return already showing, "nothing can be returned online" reads
        // as a contradiction; the return card says everything there is to say.
        else if (!hasExisting && (body.reason === 'final_sale' || body.reason === 'outside_window') && T.retAllExcludedHtml) h += retNoteHtml(T.retAllExcludedHtml);
      }
      box.innerHTML = h;
      var start = afEl('rstart');
      var xstart = afEl('xstart');
      if (start) start.addEventListener('click', function () { renderRetForm(body, 'return'); });
      if (xstart) xstart.addEventListener('click', function () { renderRetForm(body, 'exchange'); });
      syncShipVis();
      if (pendingFocus === 'return' || pendingFocus === 'exchange') {
        if (cardRet) {
          if (pendingFocus === 'exchange' && !anyExchangeable(body)) {
            // Nothing is in stock to exchange to: say so, and offer the return.
            box.innerHTML = retNoteHtml('<p>' + esc(T.exNone) + '</p>') +
              '<button type="button" class="htrk-' + S + '__abtn" id="htrk-rstart-' + S + '">' + esc(T.retStartReturn) + '</button>';
            afEl('rstart').addEventListener('click', function () { renderRetForm(body, 'return'); });
            syncShipVis();
          } else {
            renderRetForm(body, pendingFocus);
          }
        }
        // Not eligible: the note PLM sent (or nothing) is the honest answer.
        focusDone(retSec() || box);
      }
    }
    function retSec() { return document.getElementById('htrk-retsec-' + S + ''); }

    function retItemId(i, part) { return 'htrk-r' + part + i + '-' + S + ''; }

    // The return-label fee as PLM reports it (a number of dollars), filled into
    // copy that carries a [fee] placeholder. Remembered from the last answer
    // so the confirmation can say it too.
    var retFee = null;
    function feeText(template, fee) {
      var f = fee != null ? fee : retFee;
      var money = f != null && isFinite(f) ? '$' + Number(f).toFixed(2).replace(/\.00$/, '') : '';
      return String(template || '').replace('[fee]', money).replace(/\s*[-—]\s*$/, '');
    }

    // RETURN / EXCHANGE FLOWS (operator, 2026-09-26). Two step-by-step flows
    // in place of the one combined form, the same shape for both:
    //
    //   Exchange: 1 items + reason (5 reasons)  2 new size per item (in stock /
    //             out of stock)  3 review + disclaimer  -> Complete Exchange
    //   Return:   1 items + reason (all reasons)  2 refund or store credit?
    //             (skipped when every item is our fault)  3 review  -> Complete Return
    //
    // PLM decides everything again on submit (eligibility, sizes, fee, gift);
    // the page only collects the choices. The fee, the exchange reasons, the
    // fee-free (our fault) reasons and the return address all come from PLM's
    // answer, so the copy and the charge cannot drift.
    var flow = null; // { mode, step, body, picks: [{ on, reason, qty, note, swap }], want, gift }

    function reasonLabel(body, code) {
      var rs = body.reasons || [];
      for (var i = 0; i < rs.length; i++) if (rs[i].code === code) return rs[i].label;
      return code;
    }
    function flowReasons(body, mode) {
      var all = body.reasons || [];
      if (mode !== 'exchange' || !body.exchangeReasons) return all;
      var out = [];
      for (var i = 0; i < body.exchangeReasons.length; i++) {
        out.push({ code: body.exchangeReasons[i], label: reasonLabel(body, body.exchangeReasons[i]) });
      }
      return out;
    }
    function isFeeFree(body, reason) {
      var f = body.feeFreeReasons || [];
      for (var i = 0; i < f.length; i++) if (f[i] === reason) return true;
      return false;
    }
    function canExchange(it) {
      if (!it.swaps) return false;
      for (var i = 0; i < it.swaps.length; i++) if (it.swaps[i].available) return true;
      return false;
    }
    // What an item can go to, for the reason picked: the same size is hidden
    // for "Too small" / "Too large" (PLM refuses it too).
    function swapsFor(it, reason) {
      var out = [];
      var sizeWhy = reason === 'SIZE_TOO_SMALL' || reason === 'SIZE_TOO_LARGE';
      // A fit problem needs a different SIZE: the same size (in any colour,
      // or a one-size item's other colours) can't fix it.
      var mine = it.size || 'One size';
      for (var i = 0; i < (it.swaps || []).length; i++) {
        var sw = it.swaps[i];
        if (sizeWhy && (sw.same || sw.size === mine)) continue;
        out.push(sw);
      }
      return out;
    }
    function isSizeReason(code) { return code === 'SIZE_TOO_SMALL' || code === 'SIZE_TOO_LARGE'; }
    function hasAvail(list) {
      for (var i = 0; i < list.length; i++) if (list[i].available) return true;
      return false;
    }
    function swapById(list, id) {
      for (var i = 0; i < (list || []).length; i++) if (list[i].variantId === id) return list[i];
      return null;
    }
    // "M", "Burgundy · M", "Burgundy", "Same size (replacement)".
    function swapText(sw, it, inReview) {
      var one = sw.size === 'One size';
      if (sw.same) {
        if (inReview) return T.swapReplacement;
        return it.title + (one ? '' : ' · ' + sw.size);
      }
      if (sw.color && sw.color !== it.color) return one ? sw.color : sw.color + ' · ' + sw.size;
      return sw.size;
    }
    // Put the fee in and match the article to how it's read aloud: "an $8",
    // "an $11", "an $18", "an $80", but "a $10".
    function feeArticle(text, fee) {
      var whole = (String(fee).match(/\d+/) || [''])[0];
      var an = whole.charAt(0) === '8' || whole === '11' || whole === '18';
      return text.replace(/\b([Aa])n? \[fee\]/, function (m, a) { return (an ? a + 'n ' : a + ' ') + fee; }).replace('[fee]', fee);
    }
    function anyExchangeable(body) {
      var items = body.items || [];
      for (var i = 0; i < items.length; i++) if (canExchange(items[i])) return true;
      return false;
    }
    function ticked() {
      var out = [];
      var items = flow.body.items || [];
      for (var i = 0; i < items.length; i++) if (flow.picks[i] && flow.picks[i].on) out.push(i);
      return out;
    }
    // Every ticked item is our fault: no fee, and a return skips step 2.
    // "Return-label fee waived once we confirm …" for an our-fault reason, else ''.
    function feeWaivedText(reason) {
      if (!reason || !isFeeFree(flow.body, reason)) return '';
      return T.feeWaived[reason] || T.feeWaivedOther;
    }
    function allFeeFree() {
      var t = ticked();
      if (!t.length) return false;
      for (var i = 0; i < t.length; i++) if (!isFeeFree(flow.body, flow.picks[t[i]].reason)) return false;
      return true;
    }
    function anyFeeFree() {
      var t = ticked();
      for (var i = 0; i < t.length; i++) if (isFeeFree(flow.body, flow.picks[t[i]].reason)) return true;
      return false;
    }
    // The gift question is its own step, on a RETURN taken as a REFUND that
    // takes the order under the spend that earned a gift (operator,
    // 2026-09-26). Never on an exchange (the order keeps its value), never on
    // store credit (the gift is kept free), never when something is our fault
    // (PLM exempts the gift then), never for the socks (not in body.gift).
    function giftStepNeeded() {
      return flow.mode === 'return' && flow.want === 'refund' && !anyFeeFree() && giftBreaks();
    }
    function stepsList() {
      var l = ['items'];
      if (flow.mode === 'exchange') l.push('size');
      else {
        // Always asked, our fault included: they may simply prefer store
        // credit (operator, 2026-09-28).
        l.push('want');
        // The shipping step only explains a refund's label fee (+ own label):
        // skipped for store credit (free) and when everything is our fault.
        if (flow.want !== 'credit' && !allFeeFree()) l.push('ship');
      }
      if (giftStepNeeded()) l.push('gift');
      l.push('review');
      return l;
    }
    function stepLabel(key) {
      var l = stepsList();
      var n = 0;
      for (var i = 0; i < l.length; i++) if (l[i] === key) n = i + 1;
      return String(T.stepOf || 'Step [n] of [total]').replace('[n]', n).replace('[total]', l.length);
    }
    function stepHead(key, title) {
      return '<p class="htrk-' + S + '__rstep" id="htrk-rstepn-' + S + '">' + esc(stepLabel(key)) + '</p>' +
             '<h3 class="htrk-' + S + '__rtitle" tabindex="-1" id="htrk-rtitle-' + S + '">' + esc(title) + '</h3>';
    }
    function flowDone() {
      initDropdowns(retBox());
      syncShipVis();
      updateScrollShadows();
      var t = document.getElementById('htrk-rtitle-' + S + '');
      if (t) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
      var sec = retSec();
      if (sec && sec.scrollIntoView && grid && grid.parentNode && grid.parentNode.classList.contains('is-modal')) {
        try { sec.scrollIntoView({ block: 'start' }); } catch (e2) {}
      }
    }
    // (The "buy your own return label" option was removed 2026-09-28, operator.)
    function itemLine(i, withSwap) {
      var it = flow.body.items[i];
      var p = flow.picks[i];
      var h = esc(cleanTitle(it.title));
      if (withSwap && p.swap) {
        var to = '';
        var sw = swapById(it.swaps, p.swap);
        if (sw && sw.same) {
          // "Chain User Tee — L (replacement)", "Rain Dinners Hat — replacement".
          h += ' - ' + (it.size ? esc(it.size) + ' (' + esc(T.swapReplacement) + ')' : esc(T.swapReplacement));
        } else {
          if (sw) to = swapText(sw, it, true);
          h += ' - ' + (it.size ? esc(it.size) + ' &rarr; ' : '') + esc(to);
        }
      } else if (it.size) {
        h += ' - ' + esc(it.size);
      }
      if (p.qty > 1) h += ' &times; ' + esc(p.qty);
      return '<li>' + h + '</li>';
    }

    // ---------------------------------------------------------------------
    // RETURN PHOTOS. PLM says which reasons ask for them (photoReasons) and
    // whether it will insist (photosRequired). Each photo is shrunk to
    // ≤1600px JPEG here — a phone photo is 3–10 MB, and re-drawing it drops
    // the EXIF (location) — then uploaded on its own; the return carries ids.
    // ---------------------------------------------------------------------
    function wantsPhotos(reason) {
      var r = flow && flow.body && flow.body.photoReasons;
      if (!reason || !r) return false;
      for (var i = 0; i < r.length; i++) if (r[i] === reason) return true;
      return false;
    }
    function maxPhotos() { return (flow && flow.body && flow.body.maxPhotos) || 3; }
    function photosInner(i) {
      var p = flow.picks[i];
      var lab = (T.photoLabel && T.photoLabel[p.reason]) || T.photoLabelOther;
      var rule = String(flow.body.photosRequired ? T.photoReq : T.photoOpt).replace('[max]', maxPhotos());
      var h = '<span class="htrk-' + S + '__label">' + esc(lab) + ' <small>' + esc(rule) + '</small></span><div class="htrk-' + S + '__pgrid">';
      for (var k = 0; k < p.photos.length; k++) {
        h += '<span class="htrk-' + S + '__pthumb"><img src="' + esc(p.photos[k].thumb) + '" alt="">' +
             '<button type="button" data-pdel="' + k + '" aria-label="' + esc(T.photoRemove) + '">&times;</button></span>';
      }
      for (var u = 0; u < p.uploading; u++) h += '<span class="htrk-' + S + '__pthumb is-busy" aria-label="' + esc(T.photoBusy) + '"></span>';
      if (p.photos.length + p.uploading < maxPhotos()) {
        h += '<label class="htrk-' + S + '__padd"><input type="file" id="' + retItemId(i, 'pfile') + '" accept="image/*" multiple>' +
             '<span>+ ' + esc(T.photoAdd) + '</span></label>';
      }
      h += '</div><p class="htrk-' + S + '__rhint" id="' + retItemId(i, 'perr') + '" role="alert" hidden></p>';
      return h;
    }
    function redrawPhotos(i) {
      var box = document.getElementById(retItemId(i, 'photos'));
      if (!box) return;
      box.innerHTML = photosInner(i);
      wirePhotos(i);
    }
    function photoError(i, text) {
      var e = document.getElementById(retItemId(i, 'perr'));
      if (e) { e.textContent = text; e.hidden = !text; }
    }
    function wirePhotos(i) {
      var box = document.getElementById(retItemId(i, 'photos'));
      if (!box) return;
      var dels = box.querySelectorAll('[data-pdel]');
      for (var d = 0; d < dels.length; d++) {
        dels[d].addEventListener('click', function (ev) {
          flow.picks[i].photos.splice(parseInt(ev.currentTarget.getAttribute('data-pdel'), 10), 1);
          redrawPhotos(i);
        });
      }
      var file = document.getElementById(retItemId(i, 'pfile'));
      if (file) file.addEventListener('change', function () {
        var p = flow.picks[i];
        var room = maxPhotos() - p.photos.length - p.uploading;
        var files = Array.prototype.slice.call(file.files || [], 0, Math.max(0, room));
        photoError(i, '');
        files.forEach(function (f) {
          if (f.type && f.type.indexOf('image/') !== 0) { photoError(i, T.photoNotImage); return; }
          p.uploading++;
          shrinkPhoto(f)
            .then(function (dataUrl) {
              var payload = { orderNumber: lastOrder, email: lastEmail, image: dataUrl };
              return changeFetch(PHOTO_API, payload, 'return', afEl('rform')).then(function (r) {
                if (r.body && r.body.photoId) return { id: r.body.photoId, thumb: dataUrl };
                throw new Error((r.body && r.body.error) || T.photoFail);
              });
            })
            .then(function (ph) {
              if (flow && flow.picks[i] === p) p.photos.push(ph);
              // The step's "add a photo" warning is answered now.
              var re = afEl('rerr');
              if (re && re.textContent === T.photoNeed) re.textContent = '';
            }, function (e) {
              photoError(i, e && e.message ? e.message : T.photoFail);
            })
            .then(function () {
              p.uploading--;
              if (flow && flow.picks[i] === p) { redrawPhotos(i); if (p.uploading === 0 && p.photos.length) photoError(i, ''); }
            });
        });
        redrawPhotos(i);
      });
    }
    function shrinkPhoto(file) {
      return new Promise(function (resolve, reject) {
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          var max = 1600;
          var w = img.naturalWidth, h = img.naturalHeight;
          var k = Math.min(1, max / Math.max(w, h));
          var c = document.createElement('canvas');
          c.width = Math.max(1, Math.round(w * k));
          c.height = Math.max(1, Math.round(h * k));
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          URL.revokeObjectURL(url);
          try { resolve(c.toDataURL('image/jpeg', 0.85)); } catch (e) { reject(e); }
        };
        img.onerror = function () { URL.revokeObjectURL(url); reject(new Error(T.photoNotImage)); };
        img.src = url;
      });
    }

    function renderRetForm(body, mode) {
      // want starts empty: neither option is pre-picked (operator, 2026-09-26).
      flow = { mode: mode === 'exchange' ? 'exchange' : 'return', step: 1, body: body, picks: [], want: '', gift: null };
      setRetHead();
      retFee = body.fee != null ? Number(body.fee) : null;
      var items = body.items || [];
      for (var i = 0; i < items.length; i++) flow.picks.push({ on: false, reason: '', qty: 1, note: '', swap: '', photos: [], uploading: 0 });
      renderStep1();
    }

    // STEP 1: which items, and why.
    function renderStep1() {
      var box = retBox();
      if (!box) return;
      flow.step = 1;
      var ex = flow.mode === 'exchange';
      var items = flow.body.items || [];
      var reasons = flowReasons(flow.body, flow.mode);
      var h = '<form class="htrk-' + S + '__line htrk-' + S + '__aform" id="htrk-rform-' + S + '" novalidate>';
      h += stepHead('items', ex ? T.exStep1 : T.retStep1);
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var p = flow.picks[i];
        var off = ex && !canExchange(it);
        h += '<div class="htrk-' + S + '__ritem' + (p.on ? ' is-on' : '') + (off ? ' is-off' : '') + '" id="' + retItemId(i, 'row') + '">';
        h += '<input type="checkbox" id="' + retItemId(i, 'on') + '" data-key="' + esc(it.key) + '"' + (p.on ? ' checked' : '') + (off ? ' disabled' : '') + '>';
        h += '<label class="htrk-' + S + '__ritem-name" for="' + retItemId(i, 'on') + '">' + esc(cleanTitle(it.title));
        var small = [];
        if (it.size) small.push('Size ' + esc(it.size));
        if (it.quantity > 1) small.push('Qty ' + esc(it.quantity));
        if (off) small.push(esc(it.swaps && it.swaps.length ? T.exNoStock : T.exNoOptions));
        if (small.length) h += '<small>' + small.join(' &middot; ') + '</small>';
        h += '</label>';
        h += '<div class="htrk-' + S + '__ritem-opts">';
        var opts = [];
        var itReasons = reasonsForItem(flow.body, it, reasons);
        for (var r = 0; r < itReasons.length; r++) {
          // Exchange: "Size was too small / large" only when another size or
          // colour is actually in stock — the same size is hidden for those,
          // so a one-size hat would get an empty list (operator, 2026-09-28).
          if (ex && isSizeReason(itReasons[r].code) && !hasAvail(swapsFor(it, itReasons[r].code))) continue;
          opts.push({ value: itReasons[r].code, label: itReasons[r].label });
        }
        if (it.finalSale && p.reason && !finalSaleAllows(flow.body, p.reason)) p.reason = '';
        h += finalSaleHintHtml(flow.body, it, retItemId(i, 'fshint'), 'htrk-' + S + '__rhint');
        if (ex && p.reason && isSizeReason(p.reason) && !hasAvail(swapsFor(it, p.reason))) p.reason = '';
        h += '<div class="htrk-' + S + '__field"><span class="htrk-' + S + '__label" id="' + retItemId(i, 'whylbl') + '">' + esc(T.retReason) + '</span>' +
             ddHtml(retItemId(i, 'why'), opts, T.retChooseReason, p.reason, retItemId(i, 'whylbl')) +
             '<p class="htrk-' + S + '__rhint" id="' + retItemId(i, 'hint') + '"' + (feeWaivedText(p.reason) ? '' : ' hidden') + '>' + esc(feeWaivedText(p.reason)) + '</p></div>';
        h += '<div class="htrk-' + S + '__field htrk-' + S + '__rphotos" id="' + retItemId(i, 'photos') + '"' + (wantsPhotos(p.reason) ? '' : ' hidden') + '>' + photosInner(i) + '</div>';
        if (it.quantity > 1) {
          var qtyOpts = [];
          for (var q = 1; q <= it.quantity; q++) qtyOpts.push({ value: String(q), label: String(q) });
          h += '<div class="htrk-' + S + '__field"><span class="htrk-' + S + '__label" id="' + retItemId(i, 'qtylbl') + '">How many</span>' +
               ddHtml(retItemId(i, 'qty'), qtyOpts, '1', String(p.qty || 1), retItemId(i, 'qtylbl')) + '</div>';
        }
        h += '<label class="htrk-' + S + '__field"><span class="htrk-' + S + '__label">' + esc(T.retNote) + '</span>' +
             '<input type="text" id="' + retItemId(i, 'note') + '" maxlength="300" value="' + esc(p.note) + '"></label>';
        h += '</div></div>';
      }
      if (flow.body.excluded && flow.body.excluded.length) {
        var exl = [];
        for (var e = 0; e < flow.body.excluded.length; e++) {
          var x = flow.body.excluded[e];
          exl.push(esc(cleanTitle(x.title)) + (x.size ? ' (' + esc(x.size) + ')' : '') + ' - ' + esc(x.why === 'final_sale' ? T.retFinalSale : T.retLate));
        }
        h += '<div class="htrk-' + S + '__rexcl"><p>Not eligible: ' + exl.join('; ') + '</p></div>';
      }
      if (!ex && flow.body.keptGifts && flow.body.keptGifts.length) {
        var kept = [];
        for (var kg = 0; kg < flow.body.keptGifts.length; kg++) kept.push(esc(flow.body.keptGifts[kg]));
        h += '<div class="htrk-' + S + '__rkept"><p>' + kept.join(', ') + ' - ' + esc(T.retKeptGift) + '</p></div>';
      }
      h += '<p class="htrk-' + S + '__aerr" id="htrk-rerr-' + S + '" role="alert"></p>';
      h += '<button type="submit" class="htrk-' + S + '__submit htrk-' + S + '__submit--a" id="htrk-rsend-' + S + '">' + esc(ex ? T.exStart : T.retSubmit) + '</button>';
      h += '<button type="button" class="htrk-' + S + '__abtn htrk-' + S + '__abtn--cancel" id="htrk-rcancel-' + S + '">' + esc(T.cancel) + '</button>';
      h += '</form>';
      box.innerHTML = h;
      // The reason picker is described by its final-sale line and by the
      // waived-fee line under it (that one only reads when it is showing).
      for (var d = 0; d < items.length; d++) {
        var whyBtn = ddTrigger(retItemId(d, 'why'));
        if (!whyBtn) continue;
        var desc = [];
        if (document.getElementById(retItemId(d, 'fshint'))) desc.push(retItemId(d, 'fshint'));
        desc.push(retItemId(d, 'hint'));
        whyBtn.setAttribute('aria-describedby', desc.join(' '));
      }
      for (var j = 0; j < items.length; j++) {
        (function (idx) {
          var on = document.getElementById(retItemId(idx, 'on'));
          var row = document.getElementById(retItemId(idx, 'row'));
          if (!on || !row) return;
          // The waived-fee line follows the reason as it changes.
          var whyIn = document.getElementById(retItemId(idx, 'why'));
          var hint = document.getElementById(retItemId(idx, 'hint'));
          if (whyIn && hint) whyIn.addEventListener('change', function () {
            var txt = feeWaivedText(whyIn.value);
            hint.textContent = txt;
            hint.hidden = !txt;
            // The photo picker follows the reason too.
            flow.picks[idx].reason = trimStr(whyIn.value);
            var ph = document.getElementById(retItemId(idx, 'photos'));
            if (ph) { ph.hidden = !wantsPhotos(whyIn.value); if (!ph.hidden) { ph.innerHTML = photosInner(idx); wirePhotos(idx); } }
          });
          wirePhotos(idx);
          on.addEventListener('change', function () {
            if (on.checked) row.classList.add('is-on'); else row.classList.remove('is-on');
            updateScrollShadows();
          });
        })(j);
      }
      afEl('rform').addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (readStep1()) renderStep2();
      });
      afEl('rcancel').addEventListener('click', function () {
        flow = null;
        applyRetAnswer(lastRet ? lastRet.body : null);
        // Opened straight into this flow from the order page's Return /
        // Exchange button: Cancel closes the pop-up (operator, 2026-09-28 — it
        // left the old returns chooser open). On the track page it
        // goes back to that chooser, as before.
        if (flowCancelHook) flowCancelHook();
      });
      flowDone();
    }
    function readStep1() {
      var items = flow.body.items || [];
      var firstBad = null;
      var photoErr = '';
      var reasonMissing = false;
      var any = false;
      for (var i = 0; i < items.length; i++) {
        var p = flow.picks[i];
        var on = document.getElementById(retItemId(i, 'on'));
        p.on = !!(on && on.checked && !on.disabled);
        var why = document.getElementById(retItemId(i, 'why'));
        p.reason = why ? trimStr(why.value) : '';
        var qty = document.getElementById(retItemId(i, 'qty'));
        p.qty = qty ? (parseInt(qty.value, 10) || 1) : 1;
        var note = document.getElementById(retItemId(i, 'note'));
        p.note = note ? trimStr(note.value) : '';
        if (!p.on) continue;
        any = true;
        var whyBtn = ddTrigger(retItemId(i, 'why'));
        if (whyBtn) { if (p.reason) whyBtn.classList.remove('is-invalid'); else whyBtn.classList.add('is-invalid'); }
        if (!p.reason) reasonMissing = true;
        if (!p.reason && !firstBad) firstBad = whyBtn || why;
        if (p.reason && wantsPhotos(p.reason)) {
          if (p.uploading > 0) photoErr = photoErr || T.photoWait;
          else if (flow.body.photosRequired && p.photos.length === 0) {
            photoErr = photoErr || T.photoNeed;
            if (!firstBad) firstBad = document.getElementById(retItemId(i, 'pfile'));
          }
        }
      }
      var err = afEl('rerr');
      if (!any || firstBad || photoErr) {
        if (err) err.textContent = !any || reasonMissing || !photoErr ? T.retPick : photoErr;
        if (firstBad) firstBad.focus();
        return false;
      }
      if (err) err.textContent = '';
      return true;
    }

    // STEP 2, exchange: the new size for each item. Out of stock stays listed,
    // greyed. Next unlocks once every item has one.
    // STEP 2, return: refund or store credit (skipped when all are our fault).
    function renderStep2() {
      var box = retBox();
      if (!box) return;
      flow.step = 2;
      var ex = flow.mode === 'exchange';
      var t = ticked();
      var h = '<form class="htrk-' + S + '__line htrk-' + S + '__aform" id="htrk-rform-' + S + '" novalidate>';
      if (ex) {
        h += stepHead('size', T.exStep2);
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          var it = flow.body.items[i];
          var opts = [];
          var shown = swapsFor(it, flow.picks[i].reason);
          for (var k = 0; k < shown.length; k++) {
            var sw = shown[k];
            opts.push({ value: sw.variantId, label: swapText(sw, it) + ' - ' + (sw.available ? T.inStock : T.outOfStock), disabled: !sw.available });
          }
          // A pick the reason now hides (changed to "Too small") is dropped.
          if (flow.picks[i].swap && !swapById(shown, flow.picks[i].swap)) flow.picks[i].swap = null;
          h += '<div class="htrk-' + S + '__rsize">';
          h += '<p class="htrk-' + S + '__ritem-name">' + esc(cleanTitle(it.title)) + (it.size ? '<small>' + esc(T.currentSize).replace('[size]', esc(it.size)) + '</small>' : '') + '</p>';
          h += '<div class="htrk-' + S + '__field"><span class="htrk-' + S + '__label" id="' + retItemId(i, 'swaplbl') + '">' + esc(T.newSize) + '</span>' +
               ddHtml(retItemId(i, 'swap'), opts, T.chooseSize, flow.picks[i].swap, retItemId(i, 'swaplbl')) + '</div>';
          h += '</div>';
        }
      } else {
        h += stepHead('want', T.retStep2);
        // "$8" from PLM's fee; without a figure, say a fee applies rather than
        // print an empty "( return-label)".
        var feeFig = feeText('[fee]');
        // Our fault: both options ship free, so "(free return shipping)" says
        // nothing — only the bonus is called out (operator, 2026-09-28).
        var ourFault = allFeeFree();
        var refundHint = ourFault ? '' : feeFig ? String(T.optRefundHint).replace('[fee]', feeFig) : T.optRefundHintNoFee;
        var creditHint = creditBonus()
          ? String(ourFault ? T.optCreditHintBonusOnly : T.optCreditHintBonus).replace('[bonus]', money(creditBonus()))
          : (ourFault ? '' : T.optCreditHint);
        // Refund first, store credit second, nothing pre-picked (operator,
        // 2026-09-26): store credit should read as the better offer, not as
        // the default.
        h += '<div class="htrk-' + S + '__ropts" role="radiogroup">';
        h += '<label class="htrk-' + S + '__ropt"><input type="radio" name="htrk-rwant-' + S + '" value="refund"' + (flow.want === 'refund' ? ' checked' : '') + '>' +
             '<span><strong>' + esc(T.optRefund) + ' <em class="htrk-' + S + '__ropt-hint">' + esc(refundHint) + '</em></strong><small>' + esc(T.optRefundSub) + '</small></span></label>';
        h += '<label class="htrk-' + S + '__ropt"><input type="radio" name="htrk-rwant-' + S + '" value="credit"' + (flow.want === 'credit' ? ' checked' : '') + '>' +
             '<span><strong>' + esc(T.optCredit) + ' <em class="htrk-' + S + '__ropt-hint">' + esc(creditHint) + '</em></strong><small>' + esc(creditLine(T.optCreditSubAmt, T.optCreditSub, T.optCreditSubAmtBonus, T.optCreditSubBonus)) + '</small></span></label>';
        h += '</div>';
      }
      h += '<p class="htrk-' + S + '__aerr" id="htrk-rerr-' + S + '" role="alert"></p>';
      h += '<button type="submit" class="htrk-' + S + '__submit htrk-' + S + '__submit--a" id="htrk-rsend-' + S + '">' + esc(T.next) + '</button>';
      h += '<button type="button" class="htrk-' + S + '__abtn htrk-' + S + '__abtn--cancel" id="htrk-rback-' + S + '">' + esc(T.back) + '</button>';
      h += '</form>';
      box.innerHTML = h;

      var send = afEl('rsend');
      if (ex) {
        var sync = function () {
          var all = true;
          for (var n2 = 0; n2 < t.length; n2++) {
            var inp = document.getElementById(retItemId(t[n2], 'swap'));
            if (!inp || !inp.value) all = false;
          }
          send.disabled = !all;
        };
        for (var n3 = 0; n3 < t.length; n3++) {
          var inp2 = document.getElementById(retItemId(t[n3], 'swap'));
          if (inp2) inp2.addEventListener('change', sync);
        }
        sync();
      } else {
        // The step count can change with the choice (a refund may add the
        // gift step), so the "Step 2 of N" line follows it.
        var radios = document.getElementsByName('htrk-rwant-' + S + '');
        var syncWant = function () {
          readWant();
          var sn = afEl('rstepn');
          if (sn) sn.textContent = stepLabel('want');
          send.disabled = !flow.want; // nothing pre-picked: Next waits for a choice
        };
        for (var r = 0; r < radios.length; r++) radios[r].addEventListener('change', syncWant);
        syncWant();
      }
      afEl('rform').addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (ex) {
          for (var n4 = 0; n4 < t.length; n4++) {
            var inp3 = document.getElementById(retItemId(t[n4], 'swap'));
            flow.picks[t[n4]].swap = inp3 ? inp3.value : '';
            if (!flow.picks[t[n4]].swap) return;
          }
          giftStepNeeded() ? renderGiftStep() : renderStep3();
        } else {
          readWant();
          if (!flow.want) return;
          if (flow.want === 'credit' || allFeeFree()) giftStepNeeded() ? renderGiftStep() : renderStep3();
          else renderShipStep();
        }
      });
      afEl('rback').addEventListener('click', function () {
        if (ex) {
          for (var n5 = 0; n5 < t.length; n5++) {
            var inp4 = document.getElementById(retItemId(t[n5], 'swap'));
            if (inp4) flow.picks[t[n5]].swap = inp4.value;
          }
        } else { readWant(); }
        renderStep1();
      });
      flowDone();
    }
    function readWant() {
      var radios = document.getElementsByName('htrk-rwant-' + S + '');
      for (var r = 0; r < radios.length; r++) if (radios[r].checked) flow.want = radios[r].value;
    }
    // The gift policy, in money: send it back in its original condition (nothing
    // to pay) or keep it and half its retail comes off the refund. Same sum
    // the server does on submit; the server is the authority.
    function giftBreaks() {
      var g = flow.body.gift;
      if (!g) return false;
      var t = ticked();
      var leaving = 0;
      for (var n = 0; n < t.length; n++) {
        var it = flow.body.items[t[n]];
        var per = g.breaksIf ? g.breaksIf[it.key] : null;
        if (per != null && isFinite(per)) leaving += Number(per) * (flow.picks[t[n]].qty || 1);
      }
      return t.length > 0 && Number(g.basis) - leaving < Number(g.threshold);
    }
    function money(v) { return '$' + Number(v).toFixed(2).replace(/\.00$/, ''); }
    // The store credit the ticked items come to: price paid after discounts
    // plus tax, per unit, times the quantity going back. null when any item
    // has no price (an older PLM), so the copy never shows a partial sum.
    function creditTotal() {
      var t = ticked();
      var sum = 0;
      for (var n = 0; n < t.length; n++) {
        var it = flow.body.items[t[n]];
        if (!it || typeof it.unitPaid !== 'number') return null;
        sum += it.unitPaid * (flow.picks[t[n]].qty || 1);
      }
      return t.length ? Math.round(sum * 100) / 100 : null;
    }
    // The our-fault bonus in $, or 0: PLM's creditBonus, only when a ticked
    // item arrived damaged / wrong (the same test PLM pays on).
    function creditBonus() {
      var b = Number(flow && flow.body && flow.body.creditBonus) || 0;
      // PLM pays the bonus only on top of a real credit: a $0 order gets none.
      return b > 0 && anyFeeFree() && creditTotal() !== 0 ? b : 0;
    }
    function creditLine(withAmount, plain, withAmountBonus, plainBonus) {
      var c = creditTotal();
      var b = creditBonus();
      var t = c != null && c > 0 ? (b ? withAmountBonus : withAmount) : (b ? plainBonus : plain);
      return String(t).replace('[amount]', c != null ? '$' + c.toFixed(2) : '').replace('[bonus]', money(b));
    }
    function giftKeepText() {
      var g = flow.body.gift;
      // No figure unless PLM gave one: an unrecorded retail must never read "$0".
      return g.deduction != null ? String(T.giftKeepSub).replace('[amount]', money(g.deduction)) : T.giftKeepSubNoAmount;
    }

    // RETURN SHIPPING (return mode; its own step since 2026-09-28 — the money
    // choice no longer talks about labels). Refund: the label fee, and the
    // option to buy their own label. Store credit: free. Skipped entirely when
    // every item is our fault (shipping is on us; the review says so).
    function renderShipStep() {
      var box = retBox();
      if (!box) return;
      flow.step = 'ship';
      var credit = flow.want === 'credit';
      var fee = feeText('[fee]');
      var h = '<form class="htrk-' + S + '__line htrk-' + S + '__aform" id="htrk-rform-' + S + '" novalidate>';
      h += stepHead('ship', T.retShipTitle);
      h += '<p class="htrk-' + S + '__detail">' + esc(credit ? T.shipCredit : feeArticle(String(anyFeeFree() ? T.shipRefundMixed : T.shipRefund), fee)) + '</p>';
      h += '<p class="htrk-' + S + '__aerr" id="htrk-rerr-' + S + '" role="alert"></p>';
      h += '<button type="submit" class="htrk-' + S + '__submit htrk-' + S + '__submit--a" id="htrk-rsend-' + S + '">' + esc(T.next) + '</button>';
      h += '<button type="button" class="htrk-' + S + '__abtn htrk-' + S + '__abtn--cancel" id="htrk-rback-' + S + '">' + esc(T.back) + '</button>';
      h += '</form>';
      box.innerHTML = h;
      afEl('rform').addEventListener('submit', function (ev) { ev.preventDefault(); giftStepNeeded() ? renderGiftStep() : renderStep3(); });
      afEl('rback').addEventListener('click', function () { renderStep2(); });
      flowDone();
    }

    // STEP 3 (return, refund, under the threshold): the free gift.
    function renderGiftStep() {
      var box = retBox();
      if (!box) return;
      flow.step = 'gift';
      var g = flow.body.gift;
      var h = '<form class="htrk-' + S + '__line htrk-' + S + '__aform" id="htrk-rform-' + S + '" novalidate>';
      h += stepHead('gift', String(T.giftStepTitle).replace('[label]', g.label || ''));
      h += '<p class="htrk-' + S + '__detail">' + esc(String(T.giftStepIntro).replace('[label]', g.label || '').replace('[threshold]', money(g.threshold))) + '</p>';
      h += '<div class="htrk-' + S + '__ropts" role="radiogroup">';
      h += '<label class="htrk-' + S + '__ropt"><input type="radio" name="htrk-rgiftc-' + S + '" value="send_back"' + (flow.gift === 'send_back' ? ' checked' : '') + '>' +
           '<span><strong>' + esc(T.giftSendTitle) + '</strong><small>' + esc(T.giftSendSub) + '</small></span></label>';
      h += '<label class="htrk-' + S + '__ropt"><input type="radio" name="htrk-rgiftc-' + S + '" value="keep"' + (flow.gift === 'keep' ? ' checked' : '') + '>' +
           '<span><strong>' + esc(T.giftKeepTitle) + '</strong><small>' + esc(giftKeepText()) + '</small></span></label>';
      h += '</div>';
      h += '<p class="htrk-' + S + '__rsmall">' + esc(T.giftCreditHint) + '</p>';
      h += '<p class="htrk-' + S + '__aerr" id="htrk-rerr-' + S + '" role="alert"></p>';
      h += '<button type="submit" class="htrk-' + S + '__submit htrk-' + S + '__submit--a" id="htrk-rsend-' + S + '">' + esc(T.next) + '</button>';
      h += '<button type="button" class="htrk-' + S + '__abtn htrk-' + S + '__abtn--cancel" id="htrk-rback-' + S + '">' + esc(T.back) + '</button>';
      h += '</form>';
      box.innerHTML = h;
      // Money is involved: nothing is pre-picked, Next waits for a choice.
      var send = afEl('rsend');
      var rg = document.getElementsByName('htrk-rgiftc-' + S + '');
      var read = function () {
        flow.gift = null;
        for (var i = 0; i < rg.length; i++) if (rg[i].checked) flow.gift = rg[i].value;
        send.disabled = !flow.gift;
      };
      for (var k = 0; k < rg.length; k++) rg[k].addEventListener('change', read);
      read();
      afEl('rform').addEventListener('submit', function (ev) { ev.preventDefault(); read(); if (flow.gift) renderStep3(); });
      afEl('rback').addEventListener('click', function () { read(); stepsList().indexOf('ship') >= 0 ? renderShipStep() : renderStep2(); });
      flowDone();
    }

    // STEP 3: what they are sending, what it costs, and the button.
    function renderStep3() {
      var box = retBox();
      if (!box) return;
      flow.step = 3;
      var ex = flow.mode === 'exchange';
      var t = ticked();
      var free = allFeeFree();
      // (Our-fault returns used to be forced to a refund here; they now pick on step 2.)
      var fee = feeText('[fee]');
      var h = '<form class="htrk-' + S + '__line htrk-' + S + '__aform" id="htrk-rform-' + S + '" novalidate>';
      h += stepHead('review', ex ? T.exStep3 : T.retStep3);
      h += '<p class="htrk-' + S + '__detail" style="margin:0 0 6px">' + esc(ex ? T.exYouAre : T.retYouAre) + '</p>';
      h += '<ul class="htrk-' + S + '__rlist">';
      for (var n = 0; n < t.length; n++) h += itemLine(t[n], ex);
      h += '</ul>';
      var lines = [];
      if (ex) {
        lines.push(free ? T.exFree : String(T.exDisclaimer).replace('[fee]', fee));
      } else if (flow.want === 'credit') {
        lines.push(creditLine(T.retSumCreditAmt, T.retSumCredit, T.retSumCreditAmtBonus, T.retSumCreditBonus));
      } else {
        lines.push(free ? T.retSumRefundFree : feeArticle(String(T.retSumRefund), fee));
      }
      // The gift outcome, said once more before they commit.
      if (giftStepNeeded()) {
        lines.push(String(flow.gift === 'keep' ? T.giftSumKeep : T.giftSumSend).replace('[label]', flow.body.gift.label || '').replace('[keep]', giftKeepText()));
      } else if (!ex && flow.want === 'credit' && !anyFeeFree() && giftBreaks()) {
        lines.push(String(T.retGiftCredit || '').replace('[label]', flow.body.gift.label || ''));
      }
      for (var l = 0; l < lines.length; l++) if (lines[l]) h += '<p class="htrk-' + S + '__detail">' + esc(lines[l]) + '</p>';
      h += '<p class="htrk-' + S + '__aerr" id="htrk-rerr-' + S + '" role="alert"></p>';
      h += '<button type="submit" class="htrk-' + S + '__submit htrk-' + S + '__submit--a" id="htrk-rsend-' + S + '">' + esc(ex ? T.exComplete : T.retComplete) + '</button>';
      h += '<button type="button" class="htrk-' + S + '__abtn htrk-' + S + '__abtn--cancel" id="htrk-rback-' + S + '">' + esc(T.back) + '</button>';
      h += '</form>';
      box.innerHTML = h;
      afEl('rform').addEventListener('submit', function (ev) { ev.preventDefault(); submitFlow(); });
      afEl('rback').addEventListener('click', function () {
        if (giftStepNeeded()) renderGiftStep();
        else if (!ex && stepsList().indexOf('ship') >= 0) renderShipStep();
        else renderStep2();
      });
      flowDone();
    }

    function submitFlow() {
      var ex = flow.mode === 'exchange';
      var t = ticked();
      var lines = [];
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        var p = flow.picks[i];
        var line = { key: flow.body.items[i].key, reason: p.reason, quantity: p.qty || 1, want: ex ? 'swap' : flow.want };
        if (ex) line.swapVariantId = p.swap;
        if (p.note) line.note = p.note;
        if (wantsPhotos(p.reason) && p.photos.length) line.photoIds = p.photos.map(function (ph) { return ph.id; });
        lines.push(line);
      }
      // Only a choice they were actually asked for; store credit and our-fault
      // returns keep the gift without asking (PLM decides that again).
      var giftChoice = giftStepNeeded() ? flow.gift : null;
      submitReturn(lines, giftChoice, ex ? T.exComplete : T.retComplete);
    }

    // ---------------------------------------------------------------------
    // CONFIRMING IT'S THEM. PLM asks for proof before a guest CHANGES an order
    // (return / exchange / address) once TRACK_REQUIRE_VERIFY is on: it
    // answers 403 { verify: 'required' }. Then a signed-in member gets a pass
    // from the App Proxy (they're already proven), and a guest gets a 6-digit
    // code by email, typed into a box inside the form. The change is then
    // re-sent with the pass. With the switch off nothing asks, so this page
    // works either way. A pass lasts 30 minutes and is reused within that time.
    // ---------------------------------------------------------------------
    var passes = {};
    function postJson(url, data) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
        .then(function (res) {
          return res.json().then(function (b) { return { status: res.status, body: b }; }, function () { return { status: res.status, body: null }; });
        });
    }
    function changeFetch(api, payload, purpose, formEl) {
      var key = purpose + '|' + payload.orderNumber;
      var have = passes[key];
      if (have && have.exp > Date.now() + 30000) payload.verifyToken = have.token;
      return postJson(api, payload).then(function (r) {
        if (!(r.status === 403 && r.body && r.body.verify === 'required')) return r;
        return getPass(purpose, payload, formEl).then(function (token) {
          if (!token) return { status: 0, body: { error: T.vCancelled } };
          passes[key] = { token: token, exp: Date.now() + 29 * 60000 };
          payload.verifyToken = token;
          return postJson(api, payload);
        });
      });
    }
    function getPass(purpose, payload, formEl) {
      var member = MEMBER_EMAIL
        ? postJson(PASS_API, { orderNumber: payload.orderNumber, purpose: purpose })
            .then(function (r) { return r.body && r.body.ok && r.body.pass ? r.body.pass : null; }, function () { return null; })
        : Promise.resolve(null);
      return member.then(function (t) { return t || codeStep(purpose, payload, formEl); });
    }
    function codeStep(purpose, payload, formEl) {
      return new Promise(function (resolve) {
        var old = formEl && formEl.querySelector('.htrk-' + S + '__verify');
        if (old) old.parentNode.removeChild(old);
        var box = document.createElement('div');
        box.className = 'htrk-' + S + '__verify';
        box.innerHTML =
          '<p class="htrk-' + S + '__detail" data-v="msg" role="status">' + esc(T.vSending) + '</p>' +
          '<label class="htrk-' + S + '__field"><span class="htrk-' + S + '__label">' + esc(T.vLabel) + '</span>' +
          '<input type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" data-v="code"></label>' +
          '<p class="htrk-' + S + '__aerr" data-v="err" role="alert"></p>' +
          '<div class="htrk-' + S + '__verify-acts">' +
          '<button type="button" class="htrk-' + S + '__abtn" data-v="ok">' + esc(T.vConfirm) + '</button>' +
          '<button type="button" class="htrk-' + S + '__verify-link" data-v="resend">' + esc(T.vResend) + '</button>' +
          '<button type="button" class="htrk-' + S + '__verify-link" data-v="cancel">' + esc(T.vCancel) + '</button></div>';
        var errLine = formEl && formEl.querySelector('[role="alert"]');
        if (errLine && errLine.parentNode) errLine.parentNode.insertBefore(box, errLine);
        else if (formEl) formEl.appendChild(box);
        else { resolve(null); return; }
        var q = function (n) { return box.querySelector('[data-v="' + n + '"]'); };
        var done = false;
        var finish = function (token) {
          if (done) return;
          done = true;
          if (box.parentNode) box.parentNode.removeChild(box);
          resolve(token);
        };
        var base = { orderNumber: payload.orderNumber, email: payload.email, purpose: purpose };
        var send = function () {
          q('err').textContent = '';
          q('msg').textContent = T.vSending;
          postJson(VERIFY_API, { orderNumber: base.orderNumber, email: base.email, purpose: purpose, action: 'send' }).then(function (r) {
            if (r.body && r.body.sent) q('msg').textContent = String(T.vSent).replace('[to]', r.body.sentTo || base.email);
            else { q('msg').textContent = ''; q('err').textContent = (r.body && r.body.error) || T.vDown; }
          }, function () { q('msg').textContent = ''; q('err').textContent = T.vDown; });
        };
        var confirm = function () {
          var code = String(q('code').value || '').replace(/\D/g, '');
          if (code.length !== 6) { q('err').textContent = T.vBadCode; return; }
          var ok = q('ok');
          ok.disabled = true; ok.textContent = T.vChecking;
          postJson(VERIFY_API, { orderNumber: base.orderNumber, email: base.email, purpose: purpose, action: 'check', code: code }).then(function (r) {
            if (r.body && r.body.ok && r.body.pass) { finish(r.body.pass); return; }
            ok.disabled = false; ok.textContent = T.vConfirm;
            q('err').textContent = (r.body && r.body.error) || T.vBadCode;
          }, function () { ok.disabled = false; ok.textContent = T.vConfirm; q('err').textContent = T.vDown; });
        };
        q('ok').addEventListener('click', confirm);
        q('resend').addEventListener('click', send);
        q('cancel').addEventListener('click', function () { finish(null); });
        // Enter confirms the code; it must never submit the form underneath.
        q('code').addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); confirm(); }
        });
        send();
        try { q('code').focus(); } catch (e) {}
        updateScrollShadows();
      });
    }

    function submitReturn(lines, giftChoice, idleLabel) {
      var errEl = afEl('rerr');
      if (errEl) errEl.textContent = '';
      var send = afEl('rsend');
      var back = afEl('rback');
      if (send) { send.disabled = true; send.textContent = T.retBusy; }
      if (back) back.disabled = true;
      var seq = addrSeq;

      function fail(text) {
        var e2 = afEl('rerr');
        var s2 = afEl('rsend');
        var b2 = afEl('rback');
        if (e2) e2.textContent = text;
        if (s2) { s2.disabled = false; s2.textContent = idleLabel; }
        if (b2) b2.disabled = false;
        focusError(e2, document);
      }

      // options: 2 = this page understands replacements and other colours; without
      // it PLM sends (and accepts) other sizes only, for the older live theme.
      var payload = { orderNumber: lastOrder, email: lastEmail, action: 'set', lines: lines, entry: lastEntry, options: 2 };
      if (giftChoice) payload.giftChoice = giftChoice;
      changeFetch(RET_API, payload, 'return', afEl('rform'))
        .then(function (r) {
          if (seq !== addrSeq) return;
          var b = r.body;
          var box = retBox();
          if (b && b.ok) {
            if (!box) return;
            var text = b.mode === 'requested' ? T.retDoneRequested : (b.labelEmailed ? T.retDoneLabel : T.retDoneNoLabel);
            var h = '<div class="htrk-' + S + '__line">';
            if (b.name) h += '<p class="htrk-' + S + '__stage">' + esc(b.resolution === 'exchange' || (b.exchange && b.exchange.length) || flow && flow.mode === 'exchange' ? T.exExisting : T.retExisting) + ' ' + esc(b.name) + '</p>';
            h += '<p class="htrk-' + S + '__aok">' + esc(text) + '</p>';
            if (b.mode === 'created' && b.resolution === 'store_credit') {
              h += '<p class="htrk-' + S + '__detail">' + esc(T.retCreditDone) + '</p>';
            } else if (b.mode === 'created' && b.fee) {
              h += '<p class="htrk-' + S + '__detail">' + esc(feeText(b.resolution === 'exchange' ? T.exFeeDone : T.retFeeDone, b.fee)) + '</p>';
            }
            if (b.exchange && b.exchange.length) {
              h += '<p class="htrk-' + S + '__detail">Exchange for ' + esc(b.exchange.join(', ')) + '. We’ll ship your new item as soon as we receive your return. Send it within 7 days to keep your new item set aside.</p>';
            }
            if (b.label && b.label.tracking) {
              h += b.label.url
                ? '<a class="htrk-' + S + '__track" href="' + esc(b.label.url) + '" target="_blank" rel="noopener">' + esc(T.retTrackBack) + ' &rarr;</a>'
                : '<p class="htrk-' + S + '__eta">' + esc(b.label.carrier || 'Carrier') + ' &middot; ' + esc(b.label.tracking) + '</p>';
            }
            h += '</div>';
            box.innerHTML = h;
            syncShipVis();
            return;
          }
          if (b && b.error) {
            if (r.status === 409) {
              // Nothing returnable any more (someone started it in the
              // meantime): the sentence replaces the form.
              if (box) { box.innerHTML = retNoteHtml('<p>' + esc(b.error) + '</p>'); syncShipVis(); }
              return;
            }
            fail(b.error);
            return;
          }
          // Not-found body: the verified pair went stale. Hide rather than argue.
          if (box) { box.innerHTML = ''; syncShipVis(); }
        })
        .catch(function () {
          if (seq !== addrSeq) return;
          fail('We could not reach our order system just now. Check your connection and try again.');
        });
    }

    // DEEP LINK FROM THE ORDER EMAILS.
    //
    // Shopify's own order-status link is a bearer token in a URL — /<shop>/orders/
    // <token>?key=... — good for exactly one order, with no login and no history.
    // We carry the same amount of authority in the same way, so a link from our
    // emails opens straight onto the order:
    //
    //   /pages/track?order=<order>&email=<email>
    //
    // With both present the lookup fires on its own and the shopper types nothing.
    // With only the order number they type the email, which is the identity check.
    //
    // THE URL IS SCRUBBED THE MOMENT IT IS READ. replaceState drops the query
    // string from the address bar and from session history, so the address does
    // not sit in the back button, get screenshotted, or ride along if the shopper
    // pastes the URL to someone. Cross-origin Referer already carries origin only
    // under the modern default policy, so the remaining exposure is the customer's
    // own inbox — the same place Shopify's token link already lives.
    var linkedOrder = null; // the order a link opened, for the "Your orders" highlight
    function showFinding() {
      if (!EMBED) outLive(true);
      out.innerHTML = '<div class="htrk-' + S + '__loading">' + (window.HakiLoader ? window.HakiLoader('Finding your order') : '<p role="status">Finding your order…</p>') + '</div>';
      reveal();
    }
    (function prefillFromLink() {
      if (EMBED) return; // the order view drives an embedded lookup itself
      var q = window.location.search;
      if (!q || q.length < 2) return;

      var got = {};
      var pairs = q.slice(1).split('&');
      for (var i = 0; i < pairs.length; i++) {
        var kv = pairs[i].split('=');
        var k = kv[0];
        if (k !== 'order' && k !== 'o' && k !== 'email' && k !== 'e') continue;
        var raw = '';
        try {
          raw = decodeURIComponent((kv[1] || '').replace(/\+/g, ' ')).trim();
        } catch (err) {
          continue; // a malformed escape must not throw and kill the whole script
        }
        // Validate before writing anything into an input: reflecting arbitrary
        // text from a URL into the page is how a link becomes a way to put words
        // on our storefront.
        if (k === 'order' || k === 'o') {
          if (/^#?[A-Za-z]{0,4}[0-9]{3,12}$/.test(raw)) got.order = raw;
        } else if (/^[^\s@<>"']{1,64}@[^\s@<>"']{1,190}\.[A-Za-z]{2,24}$/.test(raw)) {
          got.email = raw;
        }
      }

      var fromMember = !!(got.order && !got.email && MEMBER_EMAIL);
      if (fromMember) got.email = MEMBER_EMAIL;
      if (!got.order && !got.email) return;
      if (got.order) orderEl.value = got.order;
      if (got.email) emailEl.value = got.email;

      if (window.history && window.history.replaceState) {
        try {
          window.history.replaceState({}, '', window.location.pathname);
        } catch (err) {
          /* a browser that refuses is no reason to fail the lookup */
        }
      }

      if (got.order && got.email) {
        lastEntry = 'link';
        // No more "linked mode" (operator, 2026-09-29): a link from the order page
        // opens the normal track page with the answer beside the form. (is-linked
        // CSS kept, unused.)
        // A signed-in member arriving from their order page never needs the
        // form (operator, 2026-09-29): title only, their order beside it.
        if (fromMember && grid) grid.classList.add('is-member-view');
        submitLookup();
        // The link's order number + email only drive the lookup; the boxes stay
        // empty (operator, 2026-09-29), ready for "track another order".
        // submitLookup has already read them.
        orderEl.value = '';
        emailEl.value = '';
        // Shown AND revealed: the results area stays invisible until reveal(),
        // so without it a linked lookup was a blank page until the answer came
        // (operator, 2026-09-29, from the order page's "Track your order").
        linkedOrder = got.order;
        showFinding();
      } else if (got.order) {
        emailEl.focus();
      }
    })();

    // YOUR ORDERS (signed-in; operator, 2026-09-29). The order on screen is a
    // bigger card at the top of the left column; the others are compact rows
    // under the help text (desktop) or at the very bottom of the page (phones).
    // A tap looks an order up with the member's own email and makes it the
    // current one. Opened without a link, the most recent order loads.
    (function memberOrders() {
      // Light or dark ground → which green, for guests too (their "Viewing"
      // card). Reads the colour scheme itself.
      try {
        var gHost = grid && grid.parentNode;
        var gbg = window.getComputedStyle(gHost).getPropertyValue('--color-background').split(',');
        if (gbg.length >= 3 && (0.299 * gbg[0] + 0.587 * gbg[1] + 0.114 * gbg[2]) > 150) gHost.setAttribute('data-htrk-light', '');
      } catch (e) {}
      if (EMBED || !MEMBER_EMAIL) return;
      var dataEl = document.getElementById('htrk-myorders-data-' + S + '');
      var cur = document.getElementById('htrk-current-' + S + '');
      var nav = document.getElementById('htrk-myorders-' + S + '');
      var orders = [];
      try { orders = JSON.parse(dataEl.textContent) || []; } catch (e) { orders = []; }
      if (!cur || !orders.length) return;
      var host = grid && grid.parentNode;
      // Light or dark ground → which green (reads the colour scheme itself).
      try {
        var bg = window.getComputedStyle(host).getPropertyValue('--color-background').split(',');
        if (bg.length >= 3 && (0.299 * bg[0] + 0.587 * bg[1] + 0.114 * bg[2]) > 150) host.setAttribute('data-htrk-light', '');
      } catch (e) {}
      if (grid) grid.classList.add('is-member-view');
      var list = nav ? nav.querySelector('ul') : null;
      var current = null;
      function norm(n) { return String(n || '').replace(/^#/, '').replace(/\s+/g, '').toUpperCase(); }
      function find(n) { for (var i = 0; i < orders.length; i++) if (orders[i].n === norm(n)) return orders[i]; return null; }
      function meta(o, withTotal) {
        var bits = [o.date, o.items + (o.items === 1 ? ' item' : ' items')];
        if (withTotal) bits.push(o.total);
        if (o.status) bits.push(o.status);
        return bits.join(' \u00b7 ');
      }
      function render() {
        var o = find(current);
        if (o) {
          cur.innerHTML = '<h2 class="htrk-' + S + '__sechead htrk-' + S + '__cardhead">' + esc(T.currentHead) + '</h2>' +
            '<div class="htrk-' + S + '__current-card" aria-live="polite">' +
            '<p class="htrk-' + S + '__current-label">' + esc(C.my_order_viewing) + '</p>' +
            '<div class="htrk-' + S + '__current-top"><p class="htrk-' + S + '__current-name">' + esc(o.name) + '</p>' +
            '<p class="htrk-' + S + '__current-total">' + esc(o.total) + '</p></div>' +
            '<p class="htrk-' + S + '__current-meta">' + esc('Placed ' + meta(o, false)) + '</p>' +
            '<div class="htrk-' + S + '__cardacts" hidden></div></div>';
          cur.hidden = false;
          cardTotal = { n: o.n, total: o.total || '' };
          fillCardActs();
        } else {
          cur.hidden = true;
        }
        if (!list) return;
        var h = '';
        for (var i = 0; i < orders.length; i++) {
          if (o && orders[i].n === o.n) continue;
          if (!orders[i].active) continue; // active orders only
          h += '<li><button type="button" class="htrk-' + S + '__myorder" data-order="' + esc(orders[i].n) + '">' +
               '<span class="htrk-' + S + '__myorder-name">' + esc(orders[i].name) + '</span>' +
               '<span class="htrk-' + S + '__myorder-meta">' + esc(meta(orders[i], true)) + '</span></button></li>';
        }
        list.innerHTML = h;
        nav.hidden = !h;
        var bs = list.querySelectorAll('[data-order]');
        for (var k = 0; k < bs.length; k++) {
          (function (b) { b.addEventListener('click', function () { focusResult = true; open(b.getAttribute('data-order')); }); })(bs[k]);
        }
        sideOrdersHook();
      }
      // The result view's right column shows the same list (resultSideHtml).
      sideOrdersHook = function () {
        var box = out.querySelector('.htrk-' + S + '__sideorders');
        if (!box || !list) return;
        var ul = box.querySelector('ul');
        ul.innerHTML = list.innerHTML;
        box.hidden = !list.innerHTML;
        var sb = ul.querySelectorAll('[data-order]');
        for (var k = 0; k < sb.length; k++) {
          (function (b) { b.addEventListener('click', function () { focusResult = true; open(b.getAttribute('data-order')); }); })(sb[k]);
        }
      };
      refreshCurrent = function () { if (current) open(current); };
      function open(num) {
        current = norm(num);
        render();
        if (grid) grid.classList.add('is-member-view');
        orderEl.value = current;
        emailEl.value = MEMBER_EMAIL;
        lastEntry = 'account';
        submitLookup();
        orderEl.value = '';
        emailEl.value = '';
        showFinding();
        try { cur.scrollIntoView({ block: 'nearest' }); } catch (e) {}
      }
      // Phones: the other orders go to the very bottom of the page.
      if (nav && window.matchMedia) {
        var home = document.createComment('htrk-myorders');
        nav.parentNode.insertBefore(home, nav);
        var mq = window.matchMedia('(max-width: 749px)');
        var place = function () {
          if (mq.matches) { if (grid && nav.parentNode !== grid) grid.appendChild(nav); }
          else if (home.parentNode && nav.previousSibling !== home) home.parentNode.insertBefore(nav, home.nextSibling);
        };
        place();
        if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
      }
      // ACTIVE, precisely (operator, 2026-09-29: "active until 2 weeks after
      // delivery"; "lookout for RTS orders"). PLM's orders answer knows the
      // delivery day; Liquid only knows when a parcel left, so the list starts
      // from Liquid's guess and is corrected when PLM answers:
      //   cancelled / closed / old "shipped" (no scans)  → not active
      //   returned to us (RTS)                           → active (needs sorting out)
      //   delivered                                      → active for 14 days after
      //   anything still on its way / being made         → active
      try {
        fetch('' + C.proxy_base + '/orders', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            var rows = (data && data.orders) || [];
            if (!rows.length) return;
            var today = new Date();
            for (var i = 0; i < rows.length; i++) {
              var o = find(rows[i].orderNumber);
              if (!o) continue;
              var st = rows[i].stage;
              if (st === 'cancelled' || st === 'closed' || st === 'shipped') o.active = false;
              else if (st === 'returned_to_us') o.active = true;
              else if (st === 'delivered') {
                var d = rows[i].deliveredOn ? new Date(rows[i].deliveredOn + 'T12:00:00Z') : null;
                o.active = d ? (today - d) <= 14 * 86400000 : o.active;
              } else o.active = true;
            }
            render();
          })['catch'](function () {});
      } catch (e) {}
      if (linkedOrder && find(linkedOrder)) { current = norm(linkedOrder); render(); }
      else if (linkedOrder) { render(); }
      else {
        // The most recent ACTIVE order; with none active, the most recent one.
        var first = orders[0];
        for (var a = 0; a < orders.length; a++) if (orders[a].active) { first = orders[a]; break; }
        open(first.n);
      }
    })();

    // Named, so the deep-link path above can run the same lookup the form runs —
    // one code path, not a second copy that drifts.
    //
    // THE TWO REQUESTS TRAVEL TOGETHER. The eligibility question used to be
    // asked only after the lookup answered, so the shopper watched the items
    // render and then the shipping column pop in seconds later. Now both fire
    // the moment the form is submitted, with the same credentials, and the
    // results render in ONE paint: the page holds until both answers are in,
    // but never waits more than ADDR_GRACE_MS past the lookup answering — a
    // slow or dead address endpoint must not hold the tracking answer hostage.
    // Past the cap the results render without the shipping card and the card
    // appears if and when the answer lands, under the same silent-degrade
    // rules as ever. One sequence number covers BOTH in-flight requests, so a
    // back-to-back lookup invalidates the pair together.
    var ADDR_GRACE_MS = 2500;

    function submitLookup() {
      var orderNumber = (orderEl.value || '').trim();
      var email = (emailEl.value || '').trim();
      if (!orderNumber || !email) {
        message('We need both your order number and the email you used at checkout.', true);
        return;
      }

      btn.disabled = true;
      btn.textContent = BUSY;
      out.classList.remove('is-in');
      out.innerHTML = '';
      cardRet = null;
      cardCancel = false;
      cardRefund = '';
      cancelSeq++;
      fillCardActs();
      // The monogram loader while we look (operator, 2026-09-29: a second
      // lookup left the results side black). Not in the order-page pop-up,
      // which has its own loader.
      if (!EMBED) showFinding();

      addrSeq += 1;
      var seq = addrSeq;

      var addrBody = null;     // the eligibility answer, once it lands
      var addrLanded = false;
      var retBody = null;      // the returns answer, once it lands
      var retLanded = false;
      var lookupR = null;      // { status, body } | { netfail: true }
      var painted = false;
      var graceTimer = null;

      // One render for everything the shopper sees, success or failure. Runs
      // exactly once per lookup; a newer lookup makes it a no-op.
      function paint() {
        if (painted || seq !== addrSeq) return;
        painted = true;
        if (grid && grid.parentNode) grid.parentNode.classList.remove('is-loading');
        if (graceTimer) { clearTimeout(graceTimer); graceTimer = null; }

        if (lookupR && !lookupR.netfail && lookupR.body && lookupR.body.found) {
          // This pair just proved itself against PLM; it is what the address
          // editor authenticates with from here on.
          lastOrder = orderNumber;
          lastEmail = email;
          renderFound(lookupR.body);
          showNudge();
          checkOrderCancel(orderNumber, 0);
          // Same synchronous turn as renderFound: the address card is part of
          // the first frame whenever its answer arrived in time.
          if (addrLanded) applyAddrAnswer(addrBody);
          // Same for the returns section: part of the first frame when its
          // answer arrived in time, otherwise it appears when it lands.
          if (retLanded && retBody) applyRetAnswer(retBody);
          if (grid && grid.classList.contains('is-linked') && !EMBED) {
            out.insertAdjacentHTML('afterbegin', '<button type="button" class="htrk-' + S + '__another" id="htrk-another-' + S + '">' + esc(T.another) + '</button>');
            var another = document.getElementById('htrk-another-' + S + '');
            if (another) another.addEventListener('click', function () {
              grid.classList.remove('is-linked');
              another.parentNode.removeChild(another);
              try { window.scrollTo(0, 0); } catch (e) {}
              orderEl.focus();
            });
          }
        } else if (lookupR && lookupR.netfail) {
          // A network failure must never render as "no order found" — that
          // would tell someone their order does not exist because their wifi
          // dropped.
          message('We could not reach our order system just now. Check your connection and try again.', true);
        } else {
          // Everything else — not found, wrong email, rate limited, bad input —
          // already arrives as a sentence written for a shopper. Show it as
          // sent rather than inventing our own wording on top of it.
          message(
            (lookupR && lookupR.body && lookupR.body.message) ||
              'We could not look that up just now. Try again shortly, or get in touch and we will find it for you.',
            lookupR ? (lookupR.status >= 500 || lookupR.status === 429) : true
          );
        }
        btn.disabled = false;
        btn.textContent = IDLE;
        // Found or not, the answer is below the form on a phone.
        scrollToResults();
      }

      // The eligibility question, in flight alongside the lookup.
      window.HakiTrackPost(ADDR_API, { orderNumber: orderNumber, email: email, action: 'get', entry: lastEntry })
        .then(function (r) { return r.body; })
        .then(function (body) {
          if (seq !== addrSeq) return; // a newer lookup superseded this pair
          addrLanded = true;
          addrBody = body;
          if (painted) applyAddrAnswer(addrBody); // late arrival: card appears now
          else if (lookupR && retLanded) paint(); // lookup was only waiting on us
          // lookup still in flight: hold the answer; paint fires on the lookup.
        })
        .catch(function () {
          if (seq !== addrSeq) return;
          addrLanded = true;
          addrBody = null; // degrade invisibly; never block the results
          if (!painted && lookupR && retLanded) paint();
        });

      // The returns question, in flight alongside both of the above, under
      // the same grace window: it must never hold the tracking answer.
      loadReturns(orderNumber, email, seq, function (body) {
        retLanded = true;
        retBody = body;
        if (painted) { if (body) applyRetAnswer(body); }
        else if (lookupR && addrLanded) paint();
      });

      window.HakiTrackPost(API, { orderNumber: orderNumber, email: email, entry: lastEntry })
        .then(function (r) {
          if (seq !== addrSeq) return;
          lookupR = r;
          // Only a found order has a shipping column worth waiting for.
          if (!(r.body && r.body.found) || (addrLanded && retLanded)) { paint(); return; }
          graceTimer = setTimeout(paint, ADDR_GRACE_MS);
        })
        .catch(function () {
          if (seq !== addrSeq) return;
          lookupR = { netfail: true };
          paint();
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      lastEntry = 'typed';
      focusResult = true;
      submitLookup();
    });

    // The order view's handle on an embedded instance. Re-running the lookup on
    // every open is deliberate: eligibility (still changeable? still inside the
    // return window?) is PLM's answer at the moment of asking, never a cached one.
    if (EMBED) {
      // How long a pre-loaded returns answer counts as current. PLM checks the
      // return again when it is submitted, so this is only about what the
      // panel SHOWS; a couple of minutes is well inside "the moment of asking".
      var PREFETCH_FRESH_MS = 120000;
      var host = grid.parentNode;
      var bd = null, xBtn = null, lastFocus = null, homeMark = null;
      // KEYBOARD + SCREEN READERS (a11y review on PR #345): the pop-up had
      // role=dialog but no name (a screen reader heard only "dialog, Close")
      // and only Esc was handled, so Tab walked out into the page behind it.
      // Tab / Shift+Tab now cycle inside it. The list of focusable things is
      // read at each key press, not once on open: the pop-up opens on a
      // loader and its contents are painted (and re-painted) afterwards, so a
      // list taken on open (global.js trapFocus) would go stale.
      // Tab / Shift+Tab cycle inside it (trapTab, top of this file).
      function onKey(e) {
        if (e.key === 'Escape') { closeModal(); return; }
        trapTab(e, host);
      }
      // The pop-up's name is the visible heading of the flow it shows:
      // "Return" / "Exchange" (the returns heading) or the shipping heading
      // for the address editor. aria-label carries the same words for the
      // moment before that heading is painted (the loader).
      function nameModal() {
        var f = host.getAttribute('data-htrk-focus');
        var mode = flow ? flow.mode : askedMode;
        var txt = f === 'address' ? T.shipSection : mode === 'exchange' ? T.retHeadExchange : T.retHeadReturn;
        host.setAttribute('aria-labelledby', f === 'address' ? 'htrk-shiphead-' + S : 'htrk-rethead-' + S);
        if (txt) host.setAttribute('aria-label', txt);
      }
      nameModalHook = function () { if (host.classList.contains('is-modal')) nameModal(); };
      function openModal() {
        if (!bd) {
          bd = document.createElement('div');
          bd.className = 'htrk-bd-' + S + '';
          bd.hidden = true;
          bd.addEventListener('click', closeModal);
          document.body.appendChild(bd);
          xBtn = document.createElement('button');
          xBtn.type = 'button';
          xBtn.className = 'htrk-' + S + '__x';
          xBtn.setAttribute('aria-label', 'Close');
          xBtn.innerHTML = '<svg viewBox="0 0 12 12" width="14" height="14" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
          xBtn.addEventListener('click', closeModal);
          host.insertBefore(xBtn, host.firstChild);
          host.setAttribute('role', 'dialog');
          host.setAttribute('aria-modal', 'true');
          var ld = document.createElement('div');
          ld.className = 'htrk-' + S + '__ld';
          ld.innerHTML = window.HakiLoader ? window.HakiLoader('') : '<p>Loading\u2026</p>';
          host.insertBefore(ld, xBtn.nextSibling);
        }
        lastFocus = document.activeElement;
        // OUT OF THE PAGE WHILE OPEN (2026-09-26, live bug: the whole page and
        // the pop-up greyed out; its top and bottom cut off). Inside its
        // Shopify section wrapper the pop-up sat in that wrapper's stacking
        // context (under the body-level backdrop) and any ancestor transform
        // made position:fixed relative to the wrapper, not the screen. So it
        // moves to <body> while open, and back to its spot on close.
        if (!homeMark) {
          homeMark = document.createComment('htrk-home');
          host.parentNode.insertBefore(homeMark, host);
        }
        if (host.parentNode !== document.body) document.body.appendChild(host);
        host.classList.add('is-modal');
        host.hidden = false;
        host.scrollTop = 0;
        bd.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        nameModal();
        document.addEventListener('keydown', onKey);
        try { xBtn.focus({ preventScroll: true }); } catch (e) { xBtn.focus(); }
      }
      // Set when the pop-up was opened straight into Return / Exchange.
      var directFlow = false;
      flowCancelHook = function () { if (directFlow && host.classList.contains('is-modal')) closeModal(); };
      function closeModal() {
        directFlow = false;
        host.classList.remove('is-modal', 'is-loading');
        host.hidden = true;
        if (homeMark && homeMark.parentNode) homeMark.parentNode.insertBefore(host, homeMark.nextSibling);
        if (bd) bd.hidden = true;
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        // Back to the opener. From a deep link (no opener) or after the order
        // page re-painted it: the order's own button for the same action,
        // else the order heading (sections/haki-order.liquid).
        var mode = host.getAttribute('data-htrk-focus') === 'address' ? 'address' : (flow ? flow.mode : askedMode);
        var acts = mode === 'address' ? ['address'] : mode === 'exchange' ? ['exchange', 'return'] : ['return', 'exchange'];
        var sels = [];
        for (var i = 0; i < acts.length; i++) sels.push('[data-hord-act="' + acts[i] + '"]');
        sels.push('[data-hord-title]');
        focusQuietly(focusBackTarget(lastFocus, document, sels));
        lastFocus = null;
      }
      window.HakiTrack = {
        // THE PANEL WAS SLOW TO OPEN (operator, 2026-09-25): tapping Return
        // started three PLM calls and showed nothing until they landed. The
        // order view now calls this on load, while the panel is still hidden,
        // so by the time someone taps Return the answer is usually already here.
        prefetch: function (orderNumber, email) {
          if (!orderNumber || !email) return;
          orderEl.value = orderNumber;
          emailEl.value = email;
          pendingFocus = null;
          lastEntry = 'account';
          submitLookup();
        },
        open: function (orderNumber, email, focus) {
          var want = String(orderNumber || '').trim().toUpperCase();
          askedMode = focus === 'return' || focus === 'exchange' ? focus : null;
          setRetHead();
          if ((focus === 'return' || focus === 'exchange') && lastRet && lastRet.order === want &&
              Date.now() - lastRet.at < PREFETCH_FRESH_MS) {
            // Pre-loaded: show it now, and apply Return / Exchange to the
            // answer we already have.
            grid.parentNode.setAttribute('data-htrk-focus', 'returns');
            openModal();
            directFlow = true;
            host.classList.remove('is-loading');
            pendingFocus = focus;
            applyRetAnswer(lastRet.body);
            return;
          }
          orderEl.value = orderNumber || '';
          emailEl.value = email || '';
          pendingFocus = focus || null;
          // One flow at a time: the address editor OR returns, whichever was asked for.
          grid.parentNode.setAttribute('data-htrk-focus', focus === 'address' ? 'address' : 'returns');
          openModal();
          directFlow = focus === 'return' || focus === 'exchange' || focus === 'address';
          host.classList.add('is-loading');
          lastEntry = 'account';
          submitLookup();
        }
      };
      try { document.dispatchEvent(new CustomEvent('haki:track-ready')); } catch (e) {}
    }
  })();

  }
  var q = window.HakiTrackQueue || [];
  window.HakiTrackQueue = { push: run };
  for (var i = 0; i < q.length; i++) run(q[i]);
})();
